import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51cd2852"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = ["href"]
const _hoisted_24 = ["src"]
const _hoisted_25 = ["href"]
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = ["src"]
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = ["src"]
const _hoisted_44 = ["src"]
const _hoisted_45 = ["src"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = ["src"]
const _hoisted_48 = ["src"]
const _hoisted_49 = ["src"]
const _hoisted_50 = ["src"]
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = ["src"]
const _hoisted_55 = ["src"]
const _hoisted_56 = ["src"]
const _hoisted_57 = ["src"]
const _hoisted_58 = ["src"]
const _hoisted_59 = ["src"]
const _hoisted_60 = ["src"]
const _hoisted_61 = ["src"]
const _hoisted_62 = ["src"]
const _hoisted_63 = ["src"]
const _hoisted_64 = ["src"]
const _hoisted_65 = ["src"]
const _hoisted_66 = ["src"]
const _hoisted_67 = ["src"]
const _hoisted_68 = ["src"]
const _hoisted_69 = ["src"]
const _hoisted_70 = ["src"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_72 = ["src"]
const _hoisted_73 = ["src"]
const _hoisted_74 = ["src"]
const _hoisted_75 = ["src"]
const _hoisted_76 = ["src"]
const _hoisted_77 = ["src"]
const _hoisted_78 = ["src"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = ["src"]
const _hoisted_81 = ["src"]
const _hoisted_82 = ["src"]
const _hoisted_83 = ["src"]
const _hoisted_84 = ["src"]
const _hoisted_85 = ["src"]
const _hoisted_86 = ["src"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_89 = ["href"]
const _hoisted_90 = ["src"]
const _hoisted_91 = ["href"]
const _hoisted_92 = ["src"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_101 = {
  id: "map",
  class: "map",
  style: {
              'background-position': 'right 100%',
              'background-size': 'auto 100%',
            }
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "captureFrameContainer" }, null, -1))
const _hoisted_103 = { id: "mapSelector" }
const _hoisted_104 = ["src"]
const _hoisted_105 = { id: "mapSelectorSection" }
const _hoisted_106 = ["src"]
const _hoisted_107 = ["src"]
const _hoisted_108 = ["src"]
const _hoisted_109 = ["src"]
const _hoisted_110 = ["value"]

import { ref, onMounted, Ref, watch } from "vue";
import {
  WholeContent,
  HeaderContent,
  MainContent,
  DataViewerContent,
  SideMenu,
  SideMenuItem,
  SideMenuInnerItem,
  SideMenuSubItem,
  ToolHeader,
  ToolHeaderButtonItem,
  ToolHeaderSearch,
  ToolHeaderButtonDropdown,
  ToolFooter,
  FormUnit,
  FormUnitRow,
  FormUnitCell,
  InputField,
  SelectItem,
  ButtonSubmit,
  PopupWindow,
  ButtonContainer,
  ButtonItem,
  RadioItem,
  CheckboxItem,
  OverlayContent,
  HelpTable,
  TimeController,
  RealTimePlayer,
  DispMenuButton,
  HeadingBox,
  LoadingContent,
  AddressTable,
  Tooltip,
  ToggleButton,
} from "@/components/modules";
import { LayerName } from "@/geoMap/LayerName";
import { GeoMap } from "@/geoMap/GeoMap";
import stdMapIcon from "@/../public/icon/map/StdMapTile.png";
import paleMapIcon from "@/../public/icon/map/PaleMapTile.png";
import blankMapIcon from "@/../public/icon/map/BlankMapTile.png";
import seamlessPhotoMapIcon from "@/../public/icon/map/SeamlessphotoMapTile.png";
import QuestionIcon from "@/../public/icon/dialog/info.png";
import DownloadIcon from "@/../public/icon/index/icon-tool-btn-09.png";
import RoadtypeLogisticsLayerIcon from "@/../public/icon/layer/roadtype-logistics.png";
import RoadtypeAlternativeLayerIcon from "@/../public/icon/layer/roadtype-alternative.png";
import BridgesLayerIcon from "@/../public/icon/layer/structures-bridges.png";
import TunnelsLayerIcon from "@/../public/icon/layer/structures-tunnels.png";
import ShedsLayerIcon from "@/../public/icon/layer/structures-sheds.png";
import CulvertsLayerIcon from "@/../public/icon/layer/structures-culverts.png";
import PedestrianDecksLayerIcon from "@/../public/icon/layer/structures-pedestrian_decks.png";
import OverheadSignagesLayerIcon from "@/../public/icon/layer/structures-overhead_signages.png";
import PavementsLayerIcon from "@/../public/icon/layer/structures-pavements.png";
import EarthworksLayerIcon from "@/../public/icon/layer/structures-earthworks.png";
import accidentHotspotDeathIcon from "@/../public/icon/layer/accident-hotspot-death.png";
import accidentHotspotInjuryIcon from "@/../public/icon/layer/accident-hotspot-injury.png";
import loadkillWarningSignLayerIcon from "@/../public/icon/layer/point_roadkill_cm_warning_sign.png";
import loadkillSignboardLayerIcon from "@/../public/icon/layer/point_roadkill_cm_signboard.png";
import loadkillRoadMarkingLayerIcon from "@/../public/icon/layer/point_roadkill_cm_road_marking.png";
import loadkillInformationBoardLayerIcon from "@/../public/icon/layer/point_roadkill_cm_information_board.png";
import loadkillUnderpassLayerIcon from "@/../public/icon/layer/point_roadkill_cm_underpass.png";
import loadkillPortableSignLayerIcon from "@/../public/icon/layer/point_roadkill_cm_portable_sign.png";
import loadkillOtherLayerIcon from "@/../public/icon/layer/roadkill_cm_other.png";
import loadkillFenceLayerIcon from "@/../public/icon/layer/line_roadkill_cm_fence.png";
import majorTrafficCongestionLayerIcon from "@/../public/icon/layer/major_traffic_congestion.png";
import specificSituationExamptIcon from "@/../public/icon/layer/specific-situation_special-vehicle_exampt.png";
import specificSituationGuidanceIcon from "@/../public/icon/layer/specific-situation_special-vehicle_vehicle_guidance.png";
import specificSituationXpointIcon from "@/../public/icon/layer/specific-situation_special-vehicle_xpoint.png";
import CalcArea from "@/components/pages/util/calc-area.vue";
import CaptureDisplay from "@/components/pages/util/capture-display.vue";
import SimpleSearch from "@/components/pages/util/simple-search.vue";
import RealtimeAttribute from "@/components/pages/attribute/realtime-attribute.vue";
import HistoryAttribute from "@/components/pages/attribute/history-attribute.vue";
import NormalAttribute from "@/components/pages/attribute/normal-attribute.vue";
import ImageAttribute from "@/components/pages/attribute/image-attribute.vue";
import RealTimeTraffic from "@/components/pages/attribute/realtime-traffic.vue";
import ExportArea from "@/components/pages/util/export-area.vue";
import ExportBulk from "@/components/pages/util/export-bulk.vue";
import LegendList from "@/components/pages/util/legend-list.vue";
import TermsCondition from "@/components/pages/util/terms-condition.vue";
import {
  checkImportOptionFile,
  createExportOptionFile,
} from "@/components/pages/util/optionFIleHelper";
import { SelectedFeatureInfo } from "@/geoMap/SelectedFeatureInfo";
import { IAttributeConvert } from "@/attribute/convert/IAttributeConvert";
import { IAttributeImageConvert } from "@/attribute/convert/IAttributeImageConvert";
import { ISearchDateAttributeConvert } from "@/attribute/convert/ISearchDateAttributeConvert";
import { AttributeType } from "@/geoMap/define/AttributeType";
import MessageDialog from "../common/message-dialog.vue";
import { CommonView } from "../common/CommonView";
import { MessageDefine } from "@/components/pages/common/MessageDefine";
import { ICommonView } from "../common/ICommonView";
import { GeocodeAccessor } from "@/geoMap/GeocodeAccessor";
import { IRealTimeTrafficConvert } from "@/attribute/convert/IRealTimeTrafficConvert";
import {
  HanteiKubun,
  KanrishaKubun,
  SochiJoukyou,
} from "@/geoMap/layerFactory/AbstractRoadStructuresLayerFactory";
import { ODQuantityLayerName } from "@/geoMap/layerFactory/ODQuantityLayerName";
import { CarType, ODDataType } from "@/geoMap/layerFactory/IODLayerName";
import { ODSumDeparturesArrivalsLayerName } from "@/geoMap/layerFactory/ODSumDeparturesArrivalsLayerName";
import { ODZoneLayerName } from "@/geoMap/layerFactory/ODZoneLayerName";
import {
  TraVosLayerName,
  TraVosRoadType,
} from "@/geoMap/layerFactory/TraVosLayerName";
import {
  ETCLayerName,
  ETCLayerType,
  ETCTimeType,
} from "@/geoMap/layerFactory/ETCLayerName";
import {
  DayType,
  ETCLayerNameMonth,
} from "@/geoMap/layerFactory/ETCLayerNameMonth";
import { GeocodeResult } from "@/geoMap/GeocodeResult";
import { AttributeValue } from "@/attribute/convert/AttributeValue";
import { RoadAttributeName } from "@/geoMap/layerFactory/RoadAttributeLayerFactory";
import { ExportUtil } from "@/attribute/convert/util/ExportUtil";
import { ITraVosPlayEvent } from "@/geoMap/layerFactory/ITraVosPlayEvent";
import { ServerError } from "@/geoMap/define/ServerError";
import { IOdDisplayEvent } from "@/geoMap/layerFactory/IOdDisplayEvent";
import { Message } from "../common/Message";
import { Feature } from "ol";
import { ODNodeAttributeConvert } from "@/attribute/convert/ODNodeAttributeConvert";
import {
  dayTypeList,
  simpleSearchDataTypeList,
} from "../util/simpleSearchDataTypeList";
import {
  FeatureType,
  getFeatureTypeListByRootLayerType,
  getExportableFeatureType,
} from "@/geoMap/define/FeatureType";
import { RootLayerType } from "@/geoMap/define/RootLayerType";
import { RoadkillLayerName } from "@/geoMap/layerFactory/RoadkillLayerName";
import {
  RADIO_TRAVOS_LIST,
  RADIO_TRAVOS_HISTORY_LIST,
  RADIO_GENERAL_TRAFFIC_TABLE_TYPE_LIST,
  GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST,
  GENERAL_TRAFFIC_ROAD_CATEGORY_LIST,
  RADIO_ETC_DATA_TYPE_LIST,
  RADIO_ETC_TIME_TYPE_LIST,
  UPDATE_BUFFER_5MINUTES,
  UPDATE_BUFFER_1HOUR,
  IControlerDate,
  RADIO_TRAVOS_REALTIME_LIST,
  RADIO_ETC_DAY_TYPE_LIST,
  OD_DATA_TYPE_LIST,
  RADIO_OD_DATA_TYPE_LIST,
  OD_CAR_TYPE_LIST,
  RADIO_OD_CAR_TYPE_LIST,
  OD_YEAR_LIST,
  RADIO_OD_YEAR_LIST,
  OD_GENERATION_PURPOSE_LIST,
  RADIO_OD_GENERATION_PURPOSE_LIST,
  OD_TARGET_LIST,
  RADIO_OD_TARGET_LIST,
  RADIO_DRM_ROAD_TYPE_LIST,
  dateRange,
  dateRanges,
} from "@/components/define/defineType";
import { Geometry } from "ol/geom";
import { ISideMenuState } from "../util/ISideMenuState";
import { GeneralTrafficLayerName } from "@/geoMap/layerFactory/GeneralTrafficLayerName";

/**
 * 約款同意フラグ
 */
const MAX_ATTRIBUTE = 5;

/**
 * 一般交通量調査データ箇所別基本表データ種別ラジオボタン
 */
// const RADIO_GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST = [
//   {
//     text: "道路種別",
//     value: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST.roadCategory,
//   },
//   { text: "車線数", value: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST.laneCount },
//   {
//     text: "昼間12時間交通量（全車・上下計）",
//     value: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST.day12hVolume,
//   },
//   {
//     text: "24時間交通量（全車・上下計）",
//     value: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST.day24hVolume,
//   },
//   {
//     text: "混雑度",
//     value: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST.congestionLevel,
//   },
//   {
//     text: "朝夕旅行速度",
//     value: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST.morningEveningSpeed,
//   },
//   {
//     text: "昼間旅行速度",
//     value: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST.daytimeSpeed,
//   },
// ];


export default /*#__PURE__*/_defineComponent({
  __name: 'index-page',
  setup(__props) {

const termsConfirmed = ref(false);

/**
 * 地図
 */
const _geoMap = ref(new GeoMap("map"));

/**
 * 表示中地図レイヤ
 */
const visibleMapLayer = ref(LayerName.StdMapTile);

/**
 * 表示中地図画像URL
 */
const selectorImageSource = ref(stdMapIcon);

/**
 * セレクタ開閉状態
 */
const isDispMapSelector = ref(false);

/**
 * メニュー類表示状態
 */
const isDispMenu = ref(true);

/**
 * 基本地図スタイル
 */
const baseMapStyle = ref({ width: "", height: "" });

/**
 * 基本フッタスタイル
 */
const baseFooterHeight = ref("");

/**
 * 地図・属性時間コード
 */
const mapTimeCode = ref("");

/**
 * 属性時間コード
 */
const attributeTimeCode = ref("");

/**
 * 画面共通処理
 */
const commonView = ref(new CommonView());

/**
 * メッセージタイトル
 */
const messageTitle = ref(null);

/**
 * データダウンロードロップダウンメニュー
 */
const dataDownloadItems = [
  {
    label: "市区町村属性出力",
    clickEvent: () => {
      handleExportArea();
    },
  },
  {
    label: "表示中属性一括出力",
    clickEvent: () => {
      floatToggle(floatState.exportBulk.key, true);
    },
  },
];

/**
 * 地図座標
 */
const footerInfo = ref({ latitude: "0", longitude: "0", zoomLevel: 0 });

/**
 * 住所入力値
 */
const inputAddress = ref("");

/**
 * 住所検索結果
 */
const addressList: Ref<Array<GeocodeResult>> = ref([]);

/**
 * 住所検索クラス
 */
const geoCodeAccessor = ref(new GeocodeAccessor());

/**
 * 地図レイヤ切替セクション開閉
 */
const changeDispMapSelector = (isDisp: boolean) => {
  isDispMapSelector.value = isDisp;
};

let exportFileDate: null | string = null;

/**
 * 約款同意watch
 */
watch(
  () => termsConfirmed.value,
  async () => {
    if (termsConfirmed.value) {
      await initialize();
    }
  }
);

/**
 * 住所検索
 */
const searchAddress = async () => {
  if (!inputAddress.value) {
    commonView.value._messageLogic.onOpenMessage(
      MessageDefine.W0001.getMessage(["住所情報"])
    );
    return;
  }
  let geocodeResultList: GeocodeResult[];
  try {
    geocodeResultList = await geoCodeAccessor.value.search(inputAddress.value);
  } catch (e) {
    if (e instanceof ServerError) {
      commonView.value._messageLogic.onOpenMessage(
        MessageDefine.E0001.getMessage([e._url, e._status])
      );
    } else {
      commonView.value._messageLogic.onOpenMessage(
        MessageDefine.E0002.getMessage([e])
      );
    }
    return;
  }
  addressList.value = geocodeResultList;
  if (!floatState.住所 && !floatState.address.opened.value) {
    floatToggle(floatState.address.key, true);
  }
};

/**
 * 属性詳細ウィンドウ用リスト
 */
const attributeList: Ref<
  Array<{
    fid: string;
    isOpen: boolean;
    attributeConvert: IAttributeConvert;
  }>
> = ref([]);

/**
 * リアルタイム属性詳細ウィンドウ用リスト
 */
const realtimeAttributeList: Ref<
  Array<{
    fid: string;
    searchDateAttributeConvert: ISearchDateAttributeConvert;
    isOpen: boolean;
    refs?: any;
  }>
> = ref([]);

/**
 * リアルタイム処理
 */
let realTimeInterval: any;

/**
 * 過去属性詳細ウィンドウ用リスト
 */
const historyAttributeList: Ref<
  Array<{
    fid: string;
    searchDateAttributeConvert: ISearchDateAttributeConvert;
    compareHistoryAttributeConvert?: ISearchDateAttributeConvert;
    isOpen: boolean;
    refs?: any;
  }>
> = ref([]);

/**
 * 静止画属性詳細ウィンドウ用リスト
 */
const imageAttributeList: Ref<
  Array<{
    fid: string;
    isOpen: boolean;
    attributeConvert: IAttributeImageConvert;
  }>
> = ref([]);

/**
 * リアルタイム交通量
 */
const realTimeTrafficData: Ref<{
  fid?: string;
  title?: string;
  realTimeTrafficConvert?: IRealTimeTrafficConvert;
}> = ref(null);

/**
 * 最新データ時間コード（交通量画面）
 */
const realTimeTimeCodeTraffic = ref(null);

/**
 * 最新データ時間コード（5分値）
 */
const realTimeTimeCode5Minutes = ref(null);

/**
 * 最新データ時間コード（1時間値）
 */
const realTimeTimeCode1Hour = ref(null);

/**
 * 属性画面最大数
 */
const helpFiles = ref([]);

const LEGEND_FILE_PATH = {
  TRAVOS_HISTORY_Q_8_2: "legend/TraVos_過去_計測1時間（Q-8-2)_凡例.pdf",
  TRAVOS_HISTORY_QA_8_2: "legend/TraVos_過去_計測1時間（QA-8-2)_凡例.pdf",
  TRAVOS_REALTIME_Q_8_1: "legend/TraVos_最新_計測5分（Q-8-1)_凡例.pdf",
  TRAVOS_REALTIME_QA_8_1: "legend/TraVos_最新_計測5分（QA-8-1)_凡例.pdf",
  TRAVOS_REALTIME_Q_8_2: "legend/TraVos_最新_計測1時間（Q-8-2)_凡例.pdf",
  TRAVOS_REALTIME_QA_8_2: "legend/TraVos_最新_計測1時間（QA-8-2)_凡例.pdf",
  ETC_DRM_LINK: "legend/ETC2.0_DRMリンク(2-2, 2-3, 2-4)_凡例.pdf",
  ETC_BASIC_SECTION: "legend/ETC2.0_交通調査基本区間(2-5, 2-6, 2-7)_凡例.pdf",
  DRM_BASIC_ROAD: "legend/DRM-DB_基本道路_凡例.pdf",
  DRM_ALL_ROAD: "legend/DRM-DB_全道路_凡例.pdf",
};

const LEGEND_FILE_PATH_LIST = {
  od: {
    od: [
      {
        value: OD_DATA_TYPE_LIST.prefectures,
        path: "legend/OD_OD交通量_都道府県_凡例.pdf",
      },
    ],
    generation: [
      {
        value: OD_DATA_TYPE_LIST.prefectures,
        path: "legend/OD_発生集中交通量_都道府県_凡例.pdf",
      },
    ],
  },
};

/**
 * 左メニュー状態
 */
const sideMenuState: Ref<ISideMenuState> = ref({
  travos: {
    value: true,
    type: RADIO_TRAVOS_LIST.realTime,
    history: {
      timeType: RADIO_TRAVOS_HISTORY_LIST.measured1Hour,
      measured1Hour: {
        q82: true,
        qa82: true,
      },
      generalHighway: true,
      expressway: true,
    },
    realTime: {
      timeType: RADIO_TRAVOS_REALTIME_LIST.value5Minutes,
      value5Minutes: {
        q81: true,
        qa81: true,
      },
      value1Hour: {
        q82: true,
        qa82: true,
      },
      generalHighway: true,
      expressway: true,
    },
  },
  generalTraffic: {
    value: false,
    tableType: RADIO_GENERAL_TRAFFIC_TABLE_TYPE_LIST.location,
    location: {
      dataType: GENERAL_TRAFFIC_LOCTAION_DATA_TYPE_LIST.roadCategory,
      roadCategory: {
        generalPrefectures: true,
        mainLocalRoad: true,
        generalHighwayDirectControl: true,
        generalHighwayOthers: true,
        urbanHighway: true,
        expressNationalHighway: true,
      },
    },
    time: {
      specificationTime: "7",
      roadCategory: {
        generalPrefectures: true,
        mainLocalRoad: true,
        generalHighwayDirectControl: true,
        generalHighwayOthers: true,
        urbanHighway: true,
        expressNationalHighway: true,
      },
    },
  },
  etc: {
    value: false,
    dataType: RADIO_ETC_DATA_TYPE_LIST.drmLink,
    timeType: RADIO_ETC_TIME_TYPE_LIST.day15Minutes,
    expressNationalHighway: true,
    urbanHighway: true,
    generalHighway: true,
    mainLocalRoadPrefectures: true,
    mainLocalRoadDesinatedCity: true,
    generalPrefectures: true,
    generalDesinatedCity: true,
    dayType: RADIO_ETC_DAY_TYPE_LIST.weekday,
  },
  od: {
    value: false,
    od: {
      value: true,
      dataType: OD_DATA_TYPE_LIST.prefectures,
      carType: OD_CAR_TYPE_LIST.passengerCar,
      year: OD_YEAR_LIST.reiwa3,
      limitMax: "",
      tmpLimitMax: "",
      limitMin: "",
      tmpLimitMin: "",
    },
    generation: {
      value: false,
      dataType: OD_DATA_TYPE_LIST.prefectures,
      carType: OD_CAR_TYPE_LIST.total,
      year: OD_YEAR_LIST.reiwa3,
      purpose: OD_GENERATION_PURPOSE_LIST.purposeTotal,
      target: OD_TARGET_LIST.generated,
    },
    zone: {
      value: false,
      dataType: OD_DATA_TYPE_LIST.prefectures,
      year: OD_YEAR_LIST.reiwa3,
    },
  },
  drm: {
    value: false,
    roadType: RADIO_DRM_ROAD_TYPE_LIST.basicRoad,
    node: true,
    link: true,
  },
  roadStructures: {
    value: false,
    facilityType: {
      bridges: true,
      tunnels: false,
      sheds: false,
      culverts: false,
      pedestrianDecks: false,
      overheadSignages: false,
      pavements: false,
      earthworks: false,
    },
    adminType: {
      country: { checked: true, code: "1" },
      prefectures: { checked: true, code: "2" },
      roadPublic: { checked: true, code: "3" },
      orderedCity: { checked: true, code: "4" },
      municipalities: { checked: true, code: "5" },
      expressway: { checked: true, code: "6" },
    },
    soundness: {
      one: { checked: true, code: "1" },
      two: { checked: true, code: "2" },
      three: { checked: true, code: "3" },
      four: { checked: true, code: "4" },
      notInspected: { checked: true, code: "8" },
    },
    measures: {
      unnecessary: { checked: true, code: "0" },
      notStarted: { checked: true, code: "1" },
      started: { checked: true, code: "2" },
      completed: { checked: true, code: "3" },
      notInspected: { checked: true, code: "8" },
    },
  },
  accidentHotspot: {
    value: false,
    year: {},
    accidentDetails: {
      death: { checked: true, code: "1" },
      injury: { checked: true, code: "2" },
    },
    accidentType: {
      peopleVehicles: { checked: true, code: "01" },
      vehicleMutual: { checked: true, code: "21" },
      vehicleAlone: { checked: true, code: "41" },
      train: { checked: true, code: "61" },
    },
    partyTypeA: {
      pedestrian: { checked: true, code: ["61", "71", "72"] },
      bicycle: { checked: true, code: ["51", "52"] },
      motorcycle: { checked: true, code: ["31", "32", "33", "34", "35", "36"] },
      car: {
        checked: true,
        code: [
          "01",
          "02",
          "07",
          "03",
          "04",
          "05",
          "11",
          "12",
          "17",
          "13",
          "14",
          "21",
          "22",
          "23",
          "24",
        ],
      },
      others: { checked: true, code: ["41", "42", "59", "75", "76", "00"] },
    },
    partyTypeB: {
      pedestrian: { checked: true, code: ["61", "71", "72"] },
      bicycle: { checked: true, code: ["51", "52"] },
      motorcycle: { checked: true, code: ["31", "32", "33", "34", "35", "36"] },
      car: {
        checked: true,
        code: [
          "01",
          "02",
          "07",
          "03",
          "04",
          "05",
          "11",
          "12",
          "17",
          "13",
          "14",
          "21",
          "22",
          "23",
          "24",
        ],
      },
      others: { checked: true, code: ["41", "42", "59", "75", "76", "00"] },
    },
    ageA: {
      from0To24: { checked: true, code: ["01"] },
      from25To64: { checked: true, code: ["25", "35", "45", "55"] },
      over65: { checked: true, code: ["65", "75"] },
      unknown: { checked: true, code: ["00"] },
    },
    ageB: {
      from0To24: { checked: true, code: ["01"] },
      from25To64: { checked: true, code: ["25", "35", "45", "55"] },
      over65: { checked: true, code: ["65", "75"] },
      unknown: { checked: true, code: ["00"] },
    },
  },
  roadkill: {
    value: false,
    occurrences: {
      value: true,
      animal: {
        racoonDog: { checked: true, code: "100" },
        dogAndCat: { checked: true, code: "200" },
        bird: {
          checked: true,
          notRare: { checked: true, code: "300" },
          quail: { checked: true, code: "301" },
          stellersSeaEagle: { checked: true, code: "302" },
          whiteTailedEagle: { checked: true, code: "303" },
          redCrownedCrane: { checked: true, code: "304" },
          peregrineFalcon: { checked: true, code: "305" },
          okinawaRail: { checked: true, code: "306" },
        },
        deer: {
          checked: true,
          notRare: { checked: true, code: "400" },
          japaneseSerow: { checked: true, code: "401" },
        },
        fox: { checked: true, code: "500" },
        wildBoar: { checked: true, code: "600" },
        others: {
          checked: true,
          notRare: { checked: true, code: "900" },
          ryukyuRat: { checked: true, code: "901" },
        },
      },
      year: {},
      heatmap: true,
    },
    countermeasure: {
      value: true,
      classification: {
        warningSign: { checked: true, code: "2" },
        roadMarking: { checked: true, code: "5" },
        underpass: { checked: true, code: "3" },
        signboard: { checked: true, code: "4" },
        fence: { checked: true, code: "1" },
        informationBoard: { checked: true, code: "6" },
        portableSign: { checked: true, code: "7" },
        others: { checked: true, code: "8" },
      },
    },
  },
  specificSituation: {
    value: false,
    trafficCongestion: {
      value: true,
    },
    importantLogistics: {
      value: true,
      bold: false,
      dataType: {
        logistics: true,
        alternative: true,
      },
    },
    specialVehicle: {
      value: true,
      bold: false,
      dataType: {
        weightHeightDesignated: true,
        exampt: false,
        vehicleGuidance: false,
        examptXPoint: false,
      },
    },
  },
});

/**
 * 日時コントローラ地図・属性時間表示時間
 */
const mapTime: Ref<IControlerDate> = ref({
  year: "",
  month: "",
  day: "",
  hour: 0,
  minute: 0,
});

/**
 * 日時コントローラ地図・属性時間表示時間（実行後）
 */
const executeMapTime: Ref<IControlerDate> = ref({
  year: "",
  month: "",
  day: "",
  hour: 0,
  minute: 0,
});

/**
 * 日時コントローラ属性比較表示時間
 */
const attributeTime: Ref<IControlerDate> = ref({
  year: "",
  month: "",
  day: "",
  hour: 0,
  minute: 0,
});

/**
 * 日時コントローラ属性比較表示時間（実行後）
 */
const executeAttributeTime: Ref<IControlerDate> = ref({
  year: "",
  month: "",
  day: "",
  hour: 0,
  minute: 0,
});

/**
 * リアルタイム更新中フラグ
 */
const isUpdateRealTimeData = ref(false);

/**
 * OD量データ表示中フラグ
 */
const isDisplayOdData = ref(false);

/**
 * 簡易検索初回フラグ
 */
const simpleSearchFirstFlg = ref(true);

/**
 * 凡例画面初期左位置
 */
const legendListDefaultLeft = ref(0);

/**
 * データ存在期間
 */
const dateRangesData: Ref<dateRanges> = ref({});

/**
 * OD量表示パラメータ
 */
const odParam: Ref<{
  startNode: string;
  startFeature: Feature;
  attributeConverter: ODNodeAttributeConvert;
}> = ref({
  startNode: "",
  startFeature: null,
  attributeConverter: null,
});

/**
 * 地図切替
 */
const changeMap = (layerName: LayerName) => {
  const layerFactory = _geoMap.value.getLayerFactory();
  layerFactory.StdMapTile.getViewLayer()[0].setVisible(
    layerName === LayerName.StdMapTile
  );
  layerFactory.PaleMapTile.getViewLayer()[0].setVisible(
    layerName === LayerName.PaleMapTile
  );
  layerFactory.BlankMapTile.getViewLayer()[0].setVisible(
    layerName === LayerName.BlankMapTile
  );
  layerFactory.SeamlessphotoMapTile.getViewLayer()[0].setVisible(
    layerName === LayerName.SeamlessphotoMapTile
  );
  switch (layerName) {
    case LayerName.StdMapTile:
      selectorImageSource.value = stdMapIcon;
      break;
    case LayerName.PaleMapTile:
      selectorImageSource.value = paleMapIcon;
      break;
    case LayerName.BlankMapTile:
      selectorImageSource.value = blankMapIcon;
      break;
    case LayerName.SeamlessphotoMapTile:
      selectorImageSource.value = seamlessPhotoMapIcon;
      break;
  }
  visibleMapLayer.value = layerName;
  changeDispMapSelector(false);
};

/**
 * 左メニュー状態切替（Travos）
 */
const changeSideMenuStateTravos = () => {
  const layerFactory = _geoMap.value.getLayerFactory();
  let roadType: TraVosRoadType[] = [];
  const layerNameList: TraVosLayerName[] = [];
  const CODE_TRAVOS_EXPRESSWAY = "1";
  const CODE_TRAVOS_GENERAL_HIGHWAY = "3";
  if (sideMenuState.value.travos.value) {
    if (sideMenuState.value.travos.type === RADIO_TRAVOS_LIST.history) {
      const timeCode = mapTimeCode.value.substring(0, 10) + "00";
      if (sideMenuState.value.travos.history.generalHighway) {
        roadType.push(CODE_TRAVOS_GENERAL_HIGHWAY);
      }
      if (sideMenuState.value.travos.history.expressway) {
        roadType.push(CODE_TRAVOS_EXPRESSWAY);
      }
      if (
        sideMenuState.value.travos.history.timeType ===
          RADIO_TRAVOS_HISTORY_LIST.measured1Hour &&
        sideMenuState.value.travos.history.measured1Hour.q82
      ) {
        layerNameList.push(
          new TraVosLayerName("Travos_計測値１時間", roadType, timeCode)
        );
      }
      if (
        sideMenuState.value.travos.history.timeType ===
          RADIO_TRAVOS_HISTORY_LIST.measured1Hour &&
        sideMenuState.value.travos.history.measured1Hour.qa82
      ) {
        layerNameList.push(
          new TraVosLayerName(
            "Travos_計測値１時間（画像認識型）",
            roadType,
            timeCode
          )
        );
      }
    } else if (sideMenuState.value.travos.type === RADIO_TRAVOS_LIST.realTime) {
      let targetTime = new Date();
      switch (sideMenuState.value.travos.realTime.timeType) {
        case RADIO_TRAVOS_REALTIME_LIST.value5Minutes:
          targetTime.setMinutes(
            targetTime.getMinutes() - UPDATE_BUFFER_5MINUTES
          );
          targetTime.setMinutes(Math.floor(targetTime.getMinutes() / 5) * 5);
          break;
        case RADIO_TRAVOS_REALTIME_LIST.value1Hour:
          targetTime.setMinutes(targetTime.getMinutes() - UPDATE_BUFFER_1HOUR);
          targetTime.setMinutes(0);
          break;
      }
      let targetTime5Minutes = new Date();
      let targetTime1Hour = new Date();
      targetTime5Minutes.setMinutes(
        targetTime5Minutes.getMinutes() - UPDATE_BUFFER_5MINUTES
      );
      targetTime5Minutes.setMinutes(
        Math.floor(targetTime5Minutes.getMinutes() / 5) * 5
      );
      realTimeTimeCode5Minutes.value =
        targetTime5Minutes.getFullYear().toString() +
        (targetTime5Minutes.getMonth() + 1).toString().padStart(2, "0") +
        targetTime5Minutes.getDate().toString().padStart(2, "0") +
        targetTime5Minutes.getHours().toString().padStart(2, "0") +
        targetTime5Minutes.getMinutes().toString().padStart(2, "0");
      targetTime1Hour.setMinutes(
        targetTime1Hour.getMinutes() - UPDATE_BUFFER_1HOUR
      );
      targetTime1Hour.setMinutes(0);
      realTimeTimeCode1Hour.value =
        targetTime1Hour.getFullYear().toString() +
        (targetTime1Hour.getMonth() + 1).toString().padStart(2, "0") +
        targetTime1Hour.getDate().toString().padStart(2, "0") +
        targetTime1Hour.getHours().toString().padStart(2, "0") +
        targetTime1Hour.getMinutes().toString().padStart(2, "0");
      realTimeTimeCodeTraffic.value = realTimeTrafficData.value?.fid?.includes(
        "travospublic_measure_1h"
      )
        ? realTimeTimeCode1Hour.value
        : realTimeTimeCode5Minutes.value;
      roadType.length = 0;
      if (sideMenuState.value.travos.realTime.generalHighway) {
        roadType.push(CODE_TRAVOS_GENERAL_HIGHWAY);
      }
      if (sideMenuState.value.travos.realTime.expressway) {
        roadType.push(CODE_TRAVOS_EXPRESSWAY);
      }
      if (
        sideMenuState.value.travos.realTime.timeType ===
          RADIO_TRAVOS_REALTIME_LIST.value5Minutes &&
        sideMenuState.value.travos.realTime.value5Minutes.q81
      ) {
        layerNameList.push(
          new TraVosLayerName(
            "Travos_計測値５分(リアルタイム)",
            roadType,
            realTimeTimeCode5Minutes.value
          )
        );
      }
      if (
        sideMenuState.value.travos.realTime.timeType ===
          RADIO_TRAVOS_REALTIME_LIST.value5Minutes &&
        sideMenuState.value.travos.realTime.value5Minutes.qa81
      ) {
        layerNameList.push(
          new TraVosLayerName(
            "Travos_計測値５分（画像認識型）(リアルタイム)",
            roadType,
            realTimeTimeCode5Minutes.value
          )
        );
      }
      if (
        sideMenuState.value.travos.realTime.timeType ===
          RADIO_TRAVOS_REALTIME_LIST.value1Hour &&
        sideMenuState.value.travos.realTime.value1Hour.q82
      ) {
        layerNameList.push(
          new TraVosLayerName(
            "Travos_計測値１時間(リアルタイム)",
            roadType,
            realTimeTimeCode1Hour.value
          )
        );
      }
      if (
        sideMenuState.value.travos.realTime.timeType ===
          RADIO_TRAVOS_REALTIME_LIST.value1Hour &&
        sideMenuState.value.travos.realTime.value1Hour.qa82
      ) {
        layerNameList.push(
          new TraVosLayerName(
            "Travos_計測値１時間（画像認識型）(リアルタイム)",
            roadType,
            realTimeTimeCode1Hour.value
          )
        );
        layerFactory.TraVos.setVisible(
          sideMenuState.value.travos.realTime.timeType ===
            RADIO_TRAVOS_REALTIME_LIST.value1Hour &&
            sideMenuState.value.travos.realTime.value1Hour.qa82 &&
            roadType.length > 0,
          [
            new TraVosLayerName(
              "Travos_計測値１時間（画像認識型）(リアルタイム)",
              roadType,
              realTimeTimeCode1Hour.value
            ),
          ]
        );
      }
    }
  } else {
    deleteAttributeByMenu(RootLayerType.Travos);
  }
  layerFactory.TraVos.setVisible(
    layerNameList.length > 0 && roadType.length > 0,
    layerNameList
  );
};

/**
  左メニュー状態切替（一般交通量調査データ）
 */
const changeSideMenuStateGeneralTraffic = () => {
  const layerFactory = _geoMap.value.getLayerFactory();
  const layerNameList: GeneralTrafficLayerName[] = [];
  let tableType;
  let dataType;
  let roadCategory: string[] = [];
  let roadCategoryObject;
  let specificationTime;
  if (sideMenuState.value.generalTraffic.value) {
    if (
      sideMenuState.value.generalTraffic.tableType ===
      RADIO_GENERAL_TRAFFIC_TABLE_TYPE_LIST.location
    ) {
      tableType = FeatureType.GeneralTrafficLocation;
      dataType = sideMenuState.value.generalTraffic?.location.dataType;
      roadCategoryObject =
        sideMenuState.value.generalTraffic?.location.roadCategory;
    } else {
      tableType = FeatureType.GeneralTrafficTime;
      roadCategoryObject =
        sideMenuState.value.generalTraffic?.time.roadCategory;
      specificationTime =
        sideMenuState.value.generalTraffic?.time.specificationTime;
    }
    if (roadCategoryObject.generalPrefectures) {
      roadCategory.push(
        GENERAL_TRAFFIC_ROAD_CATEGORY_LIST.find(
          (ele) => ele.key === "generalPrefectures"
        ).value
      );
    }
    if (roadCategoryObject.mainLocalRoad) {
      roadCategory.push(
        GENERAL_TRAFFIC_ROAD_CATEGORY_LIST.find(
          (ele) => ele.key === "mainLocalRoad"
        ).value
      );
    }
    if (roadCategoryObject.generalHighwayDirectControl) {
      roadCategory.push(
        GENERAL_TRAFFIC_ROAD_CATEGORY_LIST.find(
          (ele) => ele.key === "generalHighwayDirectControl"
        ).value
      );
    }
    if (roadCategoryObject.generalHighwayOthers) {
      roadCategory.push(
        GENERAL_TRAFFIC_ROAD_CATEGORY_LIST.find(
          (ele) => ele.key === "generalHighwayOthers"
        ).value
      );
    }
    if (roadCategoryObject.urbanHighway) {
      roadCategory.push(
        GENERAL_TRAFFIC_ROAD_CATEGORY_LIST.find(
          (ele) => ele.key === "urbanHighway"
        ).value
      );
    }
    if (roadCategoryObject.expressNationalHighway) {
      roadCategory.push(
        GENERAL_TRAFFIC_ROAD_CATEGORY_LIST.find(
          (ele) => ele.key === "expressNationalHighway"
        ).value
      );
    }
    layerNameList.push(
      new GeneralTrafficLayerName(
        tableType,
        dataType,
        roadCategory,
        specificationTime
      )
    );
  }
  layerFactory.GeneralTraffic.setVisible(
    layerNameList.length > 0,
    layerNameList
  );
  return;
};

/**
 * 左メニュー状態切替（ETC2.0）
 */
const changeSideMenuStateEtc = () => {
  const layerList: Array<ETCLayerName | ETCLayerNameMonth> = [];
  let layerType: ETCLayerType;
  let timeType: ETCTimeType;
  let timeCode: string;
  let dayType: DayType;
  switch (sideMenuState.value.etc.dataType) {
    case RADIO_ETC_DATA_TYPE_LIST.drmLink:
      layerType = "ETC_DRM区間";
      break;
    case RADIO_ETC_DATA_TYPE_LIST.basicSection:
      layerType = "ETC_交通調査基本区間";
      break;
  }
  if (
    sideMenuState.value.etc.timeType === RADIO_ETC_TIME_TYPE_LIST.month1Hour
  ) {
    switch (sideMenuState.value.etc.dayType) {
      case RADIO_ETC_DAY_TYPE_LIST.weekday:
        dayType = "1";
        break;
      case RADIO_ETC_DAY_TYPE_LIST.holiday:
        dayType = "2";
        break;
      case RADIO_ETC_DAY_TYPE_LIST.allday:
        dayType = "3";
        break;
    }
    timeCode =
      mapTimeCode.value.substring(0, 6) +
      "00" +
      mapTimeCode.value.substring(8, 10) +
      "00";
    if (sideMenuState.value.etc.expressNationalHighway) {
      layerList.push(new ETCLayerNameMonth(layerType, "1", dayType, timeCode));
    }
    if (sideMenuState.value.etc.urbanHighway) {
      layerList.push(new ETCLayerNameMonth(layerType, "2", dayType, timeCode));
    }
    if (sideMenuState.value.etc.generalHighway) {
      layerList.push(new ETCLayerNameMonth(layerType, "3", dayType, timeCode));
    }
    if (sideMenuState.value.etc.mainLocalRoadPrefectures) {
      layerList.push(new ETCLayerNameMonth(layerType, "4", dayType, timeCode));
    }
    if (sideMenuState.value.etc.mainLocalRoadDesinatedCity) {
      layerList.push(new ETCLayerNameMonth(layerType, "5", dayType, timeCode));
    }
    if (sideMenuState.value.etc.generalPrefectures) {
      layerList.push(new ETCLayerNameMonth(layerType, "6", dayType, timeCode));
    }
    if (sideMenuState.value.etc.generalDesinatedCity) {
      layerList.push(new ETCLayerNameMonth(layerType, "7", dayType, timeCode));
    }
  } else {
    switch (sideMenuState.value.etc.timeType) {
      case RADIO_ETC_TIME_TYPE_LIST.day15Minutes:
        timeType = "15分";
        timeCode = mapTimeCode.value;
        break;
      case RADIO_ETC_TIME_TYPE_LIST.day1Hour:
        timeType = "1時間";
        timeCode = mapTimeCode.value.substring(0, 10) + "00";
        break;
    }
    if (sideMenuState.value.etc.expressNationalHighway) {
      layerList.push(new ETCLayerName(layerType, "1", timeCode, timeType));
    }
    if (sideMenuState.value.etc.urbanHighway) {
      layerList.push(new ETCLayerName(layerType, "2", timeCode, timeType));
    }
    if (sideMenuState.value.etc.generalHighway) {
      layerList.push(new ETCLayerName(layerType, "3", timeCode, timeType));
    }
    if (sideMenuState.value.etc.mainLocalRoadPrefectures) {
      layerList.push(new ETCLayerName(layerType, "4", timeCode, timeType));
    }
    if (sideMenuState.value.etc.mainLocalRoadDesinatedCity) {
      layerList.push(new ETCLayerName(layerType, "5", timeCode, timeType));
    }
    if (sideMenuState.value.etc.generalPrefectures) {
      layerList.push(new ETCLayerName(layerType, "6", timeCode, timeType));
    }
    if (sideMenuState.value.etc.generalDesinatedCity) {
      layerList.push(new ETCLayerName(layerType, "7", timeCode, timeType));
    }
  }
  if (!sideMenuState.value.etc.value) {
    deleteAttributeByMenu(RootLayerType.Etc);
  }
  _geoMap.value
    .getLayerFactory()
    .ETC.setVisible(sideMenuState.value.etc.value, layerList);
};

/**
 * 左メニュー状態切替（OD）
 */
const changeSideMenuStateOd = (key?: any, changeLimitFlg?: boolean) => {
  if (!sideMenuState.value.od.value) {
    deleteAttributeByMenu(RootLayerType.Od);
  }
  const layerFactory = _geoMap.value.getLayerFactory();
  if (!key || key === "od") {
    const odDataType = RADIO_OD_DATA_TYPE_LIST.find(
      (ele) => ele.value == sideMenuState.value.od.od.dataType
    )?.text;
    const odCarType = RADIO_OD_CAR_TYPE_LIST.find(
      (ele) => ele.value == sideMenuState.value.od.od.carType
    )?.text;
    layerFactory.ODNode.setVisible(
      sideMenuState.value.od.value && sideMenuState.value.od.od.value,
      new ODQuantityLayerName(
        odDataType as ODDataType,
        odCarType as CarType,
        "R03",
        sideMenuState.value.od.od.limitMax !== ""
          ? Number(sideMenuState.value.od.od.limitMax)
          : null,
        sideMenuState.value.od.od.limitMin !== ""
          ? Number(sideMenuState.value.od.od.limitMin)
          : null
      )
    );
    const rightClickContext = document.getElementById("contextMenuItemOdRight");
    if (rightClickContext) {
      _geoMap.value._contextMenu.close();
    }
  }
  if (!key || key === "generation") {
    if (
      sideMenuState.value.od.generation.dataType !==
        OD_DATA_TYPE_LIST.prefectures ||
      sideMenuState.value.od.generation.carType !== OD_CAR_TYPE_LIST.total
    ) {
      sideMenuState.value.od.generation.purpose =
        OD_GENERATION_PURPOSE_LIST.purposeTotal;
    }
    const generationDataType = RADIO_OD_DATA_TYPE_LIST.find(
      (ele) => ele.value == sideMenuState.value.od.generation.dataType
    )?.text;
    const generationCarType = RADIO_OD_CAR_TYPE_LIST.find(
      (ele) => ele.value == sideMenuState.value.od.generation.carType
    )?.text;
    const generationTargetType = RADIO_OD_TARGET_LIST.find(
      (ele) => ele.value == sideMenuState.value.od.generation.target
    )?.text;
    layerFactory.ODDepartureAndArrival.setVisible(
      sideMenuState.value.od.value && sideMenuState.value.od.generation.value,
      new ODSumDeparturesArrivalsLayerName(
        generationDataType as ODDataType,
        generationCarType as CarType,
        "R03",
        sideMenuState.value.od.generation.purpose,
        generationTargetType
      )
    );
  }
  if (!key || key === "zone") {
    const zoneDataType = RADIO_OD_DATA_TYPE_LIST.find(
      (ele) => ele.value == sideMenuState.value.od.zone.dataType
    )?.text;
    layerFactory.ODZone.setVisible(
      sideMenuState.value.od.value && sideMenuState.value.od.zone.value,
      new ODZoneLayerName(zoneDataType as ODDataType, "R03")
    );
  }
  if (!changeLimitFlg) {
    odDisplayEvent.onOdNodeUnSelected(false);
  }
};

/**
 * OD上限値・下限値更新
 */
const confirmOdLimit = () => {
  if (checkSideMenuStateOdLimit()) {
    sideMenuState.value.od.od.limitMin = sideMenuState.value.od.od.tmpLimitMin;
    sideMenuState.value.od.od.limitMax = sideMenuState.value.od.od.tmpLimitMax;
    changeSideMenuStateOd("od", true);
    if (odParam.value.startNode) {
      _geoMap.value
        .getLayerFactory()
        .ODNode.onSelectedStartNode(
          odParam.value.startNode,
          odParam.value.startFeature,
          odParam.value.attributeConverter
        )();
    }
  }
};

/**
 * 左メニュー状態切替（DRM）
 */
const changeSideMenuStateDrm = (key?: any) => {
  const layerFactory = _geoMap.value.getLayerFactory();
  if (!key || key === "node") {
    layerFactory.DrmNodeMap.setVisible(
      sideMenuState.value.drm.value && sideMenuState.value.drm.node,
      sideMenuState.value.drm.roadType
    );
  }
  if (!key || key === "link") {
    layerFactory.DrmLinkMap.setVisible(
      sideMenuState.value.drm.value && sideMenuState.value.drm.link,
      sideMenuState.value.drm.roadType
    );
  }
  if (!sideMenuState.value.drm.value) {
    deleteAttributeByMenu(RootLayerType.Drm);
  }
};

/**
 * 左メニュー状態切替（点検DB）
 */
const changeSideMenuStateRoadStructures = (key?: LayerName) => {
  const layerFactory = _geoMap.value.getLayerFactory();
  const adminTypeList: KanrishaKubun[] = [];
  Object.values(sideMenuState.value.roadStructures.adminType).forEach((ele) => {
    if (ele.checked) {
      adminTypeList.push(ele.code as KanrishaKubun);
    }
  });
  const soundnessList: HanteiKubun[] = [];
  Object.values(sideMenuState.value.roadStructures.soundness).forEach((ele) => {
    if (ele.checked) {
      soundnessList.push(ele.code as HanteiKubun);
    }
  });
  const measuresList: SochiJoukyou[] = [];
  Object.values(sideMenuState.value.roadStructures.measures).forEach((ele) => {
    if (ele.checked) {
      measuresList.push(ele.code as SochiJoukyou);
    }
  });
  if (!key || key === LayerName.RoadStructuresBridges) {
    layerFactory.RoadStructuresBridges.setVisible(
      sideMenuState.value.roadStructures.value &&
        sideMenuState.value.roadStructures.facilityType.bridges,
      [],
      soundnessList,
      adminTypeList,
      measuresList
    );
  }
  if (!key || key === LayerName.RoadStructuresTunnels) {
    layerFactory.RoadStructuresTunnels.setVisible(
      sideMenuState.value.roadStructures.value &&
        sideMenuState.value.roadStructures.facilityType.tunnels,
      [],
      soundnessList,
      adminTypeList,
      measuresList
    );
  }
  if (!key || key === LayerName.RoadStructuresSheds) {
    layerFactory.RoadStructuresSheds.setVisible(
      sideMenuState.value.roadStructures.value &&
        sideMenuState.value.roadStructures.facilityType.sheds,
      [],
      soundnessList,
      adminTypeList,
      measuresList
    );
  }
  if (!key || key === LayerName.RoadStructuresCulverts) {
    layerFactory.RoadStructuresCulverts.setVisible(
      sideMenuState.value.roadStructures.value &&
        sideMenuState.value.roadStructures.facilityType.culverts,
      [],
      soundnessList,
      adminTypeList,
      measuresList
    );
  }
  if (!key || key === LayerName.RoadStructuresPedestrianDecks) {
    layerFactory.RoadStructuresPedestrianDecks.setVisible(
      sideMenuState.value.roadStructures.value &&
        sideMenuState.value.roadStructures.facilityType.pedestrianDecks,
      [],
      soundnessList,
      adminTypeList,
      measuresList
    );
  }
  if (!key || key === LayerName.RoadStructuresOverheadSignages) {
    layerFactory.RoadStructuresOverheadSignages.setVisible(
      sideMenuState.value.roadStructures.value &&
        sideMenuState.value.roadStructures.facilityType.overheadSignages,
      [],
      soundnessList,
      adminTypeList,
      measuresList
    );
  }
  if (!key || key === LayerName.RoadStructuresPavements) {
    layerFactory.RoadStructuresPavements.setVisible(
      sideMenuState.value.roadStructures.value &&
        sideMenuState.value.roadStructures.facilityType.pavements,
      [],
      soundnessList,
      adminTypeList,
      measuresList
    );
  }
  if (!key || key === LayerName.RoadStructuresEarthworks) {
    layerFactory.RoadStructuresEarthworks.setVisible(
      sideMenuState.value.roadStructures.value &&
        sideMenuState.value.roadStructures.facilityType.earthworks,
      [],
      soundnessList,
      adminTypeList,
      measuresList
    );
  }
  if (!sideMenuState.value.roadStructures.value) {
    deleteAttributeByMenu(RootLayerType.RoadStructures);
  }
};

/**
 * 左メニュー状態切替（交通事故統計情報）
 */
const changeSideMenuStateAccidentHotspot = () => {
  const year: string[] = [];
  const accidentDetail: string[] = [];
  const accidentType: string[] = [];
  const partyTypeA: string[] = [];
  const partyTypeB: string[] = [];
  const ageA: string[] = [];
  const ageB: string[] = [];

  if (sideMenuState.value.accidentHotspot?.value) {
    Object.values(sideMenuState.value.accidentHotspot.year).forEach(
      (ele: any) => {
        if (ele.checked) {
          year.push(ele.value);
        }
      }
    );
    Object.values(sideMenuState.value.accidentHotspot.accidentDetails).forEach(
      (ele) => {
        if (ele.checked) {
          accidentDetail.push(ele.code);
        }
      }
    );
    Object.values(sideMenuState.value.accidentHotspot.accidentType).forEach(
      (ele) => {
        if (ele.checked) {
          accidentType.push(ele.code);
        }
      }
    );
    Object.values(sideMenuState.value.accidentHotspot.partyTypeA).forEach(
      (ele) => {
        if (ele.checked) {
          partyTypeA.push(...ele.code);
        }
      }
    );
    Object.values(sideMenuState.value.accidentHotspot.partyTypeB).forEach(
      (ele) => {
        if (ele.checked) {
          partyTypeB.push(...ele.code);
        }
      }
    );
    Object.values(sideMenuState.value.accidentHotspot.ageA).forEach((ele) => {
      if (ele.checked) {
        ageA.push(...ele.code);
      }
    });
    Object.values(sideMenuState.value.accidentHotspot.ageB).forEach((ele) => {
      if (ele.checked) {
        ageB.push(...ele.code);
      }
    });
  }

  _geoMap.value
    .getLayerFactory()
    .AccidentHotspot.setVisible(
      sideMenuState.value.accidentHotspot?.value &&
        year.length > 0 &&
        accidentDetail.length > 0 &&
        accidentType.length > 0 &&
        partyTypeA.length > 0 &&
        partyTypeB.length > 0 &&
        ageA.length > 0 &&
        ageB.length > 0,
      year,
      accidentDetail,
      accidentType,
      partyTypeA,
      partyTypeB,
      ageA,
      ageB
    );

  if (!sideMenuState.value.accidentHotspot?.value) {
    deleteAttributeByMenu(RootLayerType.AccidentHotspot);
  }
};

/**
 * 左メニュー状態切替（ロードキル）
 */
const changeSideMenuStateRoadkill = (_key?: any) => {
  const layerNameList: RoadkillLayerName[] = [];

  if (sideMenuState.value.roadkill!.value) {
    if (sideMenuState.value.roadkill!.occurrences.value) {
      const animal: string[] = [];
      const year: string[] = [];

      const selectCheckChild = (subTarget: any) => {
        for (const key in subTarget) {
          if (!subTarget[key].checked) continue;
          if (subTarget[key].code) {
            animal.push(subTarget[key].code);
          }
          if (typeof subTarget[key] === "object") {
            selectCheckChild(subTarget[key]);
          }
        }
      };
      selectCheckChild(sideMenuState.value.roadkill!.occurrences.animal);

      Object.values(sideMenuState.value.roadkill!.occurrences.year).forEach(
        (ele: any) => {
          if (ele.checked) {
            year.push(ele.value);
          }
        }
      );
      if (animal.length && year.length) {
        layerNameList.push(
          new RoadkillLayerName("ロードキル発生状況", animal, year)
        );
      }
    }
    if (sideMenuState.value.roadkill!.countermeasure.value) {
      const classification: string[] = [];

      Object.values(
        sideMenuState.value.roadkill!.countermeasure.classification
      ).forEach((ele) => {
        if (ele.checked) {
          classification.push(ele.code);
        }
      });
      if (classification.length) {
        layerNameList.push(
          new RoadkillLayerName("ロードキル対策実施状況", classification)
        );
      }
    }
  }
  _geoMap.value
    .getLayerFactory()
    .Roadkill.setVisible(layerNameList.length > 0, layerNameList);

  _geoMap.value
    .getLayerFactory()
    .RoadKillHeatmap.getViewLayer()[0]
    .setVisible(
      sideMenuState.value.roadkill!.value &&
        sideMenuState.value.roadkill!.occurrences.value &&
        sideMenuState.value.roadkill!.occurrences.heatmap
    );

  if (!sideMenuState.value.roadkill!.value) {
    deleteAttributeByMenu(RootLayerType.Roadkill);
  }
};

/**
 * 左メニュー状態切替（道路の指定・特定状況）
 */
const changeSideMenuStateSpecificSituation = (key?: any) => {
  if (!key || key == "trafficCongestion") {
    _geoMap.value
      .getLayerFactory()
      .TrafficCongestion.setVisible(
        sideMenuState.value.specificSituation.value &&
          sideMenuState.value.specificSituation.trafficCongestion.value
      );
  }
  if (!key || key == "importantLogistics") {
    const attributeNames: Array<RoadAttributeName> = [];
    if (
      sideMenuState.value.specificSituation.importantLogistics.dataType
        .logistics
    ) {
      attributeNames.push("全国重要物流道路");
    }
    if (
      sideMenuState.value.specificSituation.importantLogistics.dataType
        .alternative
    ) {
      attributeNames.push("全国代替補完路");
    }
    _geoMap.value
      .getLayerFactory()
      .RoadAttribute.setVisible(
        sideMenuState.value.specificSituation.value &&
          sideMenuState.value.specificSituation.importantLogistics.value &&
          attributeNames.length > 0,
        attributeNames,
        sideMenuState.value.specificSituation.importantLogistics.bold
      );
  }
  if (!key || key == "specialVehicle") {
    _geoMap.value
      .getLayerFactory()
      .WeightHeightDesignatedRoad.setVisible(
        sideMenuState.value.specificSituation.value &&
          sideMenuState.value.specificSituation.specialVehicle.value &&
          sideMenuState.value.specificSituation.specialVehicle.dataType
            .weightHeightDesignated,
        sideMenuState.value.specificSituation.specialVehicle.bold
      );
    _geoMap.value
      .getLayerFactory()
      .SpecialVehicleExempt.setVisible(
        sideMenuState.value.specificSituation.value &&
          sideMenuState.value.specificSituation.specialVehicle.value &&
          sideMenuState.value.specificSituation.specialVehicle.dataType.exampt,
        sideMenuState.value.specificSituation.specialVehicle.bold
      );
    _geoMap.value
      .getLayerFactory()
      .LargeVehicleGuidanceSection.setVisible(
        sideMenuState.value.specificSituation.value &&
          sideMenuState.value.specificSituation.specialVehicle.value &&
          sideMenuState.value.specificSituation.specialVehicle.dataType
            .vehicleGuidance,
        sideMenuState.value.specificSituation.specialVehicle.bold
      );
    _geoMap.value
      .getLayerFactory()
      .SpecialVehicleExemptPoint.setVisible(
        sideMenuState.value.specificSituation.value &&
          sideMenuState.value.specificSituation.specialVehicle.value &&
          sideMenuState.value.specificSituation.specialVehicle.dataType
            .examptXPoint
      );
  }

  if (!sideMenuState.value.specificSituation.value) {
    deleteAttributeByMenu(RootLayerType.SpecificSituation);
  }
};

/**
 * 左メニューOD量制限エラーチェック
 */
const checkSideMenuStateOdLimit = () => {
  if (/[^0-9]/.test(sideMenuState.value.od.od.tmpLimitMax)) {
    commonView.value._messageLogic.onOpenMessage(
      MessageDefine.W0006.getMessage(["上限値"])
    );
    return false;
  } else if (/[^0-9]/.test(sideMenuState.value.od.od.tmpLimitMin)) {
    commonView.value._messageLogic.onOpenMessage(
      MessageDefine.W0006.getMessage(["下限値"])
    );
    return false;
  } else if (
    sideMenuState.value.od.od.tmpLimitMin !== "" &&
    sideMenuState.value.od.od.tmpLimitMax !== "" &&
    Number(sideMenuState.value.od.od.tmpLimitMin) >
      Number(sideMenuState.value.od.od.tmpLimitMax)
  ) {
    commonView.value._messageLogic.onOpenMessage(
      MessageDefine.W0015.getMessage(["上限値", "下限値"])
    );
    return false;
  }
  return true;
};

/**
 * ベクタファイル読み込み
 */
const importVectorFile = () => {
  document.getElementById("selectImportVetorFileBody").click();
};

/**
 * ベクタファイル選択時処理
 */
const selectImportVectorFile = (ev: Event) => {
  const target = ev.target as HTMLInputElement;
  const file = target.files[0];
  if (!file) return;
  const extensionIndex = file.name.lastIndexOf(".");
  if (
    extensionIndex === -1 ||
    file.name.slice(extensionIndex + 1).toLowerCase() != "geojson"
  ) {
    commonView.value._messageLogic.onOpenMessage(
      MessageDefine.W0010.getMessage()
    );
    return;
  }
  const reader = new FileReader();
  reader.onload = (e) => {
    const coordinates = _geoMap.value
      .getLayerFactory()
      .GeoJson.load(e.target.result);
    if (coordinates) {
      moveMap(coordinates[1], coordinates[0]);
    }
  };
  reader.readAsText(file);
  (ev.target as any).value = "";
};

/**
 * ベクタファイルクリア
 */
const clearVectorFile = () => {
  commonView.value._messageLogic.onOpenMessage(
    MessageDefine.I0001.getMessage(),
    true,
    () => {
      attributeList.value = attributeList.value.filter((ele) => {
        if (ele.fid.startsWith("GeoJSON-")) {
          _geoMap.value.unSelectedFeature(ele.fid);
          return false;
        } else {
          return true;
        }
      });
      _geoMap.value.getLayerFactory().GeoJson.clear();
    }
  );
};

/**
 * 設定出力
 */
const exportOptionFile = () => {
  const jsonString = createExportOptionFile(
    sideMenuState.value,
    executeMapTime.value,
    executeAttributeTime.value,
    footerInfo.value,
    visibleMapLayer.value
  );

  const blob = new Blob([jsonString], { type: "application/json" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `data_setting_${ExportUtil.exportFileDate()}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

/**
 * 設定読み込み
 */
const importOptionFile = () => {
  document.getElementById("selectImportOptionFileBody").click();
};

/**
 * 設定読み込みファイル選択時処理
 */
const selectImportOptionFile = (ev: Event) => {
  const target = ev.target as HTMLInputElement;
  const file = target.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (e) => {
    const content: any = e.target.result;
    try {
      const data = JSON.parse(content);
      if (checkImportOptionFile(data)) {
        commonView.value._messageLogic.onOpenMessage(
          MessageDefine.W0010.getMessage()
        );
        (ev.target as any).value = "";
        return;
      }
      mapTime.value.year = data.日時コントローラ.地図属性.年;
      mapTime.value.month = data.日時コントローラ.地図属性.月;
      mapTime.value.day = data.日時コントローラ.地図属性.日;
      mapTime.value.hour = data.日時コントローラ.地図属性.時;
      mapTime.value.minute = data.日時コントローラ.地図属性.分;
      executeMapTime.value = Object.assign({}, mapTime.value);
      mapTimeCode.value =
        mapTime.value.year.padStart(4, "0") +
        mapTime.value.month.padStart(2, "0") +
        mapTime.value.day.padStart(2, "0") +
        mapTime.value.hour.toString().padStart(2, "0") +
        mapTime.value.minute.toString().padStart(2, "0");
      if (data.日時コントローラ.属性.年) {
        attributeTime.value.year = data.日時コントローラ.属性.年;
        attributeTime.value.month = data.日時コントローラ.属性.月;
        attributeTime.value.day = data.日時コントローラ.属性.日;
        attributeTime.value.hour = data.日時コントローラ.属性.時;
        attributeTime.value.minute = data.日時コントローラ.属性.分;
        executeAttributeTime.value = Object.assign({}, attributeTime.value);
        attributeTimeCode.value =
          attributeTime.value.year.padStart(2, "0") +
          attributeTime.value.month.padStart(2, "0") +
          attributeTime.value.day.padStart(2, "0") +
          attributeTime.value.hour.toString().padStart(2, "0") +
          attributeTime.value.minute.toString().padStart(2, "0");
      }
      executeUpdateTime();
      footerInfo.value.zoomLevel = data.地図情報.Zoomレベル;
      updateZoom();
      footerInfo.value.latitude = data.地図情報.緯度;
      footerInfo.value.longitude = data.地図情報.経度;
      moveMap(
        Number(footerInfo.value.latitude),
        Number(footerInfo.value.longitude)
      );
      sideMenuState.value.travos.value = data.Travos;
      sideMenuState.value.travos.type = data.Travosデータ.過去最新;
      sideMenuState.value.travos.history.timeType =
        data.Travosデータ.過去データ.データ種別;
      sideMenuState.value.travos.history.measured1Hour.q82 =
        data.Travosデータ.過去データ.常時観測データ計測値[
          "常設トラカン（様式Q-8-2）"
        ];
      sideMenuState.value.travos.history.measured1Hour.qa82 =
        data.Travosデータ.過去データ.常時観測データ計測値[
          "CCTVトラカン（様式QA-8-2）"
        ];
      sideMenuState.value.travos.history.generalHighway =
        data.Travosデータ.過去データ.道路種別.一般国道;
      sideMenuState.value.travos.history.expressway =
        data.Travosデータ.過去データ.道路種別.高速道路;
      sideMenuState.value.travos.realTime.timeType =
        data.Travosデータ.最新データ.データ種別;
      sideMenuState.value.travos.realTime.value5Minutes.q81 =
        data.Travosデータ.最新データ["5分値"]["常設トラカン様式（Q-8-1）"];
      sideMenuState.value.travos.realTime.value5Minutes.qa81 =
        data.Travosデータ.最新データ["5分値"]["CCTVトラカン（様式QA-8-1）"];
      sideMenuState.value.travos.realTime.value1Hour.q82 =
        data.Travosデータ.最新データ["1時間値"]["常設トラカン様式（Q-8-2）"];
      sideMenuState.value.travos.realTime.value1Hour.qa82 =
        data.Travosデータ.最新データ["1時間値"]["CCTVトラカン（様式QA-8-2）"];
      sideMenuState.value.travos.realTime.generalHighway =
        data.Travosデータ.最新データ.道路種別.一般国道;
      sideMenuState.value.travos.realTime.expressway =
        data.Travosデータ.最新データ.道路種別.高速道路;
      sideMenuState.value.etc.value = data["ETC2.0"];
      sideMenuState.value.etc.dataType = data.ETC情報.データ種別;
      sideMenuState.value.etc.timeType = data.ETC情報.時間種別;
      sideMenuState.value.etc.expressNationalHighway =
        data.ETC情報.道路種別.高速自動車国道;
      sideMenuState.value.etc.urbanHighway = data.ETC情報.道路種別.都市高速道路;
      sideMenuState.value.etc.generalHighway = data.ETC情報.道路種別.一般国道;
      sideMenuState.value.etc.mainLocalRoadPrefectures =
        data.ETC情報.道路種別["主要地方道（都道府県道）"];
      sideMenuState.value.etc.mainLocalRoadDesinatedCity =
        data.ETC情報.道路種別["主要地方道（指定市市道）"];
      sideMenuState.value.etc.generalPrefectures =
        data.ETC情報.道路種別.一般都道府県道;
      sideMenuState.value.etc.generalDesinatedCity =
        data.ETC情報.道路種別.特定市の一般市道;
      sideMenuState.value.etc.dayType = data.ETC情報.平休日;
      sideMenuState.value.od.value = data.OD;
      sideMenuState.value.od.od.value = data.OD情報.OD交通量;
      sideMenuState.value.od.od.dataType =
        data.OD情報.OD交通量データ.データ種別;
      sideMenuState.value.od.od.carType = data.OD情報.OD交通量データ.車種;
      sideMenuState.value.od.od.year = data.OD情報.OD交通量データ.年度;
      sideMenuState.value.od.od.tmpLimitMax =
        data.OD情報.OD交通量データ.制限.上限値;
      sideMenuState.value.od.od.tmpLimitMin =
        data.OD情報.OD交通量データ.制限.下限値;
      sideMenuState.value.od.generation.value = data.OD情報["発生・集中交通量"];
      sideMenuState.value.od.generation.dataType =
        data.OD情報["発生・集中交通量データ"].データ種別;
      sideMenuState.value.od.generation.carType =
        data.OD情報["発生・集中交通量データ"].車種;
      sideMenuState.value.od.generation.year =
        data.OD情報["発生・集中交通量データ"].年度;
      sideMenuState.value.od.generation.purpose =
        data.OD情報["発生・集中交通量データ"].移動目的;
      sideMenuState.value.od.generation.target =
        data.OD情報["発生・集中交通量データ"].表示対象;
      sideMenuState.value.od.zone.value = data.OD情報.ゾーン位置表示;
      sideMenuState.value.od.zone.dataType =
        data.OD情報.ゾーン位置表示データ.データ種別;
      sideMenuState.value.od.zone.year = data.OD情報.ゾーン位置表示データ.年度;
      sideMenuState.value.drm.value = data.DRM;
      sideMenuState.value.drm.roadType = data.DRMデータ.道路区分;
      sideMenuState.value.drm.node = data.DRMデータ["ノード/リンク"].ノード;
      sideMenuState.value.drm.link = data.DRMデータ["ノード/リンク"].リンク;
      sideMenuState.value.roadStructures.value = data.点検DB;
      sideMenuState.value.roadStructures.facilityType.bridges =
        data.点検DBの情報.施設区分.道路橋;
      sideMenuState.value.roadStructures.facilityType.tunnels =
        data.点検DBの情報.施設区分.トンネル;
      sideMenuState.value.roadStructures.facilityType.sheds =
        data.点検DBの情報.施設区分.シェッド;
      sideMenuState.value.roadStructures.facilityType.culverts =
        data.点検DBの情報.施設区分.大型カルバート;
      sideMenuState.value.roadStructures.facilityType.pedestrianDecks =
        data.点検DBの情報.施設区分.横断歩道橋;
      sideMenuState.value.roadStructures.facilityType.overheadSignages =
        data.点検DBの情報.施設区分.門型標識等;
      sideMenuState.value.roadStructures.facilityType.pavements =
        data.点検DBの情報.施設区分.舗装;
      sideMenuState.value.roadStructures.facilityType.earthworks =
        data.点検DBの情報.施設区分.特定道路土工構造物;
      sideMenuState.value.roadStructures.adminType.country.checked =
        data.点検DBの情報.管理者区分.国;
      sideMenuState.value.roadStructures.adminType.prefectures.checked =
        data.点検DBの情報.管理者区分.都道府県;
      sideMenuState.value.roadStructures.adminType.roadPublic.checked =
        data.点検DBの情報.管理者区分.道路公社;
      sideMenuState.value.roadStructures.adminType.orderedCity.checked =
        data.点検DBの情報.管理者区分.政令市;
      sideMenuState.value.roadStructures.adminType.municipalities.checked =
        data.点検DBの情報.管理者区分.市区町村;
      sideMenuState.value.roadStructures.adminType.expressway.checked =
        data.点検DBの情報.管理者区分.高速道路会社;
      sideMenuState.value.roadStructures.soundness.one.checked =
        data.点検DBの情報.健全性.I;
      sideMenuState.value.roadStructures.soundness.two.checked =
        data.点検DBの情報.健全性.Ⅱ;
      sideMenuState.value.roadStructures.soundness.three.checked =
        data.点検DBの情報.健全性.Ⅲ;
      sideMenuState.value.roadStructures.soundness.four.checked =
        data.点検DBの情報.健全性.Ⅳ;
      sideMenuState.value.roadStructures.soundness.notInspected.checked =
        data.点検DBの情報.健全性.未点検;
      sideMenuState.value.roadStructures.measures.unnecessary.checked =
        data.点検DBの情報.措置状況.措置不要;
      sideMenuState.value.roadStructures.measures.notStarted.checked =
        data.点検DBの情報.措置状況.措置未着手;
      sideMenuState.value.roadStructures.measures.started.checked =
        data.点検DBの情報.措置状況.措置着手済;
      sideMenuState.value.roadStructures.measures.completed.checked =
        data.点検DBの情報.措置状況.措置完了済;
      sideMenuState.value.roadStructures.measures.notInspected.checked =
        data.点検DBの情報.措置状況.未点検;
      changeSideMenuStateTravos();
      changeSideMenuStateEtc();
      confirmOdLimit();
      changeSideMenuStateOd();
      changeSideMenuStateDrm();
      changeSideMenuStateRoadStructures();
      if (data.交通事故統計情報の情報) {
        // 4DB追加分
        sideMenuState.value.accidentHotspot.value = data.交通事故統計情報;
        for (const key in data.交通事故統計情報の情報.年度) {
          if (!sideMenuState.value.accidentHotspot.year[key]) continue;
          sideMenuState.value.accidentHotspot.year[key].checked =
            data.交通事故統計情報の情報.年度[key];
        }
        sideMenuState.value.accidentHotspot.accidentDetails.death.checked =
          data.交通事故統計情報の情報.事故内容.死亡;
        sideMenuState.value.accidentHotspot.accidentDetails.injury.checked =
          data.交通事故統計情報の情報.事故内容.負傷;
        sideMenuState.value.accidentHotspot.accidentType.peopleVehicles.checked =
          data.交通事故統計情報の情報.事故類型.人対車両;
        sideMenuState.value.accidentHotspot.accidentType.vehicleMutual.checked =
          data.交通事故統計情報の情報.事故類型.車両相互;
        sideMenuState.value.accidentHotspot.accidentType.vehicleAlone.checked =
          data.交通事故統計情報の情報.事故類型.車両単独;
        sideMenuState.value.accidentHotspot.accidentType.train.checked =
          data.交通事故統計情報の情報.事故類型.列車;
        sideMenuState.value.accidentHotspot.partyTypeA.pedestrian.checked =
          data.交通事故統計情報の情報["当事者種別（当事者A）"].歩行者;
        sideMenuState.value.accidentHotspot.partyTypeA.bicycle.checked =
          data.交通事故統計情報の情報["当事者種別（当事者A）"].自転車;
        sideMenuState.value.accidentHotspot.partyTypeA.motorcycle.checked =
          data.交通事故統計情報の情報["当事者種別（当事者A）"].二輪車;
        sideMenuState.value.accidentHotspot.partyTypeA.car.checked =
          data.交通事故統計情報の情報["当事者種別（当事者A）"].自動車;
        sideMenuState.value.accidentHotspot.partyTypeA.others.checked =
          data.交通事故統計情報の情報["当事者種別（当事者A）"].その他;
        sideMenuState.value.accidentHotspot.partyTypeB.pedestrian.checked =
          data.交通事故統計情報の情報["当事者種別（当事者B）"].歩行者;
        sideMenuState.value.accidentHotspot.partyTypeB.bicycle.checked =
          data.交通事故統計情報の情報["当事者種別（当事者B）"].自転車;
        sideMenuState.value.accidentHotspot.partyTypeB.motorcycle.checked =
          data.交通事故統計情報の情報["当事者種別（当事者B）"].二輪車;
        sideMenuState.value.accidentHotspot.partyTypeB.car.checked =
          data.交通事故統計情報の情報["当事者種別（当事者B）"].自動車;
        sideMenuState.value.accidentHotspot.partyTypeB.others.checked =
          data.交通事故統計情報の情報["当事者種別（当事者B）"].その他;
        sideMenuState.value.accidentHotspot.ageA.from0To24.checked =
          data.交通事故統計情報の情報["年代別（当事者A）"]["0～24歳"];
        sideMenuState.value.accidentHotspot.ageA.from25To64.checked =
          data.交通事故統計情報の情報["年代別（当事者A）"]["25～64歳"];
        sideMenuState.value.accidentHotspot.ageA.over65.checked =
          data.交通事故統計情報の情報["年代別（当事者A）"]["65歳～"];
        sideMenuState.value.accidentHotspot.ageA.unknown.checked =
          data.交通事故統計情報の情報["年代別（当事者A）"].不明;
        sideMenuState.value.accidentHotspot.ageB.from0To24.checked =
          data.交通事故統計情報の情報["年代別（当事者B）"]["0～24歳"];
        sideMenuState.value.accidentHotspot.ageB.from25To64.checked =
          data.交通事故統計情報の情報["年代別（当事者B）"]["25～64歳"];
        sideMenuState.value.accidentHotspot.ageB.over65.checked =
          data.交通事故統計情報の情報["年代別（当事者B）"]["65歳～"];
        sideMenuState.value.accidentHotspot.ageB.unknown.checked =
          data.交通事故統計情報の情報["年代別（当事者B）"].不明;
        sideMenuState.value.roadkill!.value = data.ロードキル;
        sideMenuState.value.roadkill!.occurrences.value =
          data.ロードキルの情報.ロードキル発生状況;
        sideMenuState.value.roadkill!.occurrences.animal.racoonDog.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.タヌキ;
        sideMenuState.value.roadkill!.occurrences.animal.dogAndCat.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種["犬・猫"];
        sideMenuState.value.roadkill!.occurrences.animal.bird.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.鳥類;
        sideMenuState.value.roadkill!.occurrences.animal.bird.notRare.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.鳥類の情報.希少種以外;
        sideMenuState.value.roadkill!.occurrences.animal.bird.quail.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.鳥類の情報[
            "ウズラ（希少種）"
          ];
        sideMenuState.value.roadkill!.occurrences.animal.bird.stellersSeaEagle.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.鳥類の情報[
            "オオワシ（希少種）"
          ];
        sideMenuState.value.roadkill!.occurrences.animal.bird.whiteTailedEagle.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.鳥類の情報[
            "オジロワシ（希少種）"
          ];
        sideMenuState.value.roadkill!.occurrences.animal.bird.redCrownedCrane.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.鳥類の情報[
            "タンチョウ（希少種）"
          ];
        sideMenuState.value.roadkill!.occurrences.animal.bird.peregrineFalcon.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.鳥類の情報[
            "ハヤブサ（希少種）"
          ];
        sideMenuState.value.roadkill!.occurrences.animal.bird.okinawaRail.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.鳥類の情報[
            "ヤンバルクイナ（希少種）"
          ];
        sideMenuState.value.roadkill!.occurrences.animal.deer.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.シカ;
        sideMenuState.value.roadkill!.occurrences.animal.deer.notRare.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.シカの情報.希少種以外;
        sideMenuState.value.roadkill!.occurrences.animal.deer.japaneseSerow.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.シカの情報[
            "ニホンカモシカ（希少種）"
          ];
        sideMenuState.value.roadkill!.occurrences.animal.fox.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.キツネ;
        sideMenuState.value.roadkill!.occurrences.animal.wildBoar.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.イノシシ;
        sideMenuState.value.roadkill!.occurrences.animal.others.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.その他;
        sideMenuState.value.roadkill!.occurrences.animal.others.notRare.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.その他の情報.希少種以外;
        sideMenuState.value.roadkill!.occurrences.animal.others.ryukyuRat.checked =
          data.ロードキルの情報.ロードキル発生状況の情報.動物種.その他の情報[
            "ケナガネズミ（希少種）"
          ];
        for (const key in data.ロードキルの情報.ロードキル発生状況の情報
          .発生年) {
          if (!sideMenuState.value.roadkill!.occurrences.year[key]) continue;
          sideMenuState.value.roadkill!.occurrences.year[key].checked =
            data.ロードキルの情報.ロードキル発生状況の情報.発生年[key];
        }
        sideMenuState.value.roadkill!.occurrences.heatmap =
          data.ロードキルの情報.ロードキル発生状況の情報.ヒートマップ;
        sideMenuState.value.roadkill!.countermeasure.value =
          data.ロードキルの情報.対策実施状況;
        sideMenuState.value.roadkill!.countermeasure.classification.warningSign.checked =
          data.ロードキルの情報.対策実施状況の情報.対策分類.警戒標識;
        sideMenuState.value.roadkill!.countermeasure.classification.roadMarking.checked =
          data.ロードキルの情報.対策実施状況の情報.対策分類.路面標示;
        sideMenuState.value.roadkill!.countermeasure.classification.underpass.checked =
          data.ロードキルの情報.対策実施状況の情報.対策分類.道路横断施設;
        sideMenuState.value.roadkill!.countermeasure.classification.signboard.checked =
          data.ロードキルの情報.対策実施状況の情報.対策分類.注意看板;
        sideMenuState.value.roadkill!.countermeasure.classification.fence.checked =
          data.ロードキルの情報.対策実施状況の情報.対策分類["柵・フェンス"];
        sideMenuState.value.roadkill!.countermeasure.classification.informationBoard.checked =
          data.ロードキルの情報.対策実施状況の情報.対策分類.道路情報板;
        sideMenuState.value.roadkill!.countermeasure.classification.portableSign.checked =
          data.ロードキルの情報.対策実施状況の情報.対策分類.移動式注意喚起看板;
        sideMenuState.value.roadkill!.countermeasure.classification.others.checked =
          data.ロードキルの情報.対策実施状況の情報.対策分類.その他;
        sideMenuState.value.specificSituation!.value =
          data["道路の指定・特定状況"];
        sideMenuState.value.specificSituation!.trafficCongestion.value =
          data["道路の指定・特定状況の情報"].主要渋滞箇所;
        sideMenuState.value.specificSituation!.importantLogistics.value =
          data["道路の指定・特定状況の情報"].重要物流道路;
        sideMenuState.value.specificSituation!.importantLogistics.bold =
          data["道路の指定・特定状況の情報"].重要物流道路の情報.太線表示;
        sideMenuState.value.specificSituation!.importantLogistics.dataType.logistics =
          data[
            "道路の指定・特定状況の情報"
          ].重要物流道路の情報.データ種別.全国重要物流道路;
        sideMenuState.value.specificSituation!.importantLogistics.dataType.alternative =
          data[
            "道路の指定・特定状況の情報"
          ].重要物流道路の情報.データ種別.全国代替補完路;
        sideMenuState.value.specificSituation!.specialVehicle.value =
          data["道路の指定・特定状況の情報"].特殊車両データ;
        sideMenuState.value.specificSituation!.specialVehicle.bold =
          data["道路の指定・特定状況の情報"].特殊車両データの情報.太線表示;
        sideMenuState.value.specificSituation!.specialVehicle.dataType.weightHeightDesignated =
          data["道路の指定・特定状況の情報"].特殊車両データの情報.データ種別[
            "重さ・高さ指定道路"
          ];
        sideMenuState.value.specificSituation!.specialVehicle.dataType.exampt =
          data[
            "道路の指定・特定状況の情報"
          ].特殊車両データの情報.データ種別.特車通行許可不要区間;
        sideMenuState.value.specificSituation!.specialVehicle.dataType.vehicleGuidance =
          data[
            "道路の指定・特定状況の情報"
          ].特殊車両データの情報.データ種別.大型車誘導区間;
        sideMenuState.value.specificSituation!.specialVehicle.dataType.examptXPoint =
          data["道路の指定・特定状況の情報"].特殊車両データの情報.データ種別[
            "特車通行許可不要区間(交差点)"
          ];
        changeSideMenuStateAccidentHotspot();
        changeSideMenuStateSpecificSituation();
        changeSideMenuStateRoadkill();
      }
      if (data.一般交通量調査データの情報) {
        sideMenuState.value.generalTraffic.value = data.一般交通量調査データ;
        sideMenuState.value.generalTraffic.tableType =
          data.一般交通量調査データの情報.種別;
        sideMenuState.value.generalTraffic.location.dataType =
          data.一般交通量調査データの情報.箇所別基本表.データ種別;
        sideMenuState.value.generalTraffic.location.roadCategory.generalPrefectures =
          data.一般交通量調査データの情報.箇所別基本表.道路種別[
            "一般都道府県道・指定市の一般市道"
          ];
        sideMenuState.value.generalTraffic.location.roadCategory.mainLocalRoad =
          data.一般交通量調査データの情報.箇所別基本表.道路種別[
            "主要地方道（都道府県道・指定市道）"
          ];
        sideMenuState.value.generalTraffic.location.roadCategory.generalHighwayDirectControl =
          data.一般交通量調査データの情報.箇所別基本表.道路種別[
            "一般国道（直轄）"
          ];
        sideMenuState.value.generalTraffic.location.roadCategory.generalHighwayOthers =
          data.一般交通量調査データの情報.箇所別基本表.道路種別[
            "一般国道（その他）"
          ];
        sideMenuState.value.generalTraffic.location.roadCategory.urbanHighway =
          data.一般交通量調査データの情報.箇所別基本表.道路種別.都市高速道路;
        sideMenuState.value.generalTraffic.location.roadCategory.expressNationalHighway =
          data.一般交通量調査データの情報.箇所別基本表.道路種別.高速自動車国道;
        sideMenuState.value.generalTraffic.time.specificationTime =
          data.一般交通量調査データの情報.時間帯別交通量表.時間帯;
        sideMenuState.value.generalTraffic.time.roadCategory.generalPrefectures =
          data.一般交通量調査データの情報.時間帯別交通量表.道路種別[
            "一般都道府県道・指定市の一般市道"
          ];
        sideMenuState.value.generalTraffic.time.roadCategory.mainLocalRoad =
          data.一般交通量調査データの情報.時間帯別交通量表.道路種別[
            "主要地方道（都道府県道・指定市道）"
          ];
        sideMenuState.value.generalTraffic.time.roadCategory.generalHighwayDirectControl =
          data.一般交通量調査データの情報.時間帯別交通量表.道路種別[
            "一般国道（直轄）"
          ];
        sideMenuState.value.generalTraffic.time.roadCategory.generalHighwayOthers =
          data.一般交通量調査データの情報.時間帯別交通量表.道路種別[
            "一般国道（その他）"
          ];
        sideMenuState.value.generalTraffic.time.roadCategory.urbanHighway =
          data.一般交通量調査データの情報.時間帯別交通量表.道路種別.都市高速道路;
        sideMenuState.value.generalTraffic.time.roadCategory.expressNationalHighway =
          data.一般交通量調査データの情報.時間帯別交通量表.道路種別.高速自動車国道;
        changeSideMenuStateGeneralTraffic();
      }
      switch (data.背景地図コントローラ.背景地図) {
        case 1:
          changeMap(LayerName.StdMapTile);
          break;
        case 2:
          changeMap(LayerName.PaleMapTile);
          break;
        case 3:
          changeMap(LayerName.BlankMapTile);
          break;
        case 4:
          changeMap(LayerName.SeamlessphotoMapTile);
          break;
      }
      (ev.target as any).value = "";
    } catch (e) {
      commonView.value._messageLogic.onOpenMessage(
        MessageDefine.W0010.getMessage()
      );
      (ev.target as any).value = "";
    }
  };
  reader.readAsText(file);
};

/**
 * 指定種別設定セット
 */
const setOption = (
  dataType: simpleSearchDataTypeList,
  latitude: number,
  longitude: number,
  targetDate?: Date,
  dayType?: dayTypeList
) => {
  closeSimpleSearch();
  // 全てfalseにしてから必要な箇所をセット
  endUpdateRealTimeData();
  sideMenuState.value.generalTraffic.value = false;
  sideMenuState.value.od.value = false;
  sideMenuState.value.drm.value = false;
  sideMenuState.value.roadStructures.value = false;
  sideMenuState.value.accidentHotspot.value = false;
  sideMenuState.value.roadkill!.value = false;
  sideMenuState.value.specificSituation!.value = false;

  switch (dataType) {
    case simpleSearchDataTypeList.travosRealTime5Minute:
      sideMenuState.value.travos.value = true;
      sideMenuState.value.travos.type = RADIO_TRAVOS_LIST.realTime;
      sideMenuState.value.travos.realTime.timeType =
        RADIO_TRAVOS_REALTIME_LIST.value5Minutes;
      sideMenuState.value.travos.realTime.value5Minutes.q81 = true;
      sideMenuState.value.travos.realTime.value5Minutes.qa81 = true;
      sideMenuState.value.travos.realTime.generalHighway = true;
      sideMenuState.value.travos.realTime.expressway = true;
      sideMenuState.value.etc.value = false;
      break;
    case simpleSearchDataTypeList.travosRealTime1Hour:
      sideMenuState.value.travos.value = true;
      sideMenuState.value.travos.type = RADIO_TRAVOS_LIST.realTime;
      sideMenuState.value.travos.realTime.timeType =
        RADIO_TRAVOS_REALTIME_LIST.value1Hour;
      sideMenuState.value.travos.realTime.value1Hour.q82 = true;
      sideMenuState.value.travos.realTime.value1Hour.qa82 = true;
      sideMenuState.value.travos.realTime.generalHighway = true;
      sideMenuState.value.travos.realTime.expressway = true;
      sideMenuState.value.etc.value = false;
      break;
    case simpleSearchDataTypeList.etcDrmDay:
      sideMenuState.value.etc.value = true;
      sideMenuState.value.etc.dataType = RADIO_ETC_DATA_TYPE_LIST.drmLink;
      sideMenuState.value.etc.timeType = RADIO_ETC_TIME_TYPE_LIST.day1Hour;
      sideMenuState.value.etc.expressNationalHighway = true;
      sideMenuState.value.etc.urbanHighway = true;
      sideMenuState.value.etc.generalHighway = true;
      sideMenuState.value.etc.mainLocalRoadPrefectures = true;
      sideMenuState.value.etc.mainLocalRoadDesinatedCity = true;
      sideMenuState.value.etc.generalPrefectures = true;
      sideMenuState.value.etc.generalDesinatedCity = true;
      sideMenuState.value.travos.value = false;
      break;
    case simpleSearchDataTypeList.etcDrmMonth:
      sideMenuState.value.etc.value = true;
      sideMenuState.value.etc.dataType = RADIO_ETC_DATA_TYPE_LIST.drmLink;
      sideMenuState.value.etc.timeType = RADIO_ETC_TIME_TYPE_LIST.month1Hour;
      sideMenuState.value.etc.expressNationalHighway = true;
      sideMenuState.value.etc.urbanHighway = true;
      sideMenuState.value.etc.generalHighway = true;
      sideMenuState.value.etc.mainLocalRoadPrefectures = true;
      sideMenuState.value.etc.mainLocalRoadDesinatedCity = true;
      sideMenuState.value.etc.generalPrefectures = true;
      sideMenuState.value.etc.generalDesinatedCity = true;
      switch (dayType) {
        case dayTypeList.weekday:
          sideMenuState.value.etc.dayType = RADIO_ETC_DAY_TYPE_LIST.weekday;
          break;
        case dayTypeList.holiday:
          sideMenuState.value.etc.dayType = RADIO_ETC_DAY_TYPE_LIST.holiday;
          break;
        case dayTypeList.allDay:
          sideMenuState.value.etc.dayType = RADIO_ETC_DAY_TYPE_LIST.allday;
          break;
      }
      sideMenuState.value.travos.value = false;
      break;
  }
  if (targetDate) {
    mapTime.value.year = targetDate.getFullYear().toString();
    mapTime.value.month = (targetDate.getMonth() + 1).toString();
    mapTime.value.day = targetDate.getDate().toString();
    mapTime.value.hour = targetDate.getHours();
    mapTime.value.minute = targetDate.getMinutes();
    executeMapTime.value = Object.assign({}, mapTime.value);
    mapTimeCode.value =
      mapTime.value.year.padStart(4, "0") +
      mapTime.value.month.padStart(2, "0") +
      mapTime.value.day.padStart(2, "0") +
      mapTime.value.hour.toString().padStart(2, "0") +
      mapTime.value.minute.toString().padStart(2, "0");
    executeUpdateTime(false);
  } else {
    startUpdateRealTimeData();
  }
  footerInfo.value.zoomLevel = 13;
  updateZoom();
  footerInfo.value.latitude = latitude.toString();
  footerInfo.value.longitude = longitude.toString();
  moveMap(latitude, longitude);
  changeSideMenuStateTravos();
  changeSideMenuStateGeneralTraffic();
  changeSideMenuStateEtc();
  confirmOdLimit();
  changeSideMenuStateOd();
  changeSideMenuStateDrm();
  changeSideMenuStateRoadStructures();
  changeSideMenuStateAccidentHotspot();
  changeSideMenuStateSpecificSituation();
  changeSideMenuStateRoadkill();
};

/**
 * 簡易検索を閉じる
 */
const closeSimpleSearch = () => {
  floatToggle(floatState.simpleSearch.key, false);
  simpleSearchFirstFlg.value = false;
};

/**
 * メニュー類表示状態切替
 */
const toggleDispMenu = (flg: boolean) => {
  isDispMenu.value = flg;
  if (flg) {
    document.getElementById("map").style.width = baseMapStyle.value.width;
    document.getElementById("map").style.height = baseMapStyle.value.height;
  } else {
    const mapStyle = window.getComputedStyle(document.getElementById("map"));
    baseMapStyle.value = {
      width: mapStyle.width,
      height: mapStyle.height,
    };
    baseFooterHeight.value = window.getComputedStyle(
      document.getElementById("toolFooter")
    ).height;
    document.getElementById("map").style.width =
      document.documentElement.scrollWidth + "px";
    document.getElementById("map").style.height =
      document.documentElement.scrollHeight -
      Number(baseFooterHeight.value.replace("px", "")) +
      "px";
    document.getElementById("toolFooter").style.height = baseFooterHeight.value;
  }
  _geoMap.value._map.updateSize();
};

/**
 * フッタ最新化
 */
const refreshFooter = () => {
  const displayInfo = _geoMap.value.getDisplayInfo();
  footerInfo.value = {
    latitude: displayInfo.centerLatitude?.toFixed(6),
    longitude: displayInfo.centerLongitude?.toFixed(6),
    zoomLevel: Number(displayInfo.zoomLevel.toFixed(0)),
  };
};

/**
 * 地図ジャンプ
 */
const moveMap = (latitude: number, longitude: number) => {
  _geoMap.value.moveMap(latitude, longitude);
};

/**
 * 地物の位置に地図ジャンプ
 */
const moveMapToGeometry = (geom: Geometry) => {
  _geoMap.value.moveMapToGeometry(geom);
};

/**
 * フッター地図ジャンプエラーチェック
 */
const moveMapFooter = (latitude: number, longitude: number) => {
  let errorParam: Array<string> = [];
  const MIN_LATITUDE = 20.0;
  const MAX_LATITUDE = 46.0;
  const MIN_LONGITUDE = 122.0;
  const MAX_LONGITUDE = 154.0;
  if (!latitude) {
    errorParam.push("現在位置緯度");
  } else if (!longitude) {
    errorParam.push("現在位置経度");
  }
  if (errorParam.length) {
    commonView.value._messageLogic.onOpenMessage(
      MessageDefine.W0001.getMessage(errorParam)
    );
    return;
  }
  if (latitude < MIN_LATITUDE || latitude > MAX_LATITUDE) {
    errorParam = errorParam.concat([
      "現在位置緯度",
      MIN_LATITUDE.toString() + ".00000",
      MAX_LATITUDE.toString() + ".00000",
    ]);
  } else if (longitude < MIN_LONGITUDE || longitude > MAX_LONGITUDE) {
    errorParam = errorParam.concat([
      "現在位置経度",
      MIN_LONGITUDE.toString() + ".00000",
      MAX_LONGITUDE.toString() + ".00000",
    ]);
  }
  if (errorParam.length) {
    commonView.value._messageLogic.onOpenMessage(
      MessageDefine.W0009.getMessage(errorParam)
    );
    return;
  }
  moveMap(latitude, longitude);
};

const updateZoom = (value?: string) => {
  if (value) {
    footerInfo.value.zoomLevel = Number(value);
  }
  _geoMap.value._map.getView().setZoom(footerInfo.value.zoomLevel);
};

const floatState: any = {
  calcArea: { opened: ref(false), key: "calcArea" },
  capture: { opened: ref(false), key: "capture" },
  dataDownloadMenu: { opened: ref(false), key: "dataDownloadMenu" },
  exportArea: { opened: ref(false), key: "exportArea" },
  exportBulk: { opened: ref(false), key: "exportBulk" },
  help: { opened: ref(false), key: "help" },
  address: { opened: ref(false), key: "address" },
  realTimeTraffic: { opened: ref(false), key: "realTimeTraffic" },
  simpleSearch: { opened: ref(false), key: "simpleSearch" },
  legendList: { opened: ref(false), key: "legendList" },
  termsCondition: { opened: ref(false), key: "termsCondition" },
};

const floatToggle = (key: any, isOpen?: boolean) => {
  switch (key) {
    case floatState.calcArea.key:
    case floatState.exportArea.key:
      if (isOpen) {
        endSelectedFeature();
      }
      break;
  }
  floatState[key].opened.value =
    isOpen !== undefined ? isOpen : !floatState[key].opened.value;
};

/**
 * 凡例画面を開く
 */
const floatToggleLegendList = () => {
  if (!legendListDefaultLeft.value) {
    legendListDefaultLeft.value = document.documentElement.scrollWidth - 330;
  }
  floatToggle(floatState.legendList.key, true);
};

/**
 * リアルタイム交通量（過去データ）を開く
 */
const openRealtimeHistory = (
  fid: string,
  realTimeTrafficConvert: IRealTimeTrafficConvert
) => {
  realTimeTrafficData.value = {
    realTimeTrafficConvert: realTimeTrafficConvert,
    fid: fid,
  };
  realTimeTimeCodeTraffic.value = realTimeTrafficData.value?.fid?.includes(
    "travospublic_measure_1h"
  )
    ? realTimeTimeCode1Hour.value
    : realTimeTimeCode5Minutes.value;
  floatState.realTimeTraffic.opened.value = true;
};

/**
 * リアルタイム交通量（時系列データ）をリアルタイム属性から開く
 */
const openRealtimeHistoryFromAttribute = (
  fid: string,
  searchDateAttributeConvert: ISearchDateAttributeConvert
) => {
  const layerFactory = _geoMap.value.getLayerFactory().TraVos;
  const feature = new Feature({
    geometry: searchDateAttributeConvert.getGeometry(),
  });
  feature.setId(fid);
  layerFactory.setTraVosPlayNode(feature);
  const realtimeTrafficConvert =
    layerFactory.getRealtimeTrafficConvertBySearchDateAttribute(
      searchDateAttributeConvert
    );
  openRealtimeHistory(fid, realtimeTrafficConvert);
};

/**
 * travosリアルタイム交通量対象選択通知イベント
 */
const travosPlayEvent: ITraVosPlayEvent = {
  onTraVosNodeSelected: (
    fid: string,
    realTimeTrafficConvert: IRealTimeTrafficConvert
  ) => {
    if (realTimeTrafficData.value?.fid) {
      unSelectedRealTimeTraffic(realTimeTrafficData.value.fid);
    }
    return () => {
      openRealtimeHistory(fid, realTimeTrafficConvert);
    };
  },
  onTraVosNodeUnSelected: () => {
    unSelectedRealTimeTraffic(realTimeTrafficData.value.fid);
    _geoMap.value.getLayerFactory().TraVos.clearTraVosPlayNode();
    realTimeTrafficData.value = null;
    floatState.realTimeTraffic.opened.value = false;
  },
};

/**
 * 交通量選択解除
 */
const unSelectedRealTimeTraffic = (fid: string) => {
  if (
    !historyAttributeList.value.some((ele) => {
      return ele.fid === fid;
    }) &&
    !realtimeAttributeList.value.some((ele) => {
      return ele.fid === fid;
    })
  ) {
    _geoMap.value.unSelectedFeature(fid);
  }
};

/**
 * OD量データ表示開始・終了時イベント
 */
const odDisplayEvent: IOdDisplayEvent = {
  onOdNodeSelected: (
    startNode: string,
    startFeature: Feature,
    attributeConverter: ODNodeAttributeConvert
  ) => {
    isDisplayOdData.value = true;
    odParam.value = {
      startNode,
      startFeature,
      attributeConverter,
    };
  },
  onOdNodeUnSelected: (unselectFlag: boolean) => {
    isDisplayOdData.value = false;
    odParam.value = {
      startNode: null,
      startFeature: null,
      attributeConverter: null,
    };
    // OD量データ表示解除時にOD量の属性画面を閉じる
    const targetTypeArray: FeatureType[] = [
      FeatureType.ODArrivalNode,
      FeatureType.ODNode,
      FeatureType.ODRangeNode,
    ];
    if (unselectFlag) {
      attributeList.value.forEach((ele) => {
        if (targetTypeArray.includes(ele.attributeConvert.getFeatureType())) {
          deleteAttribute(ele.fid, AttributeType.Normal);
        }
      });
    }
  },
};

/**
 * リアルタイム交通量タイトル変更
 */
const changeRealTimeTrafficTitle = (title: string) => {
  realTimeTrafficData.value.title = title;
};

/**
 * リアルタイム交通量削除
 */
const deleteRealTimeTrafficData = () => {
  travosPlayEvent.onTraVosNodeUnSelected();
};

/**
 * 地物選択モード開始
 */
const startSelectedFeature = () => {
  _geoMap.value.startSelectedFeature(
    (featureAttribute: SelectedFeatureInfo) => {
      const attributeConvert = featureAttribute.attributeConvert;
      if (
        attributeConvert &&
        !attributeList.value.some((ele) => {
          return ele.fid === featureAttribute.featureGeoJson.fid;
        }) &&
        !historyAttributeList.value.some((ele) => {
          return ele.fid === featureAttribute.featureGeoJson.fid;
        }) &&
        !realtimeAttributeList.value.some((ele) => {
          return ele.fid === featureAttribute.featureGeoJson.fid;
        }) &&
        !imageAttributeList.value.some((ele) => {
          return ele.fid === featureAttribute.featureGeoJson.fid;
        })
      ) {
        if (
          attributeList.value.length +
            realtimeAttributeList.value.length +
            historyAttributeList.value.length +
            imageAttributeList.value.length >=
          MAX_ATTRIBUTE
        ) {
          _geoMap.value.unSelectedFeature(featureAttribute.featureGeoJson.fid);
          commonView.value._messageLogic.onOpenMessage(
            MessageDefine.W0011.getMessage([MAX_ATTRIBUTE])
          );
          return false;
        }
        switch (featureAttribute.attributeType) {
          case AttributeType.Normal:
            attributeList.value.push({
              fid: featureAttribute.featureGeoJson.fid,
              attributeConvert: attributeConvert as IAttributeConvert,
              isOpen: true,
            });
            break;
          case AttributeType.RealTime:
            realtimeAttributeList.value.push({
              fid: featureAttribute.featureGeoJson.fid,
              searchDateAttributeConvert:
                attributeConvert as ISearchDateAttributeConvert,
              isOpen: true,
            });
            break;
          case AttributeType.History:
            if (attributeTimeCode.value) {
              (attributeConvert as ISearchDateAttributeConvert)
                .load(attributeTimeCode.value)
                .then((res: ISearchDateAttributeConvert) => {
                  historyAttributeList.value.push({
                    fid: featureAttribute.featureGeoJson.fid,
                    searchDateAttributeConvert:
                      attributeConvert as ISearchDateAttributeConvert,
                    compareHistoryAttributeConvert: res,
                    isOpen: true,
                  });
                })
                .catch((e: ServerError) => {
                  commonView.value._messageLogic.onOpenMessage(
                    MessageDefine.E0001.getMessage([e._url, e._status])
                  );
                });
            } else {
              historyAttributeList.value.push({
                fid: featureAttribute.featureGeoJson.fid,
                searchDateAttributeConvert:
                  attributeConvert as ISearchDateAttributeConvert,
                isOpen: true,
              });
            }
            break;
          case AttributeType.Image:
            imageAttributeList.value.push({
              fid: featureAttribute.featureGeoJson.fid,
              attributeConvert: attributeConvert as IAttributeImageConvert,
              isOpen: true,
            });
            break;
        }
        return true;
      }
      return false;
    },
    travosPlayEvent,
    odDisplayEvent
  );
};

/**
 * 地物選択モード終了
 */
const endSelectedFeature = () => {
  _geoMap.value.endSelectedFeature();
};

/**
 * 属性消去
 */
const deleteAttribute = (targetFid: string, type: AttributeType) => {
  switch (type) {
    case AttributeType.Normal:
      attributeList.value = attributeList.value.filter(
        (ele) => ele.fid !== targetFid
      );
      break;
    case AttributeType.RealTime:
      realtimeAttributeList.value = realtimeAttributeList.value.filter(
        (ele) => ele.fid !== targetFid
      );
      break;
    case AttributeType.History:
      historyAttributeList.value = historyAttributeList.value.filter(
        (ele) => ele.fid !== targetFid
      );
      break;
    case AttributeType.Image:
      imageAttributeList.value = imageAttributeList.value.filter(
        (ele) => ele.fid !== targetFid
      );
      break;
  }
  if (targetFid.startsWith("t_od_stzone")) {
    _geoMap.value.getLayerFactory().ODNode.onUnSelectedStartNode();
  }
  if (
    !floatState.realTimeTraffic.opened.value ||
    _geoMap.value.getLayerFactory().TraVos.getTraVosPlayNodeFid() !== targetFid
  ) {
    _geoMap.value.unSelectedFeature(targetFid);
  }
};

/**
 * 左メニュー最上位チェックオフ時属性消去
 */
const deleteAttributeByMenu = (rootLayerType: RootLayerType) => {
  const targetTypeArray: FeatureType[] =
    getFeatureTypeListByRootLayerType(rootLayerType);
  attributeList.value.forEach((ele) => {
    if (targetTypeArray.includes(ele.attributeConvert.getFeatureType())) {
      deleteAttribute(ele.fid, AttributeType.Normal);
    }
  });
  realtimeAttributeList.value.forEach((ele) => {
    if (
      targetTypeArray.includes(ele.searchDateAttributeConvert.getFeatureType())
    ) {
      deleteAttribute(ele.fid, AttributeType.RealTime);
    }
  });
  historyAttributeList.value.filter((ele) => {
    if (
      targetTypeArray.includes(ele.searchDateAttributeConvert.getFeatureType())
    ) {
      deleteAttribute(ele.fid, AttributeType.History);
    }
  });
  imageAttributeList.value.filter((ele) => {
    if (targetTypeArray.includes(ele.attributeConvert.getFeatureType())) {
      deleteAttribute(ele.fid, AttributeType.Image);
    }
  });
  if (
    rootLayerType === RootLayerType.Travos &&
    floatState.realTimeTraffic.opened.value
  ) {
    deleteRealTimeTrafficData();
  }
};

/**
 * OD交通量属性画面閉じ
 */
const closeOdAttribute = () => {
  const targetTypeArray = [FeatureType.ODArrivalNode, FeatureType.ODNode];
  attributeList.value.forEach((ele) => {
    if (targetTypeArray.includes(ele.attributeConvert.getFeatureType())) {
      deleteAttribute(ele.fid, AttributeType.Normal);
    }
  });
};

/**
 * 日時コントローラ地図・属性表示時間入力内容更新
 */
const updateMapTime = (time: any) => {
  mapTime.value = time;
};

/**
 * 日時コントローラ属性比較表示入力内容更新
 */
const updateAttributeTime = (time: any) => {
  attributeTime.value = time;
};

/**
 * 日時コントローラ更新実行
 */
const executeUpdateTime = async (errorCheckFlg?: boolean) => {
  if (errorCheckFlg) {
    let errorParam;
    if (
      (sideMenuState.value.travos.value &&
        sideMenuState.value.travos.type === RADIO_TRAVOS_LIST.history) ||
      sideMenuState.value.etc.value
    ) {
      if (!mapTime.value.year) {
        errorParam = "年月日（地図・属性）";
      }
    }
    if (!errorParam) {
      if (
        ((sideMenuState.value.travos.value &&
          sideMenuState.value.travos.type === RADIO_TRAVOS_LIST.history) ||
          sideMenuState.value.etc.value) &&
        (attributeTime.value.hour || attributeTime.value.minute)
      ) {
        if (!attributeTime.value.year) {
          errorParam = "年月日（属性）";
        }
      }
    }
    if (errorParam) {
      commonView.value._messageLogic.onOpenMessage(
        MessageDefine.W0001.getMessage([errorParam])
      );
      return;
    }
  }

  mapTimeCode.value =
    mapTime.value.year.padStart(4, "0") +
    mapTime.value.month.padStart(2, "0") +
    mapTime.value.day.padStart(2, "0") +
    mapTime.value.hour.toString().padStart(2, "0") +
    mapTime.value.minute.toString().padStart(2, "0");
  attributeTimeCode.value = null;
  if (
    attributeTime.value.year != "" &&
    attributeTime.value.month != "" &&
    (attributeTime.value.day != "" ||
      !historyAttributeList.value.some(
        (ele) => !ele.fid.startsWith("t_etc_probe_drm_lnk_1m")
      ))
  ) {
    attributeTimeCode.value =
      attributeTime.value.year.padStart(2, "0") +
      attributeTime.value.month.padStart(2, "0") +
      attributeTime.value.day.padStart(2, "0") +
      attributeTime.value.hour.toString().padStart(2, "0") +
      attributeTime.value.minute.toString().padStart(2, "0");
  }

  if (errorCheckFlg) {
    let messageList: string[] = [];

    if (
      sideMenuState.value.travos.value &&
      sideMenuState.value.travos.type === RADIO_TRAVOS_LIST.history
    ) {
      // Travos過去
      if (
        sideMenuState.value.travos.history.timeType ===
        RADIO_TRAVOS_HISTORY_LIST.measured1Hour
      ) {
        if (sideMenuState.value.travos.history.measured1Hour.q82) {
          messageList = messageList.concat(
            checkDateRange(
              "交通量データ1時間値(常時観測データ計測値)常設トラカン(様式Q-8-2)",
              dateRangesData.value.travosHistoryMeasured1HourQ82,
              UPDATE_BUFFER_1HOUR
            )
          );
        }
        if (sideMenuState.value.travos.history.measured1Hour.qa82) {
          messageList = messageList.concat(
            checkDateRange(
              "交通量データ1時間値(常時観測データ計測値)CCTVトラカン(様式QA-8-2)",
              dateRangesData.value.travosHistoryMeasured1HourQa82,
              UPDATE_BUFFER_1HOUR
            )
          );
        }
      }
    }

    if (sideMenuState.value.etc.value) {
      // ETC
      if (
        sideMenuState.value.etc.dataType === RADIO_ETC_DATA_TYPE_LIST.drmLink
      ) {
        switch (sideMenuState.value.etc.timeType) {
          case RADIO_ETC_TIME_TYPE_LIST.day15Minutes:
            messageList = messageList.concat(
              checkDateRange(
                "ETC2.0確定値DRMリンク日別15分単位",
                dateRangesData.value.etcDrmLinkDay15Minutes
              )
            );
            break;
          case RADIO_ETC_TIME_TYPE_LIST.day1Hour:
            messageList = messageList.concat(
              checkDateRange(
                "ETC2.0確定値DRMリンク日別時間帯別",
                dateRangesData.value.etcDrmLinkDay1Hour
              )
            );
            break;
          case RADIO_ETC_TIME_TYPE_LIST.month1Hour:
            messageList = messageList.concat(
              checkDateRange(
                "ETC2.0確定値DRMリンク月別時間帯別",
                dateRangesData.value.etcDrmLinkMonth1Hour
              )
            );
            break;
        }
      } else {
        switch (sideMenuState.value.etc.timeType) {
          case RADIO_ETC_TIME_TYPE_LIST.day15Minutes:
            messageList = messageList.concat(
              checkDateRange(
                "ETC2.0確定値交通調査基本区間日別15分単位",
                dateRangesData.value.etcBasicSectionDay15Minutes
              )
            );
            break;
          case RADIO_ETC_TIME_TYPE_LIST.day1Hour:
            messageList = messageList.concat(
              checkDateRange(
                "ETC2.0確定値交通調査基本区間日別時間帯別",
                dateRangesData.value.etcBasicSectionDay1Hour
              )
            );
            break;
          case RADIO_ETC_TIME_TYPE_LIST.month1Hour:
            messageList = messageList.concat(
              checkDateRange(
                "ETC2.0確定値交通調査基本区間月別時間帯別",
                dateRangesData.value.etcBasicSectionMonth1Hour
              )
            );
            break;
        }
      }
    }

    if (messageList.join("") !== "") {
      const baseMessage = MessageDefine.I0002.getMessage();
      commonView.value._messageLogic.onOpenMessage(
        new Message(
          baseMessage.level,
          baseMessage.id,
          MessageDefine.I0003.getMessage().message + messageList.join("")
        )
      );
    } else {
      commonView.value._isDispLoading = true;
      setTimeout(() => {
        commonView.value._isDispLoading = false;
      }, 500);
    }
  }
  changeSideMenuStateTravos();
  changeSideMenuStateEtc();
  executeMapTime.value = Object.assign({}, mapTime.value);
  executeAttributeTime.value = Object.assign({}, attributeTime.value);
  historyAttributeList.value.forEach((ele) => {
    ele.searchDateAttributeConvert
      ?.load(mapTimeCode.value)
      .then((res: ISearchDateAttributeConvert) => {
        ele.searchDateAttributeConvert = res;
      })
      .catch((e: ServerError) => {
        commonView.value._messageLogic.onOpenMessage(
          MessageDefine.E0001.getMessage([e._url, e._status])
        );
      });
    if (attributeTimeCode.value) {
      ele.searchDateAttributeConvert
        .load(attributeTimeCode.value)
        .then((res: ISearchDateAttributeConvert) => {
          ele.compareHistoryAttributeConvert = res;
        })
        .catch((e: ServerError) => {
          commonView.value._messageLogic.onOpenMessage(
            MessageDefine.E0001.getMessage([e._url, e._status])
          );
        });
    }
  });
};

/**
 * 日時範囲判定
 */
const checkDateRange = (
  layerName: string,
  dateRangeData: dateRange,
  realTimeEndbuffer?: number
) => {
  const localeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  };

  const minDateTimeCode = getTimeCode(dateRangeData.mindate);
  let maxDateTimeCode;
  if (realTimeEndbuffer) {
    dateRangeData.maxdate = new Date();
    dateRangeData.maxdate.setMinutes(
      dateRangeData.maxdate.getMinutes() - realTimeEndbuffer
    );
    dateRangeData.maxdate.setMinutes(0);
  }
  maxDateTimeCode = getTimeCode(dateRangeData.maxdate);

  if (
    mapTimeCode.value > maxDateTimeCode ||
    mapTimeCode.value < minDateTimeCode
  ) {
    return MessageDefine.I0002.getMessage([
      layerName,
      dateRangeData.mindate?.toLocaleString("ja-JP", localeOptions),
      dateRangeData.maxdate?.toLocaleString("ja-JP", localeOptions),
    ]).message;
  }
};

/**
 * 時間コード変換
 */
const getTimeCode = (date: Date) => {
  return (
    date.getFullYear().toString() +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    date.getDate().toString().padStart(2, "0") +
    date.getHours().toString().padStart(2, "0") +
    date.getMinutes().toString().padStart(2, "0")
  );
};

/**
 * 最新データ更新処理開始
 */
const startUpdateRealTimeData = () => {
  isUpdateRealTimeData.value = true;
  realTimeInterval = setInterval(() => {
    changeSideMenuStateTravos();
    realtimeAttributeList.value.forEach(async (ele) => {
      const realTimeTimeCode = ele.fid.includes("travospublic_measure_1h")
        ? realTimeTimeCode1Hour.value
        : realTimeTimeCode5Minutes.value;
      await ele.searchDateAttributeConvert
        .load(realTimeTimeCode)
        .then((res: ISearchDateAttributeConvert) => {
          ele.searchDateAttributeConvert = res;
        })
        .catch((e: ServerError) => {
          endUpdateRealTimeData();
          commonView.value._messageLogic.onOpenMessage(
            MessageDefine.E0001.getMessage([e._url, e._status])
          );
        });
    });
  }, 60 * 1000);
};

/**
 * 最新データ更新処理終了
 */
const endUpdateRealTimeData = () => {
  clearInterval(realTimeInterval);
  isUpdateRealTimeData.value = false;
};

/**
 * 画面キャプチャ枠表示
 */
const showCaptureFrame = (rectWidth: number, rectHeight: number) => {
  _geoMap.value.showCaptureFrame(rectWidth, rectHeight);
};

/**
 * 画面キャプチャ枠非表示
 */
const hideCaptureFrame = () => {
  _geoMap.value.hideCaptureFrame();
};

/**
 * CSV出力
 */
const exportCsv = (
  ...attributeConvert: (IAttributeConvert | ISearchDateAttributeConvert)[]
) => {
  let isExportFileDate = false;
  if (!exportFileDate) {
    exportFileDate = ExportUtil.exportFileDate();
    isExportFileDate = true;
  }
  const csvHeader =
    attributeConvert[0]
      .getViewFormatData()
      .attributeValues.map((ele: AttributeValue) => {
        return '"' + ele.key + '"';
      })
      .join(",") + "\n";
  let csvRow = "";
  attributeConvert.forEach((ele) => {
    if (ele) {
      csvRow +=
        ele
          .getViewFormatData()
          .attributeValues.map((ele: AttributeValue) => {
            if (
              ele.value === null ||
              ele.value === undefined ||
              String(ele.value).replaceAll(" ", "") === ""
            ) {
              ele.value = "-";
            }
            return '"' + ele.value + '"';
          })
          .join(",") + "\n";
    }
  });
  // バイトオーダーマーク：文字コードの判別（UTF-8）
  const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([bom, csvHeader + csvRow], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = attributeConvert[0]
    .getExportValue()
    .csvFileName.replace("yyyyMMdd_HHmmss", exportFileDate);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
  if (isExportFileDate) exportFileDate = null;
};

/**
 * JSON出力
 */
const exportJson = (
  ...attributeConvert: (IAttributeConvert | ISearchDateAttributeConvert)[]
) => {
  let isExportFileDate = false;
  if (!exportFileDate) {
    exportFileDate = ExportUtil.exportFileDate();
    isExportFileDate = true;
  }
  let featuresArray: Feature[] = [];
  let attributeValuesArray: AttributeValue[][] = [];

  attributeConvert.forEach((item) => {
    const exportValue = item.getExportValue();
    featuresArray.push(exportValue.feature);
    attributeValuesArray.push([...exportValue.attributeValues]);
  });

  const jsonString = ExportUtil.toJsonFormat(
    featuresArray,
    attributeValuesArray
  );

  const blob = new Blob([jsonString], { type: "application/json" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = attributeConvert[0]
    .getExportValue()
    .jsonFileName.replace("yyyyMMdd_HHmmss", exportFileDate);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
  exportFileDate = null;
  if (isExportFileDate) exportFileDate = null;
};

/**
 * 一括出力
 */
const exportBulk = (format: string) => {
  commonView.value._loadingLogic.onOpenLoading();
  exportFileDate = ExportUtil.exportFileDate();

  let exportMethod: any;
  switch (format) {
    case "CSV":
      exportMethod = exportCsv;
      break;
    case "GeoJSON":
      exportMethod = exportJson;
      break;
  }

  // 対象属性画面コンバータ抽出・ソート
  const attributeArray = [
    ...attributeList.value.map((item) => item.attributeConvert),
    ...realtimeAttributeList.value.map(
      (item) => item.searchDateAttributeConvert
    ),
    ...historyAttributeList.value
      .filter((item) => {
        return item.searchDateAttributeConvert.getGeometry();
      })
      .flatMap((item) => {
        if (item.compareHistoryAttributeConvert && format == "CSV") {
          return [
            item.searchDateAttributeConvert,
            item.compareHistoryAttributeConvert,
          ];
        } else {
          return [item.searchDateAttributeConvert];
        }
      }),
  ];
  const exportableFeatureTypeArray = getExportableFeatureType();
  const filteredArray = attributeArray.filter((item) => {
    return exportableFeatureTypeArray.includes(item.getFeatureType());
  });
  if (filteredArray.length) {
    filteredArray.sort(
      (a, b) =>
        exportableFeatureTypeArray.indexOf(a.getFeatureType()) -
        exportableFeatureTypeArray.indexOf(b.getFeatureType())
    );

    let targetAttributes: IAttributeConvert[] = [];
    filteredArray.forEach((item) => {
      if (
        targetAttributes.length &&
        item.getFeatureType() !== targetAttributes.at(-1).getFeatureType()
      ) {
        exportMethod(...targetAttributes);
        targetAttributes.length = 0;
      }
      targetAttributes.push(item);
    });
    exportMethod(...targetAttributes);
  } else {
    commonView.value._messageLogic.onOpenMessage(
      MessageDefine.W0019.getMessage([])
    );
  }

  exportFileDate = null;
  commonView.value._loadingLogic.onCloseLoading();
};

/*
 * 市区町村選択モード開始
 */
const handleExportArea = async () => {
  floatToggle(floatState.exportArea.key, true);
};

/**
 * メッセージタイトル初期化
 */
const closeMessage = (index: number) => {
  messageTitle.value = null;
  commonView.value._messageObject.splice(index, 1);
};

/**
 * サイドメニュー作成
 */
const createSideMenu = async () => {
  await fetch(
    process.env.VUE_APP_YEAR_BASE_URL + process.env.VUE_APP_ACC_YEAR_URL
  )
    .then((res) => {
      if (res?.status === 404) {
        return null;
      }
      return res?.json();
    })
    .then((res) => {
      res.year?.forEach((ele: any) => {
        sideMenuState.value.accidentHotspot.year[ele.value] = {
          value: ele.value,
          label: ele.label,
          checked: ele.checked,
        };
      });
    })
    .catch((e) => {
      commonView.value._messageLogic.onOpenMessage(
        MessageDefine.E0002.getMessage([e])
      );
    });

  await fetch(
    process.env.VUE_APP_YEAR_BASE_URL + process.env.VUE_APP_RKIL_YEAR_URL
  )
    .then((res) => {
      if (res?.status === 404) {
        return null;
      }
      return res?.json();
    })
    .then((res) => {
      res.year?.forEach((ele: any) => {
        sideMenuState.value.roadkill!.occurrences.year[ele.value] = {
          value: ele.value,
          label: ele.label,
          checked: ele.checked,
        };
      });
    })
    .catch((e) => {
      commonView.value._messageLogic.onOpenMessage(
        MessageDefine.E0002.getMessage([e])
      );
    });
};

// /**
//  * 全選択・全解除
//  */
// const selectAll = (
//   buttonList: { text: string; key: string; value: string }[],
//   sideMenu: any,
//   state: boolean,
//   changeStateFunction: () => void
// ) => {
//   buttonList.forEach((target) => {
//     sideMenu[target.key] = state;
//   });
//   changeStateFunction();
// };

/**
 * TraVoS過去データ道路種別全選択・解除
 */
const travosHistoryRoadTypeSelectAll = (state: boolean) => {
  sideMenuState.value.travos.history.generalHighway = state;
  sideMenuState.value.travos.history.expressway = state;
  changeSideMenuStateTravos();
};

/**
 * TraVoS最新データ道路種別全選択・解除
 */
const travosRealTimeRoadTypeSelectAll = (state: boolean) => {
  sideMenuState.value.travos.realTime.generalHighway = state;
  sideMenuState.value.travos.realTime.expressway = state;
  changeSideMenuStateTravos();
};

/**
 * ETC2.0道路種別全選択・解除
 */
const etcRoadTypeSelectAll = (state: boolean) => {
  sideMenuState.value.etc.expressNationalHighway = state;
  sideMenuState.value.etc.urbanHighway = state;
  sideMenuState.value.etc.generalHighway = state;
  sideMenuState.value.etc.mainLocalRoadPrefectures = state;
  sideMenuState.value.etc.mainLocalRoadDesinatedCity = state;
  sideMenuState.value.etc.generalPrefectures = state;
  sideMenuState.value.etc.generalDesinatedCity = state;
  changeSideMenuStateEtc();
};

/**
 * 点検DB施設区分全選択・解除
 */
const roadStructuresFacilityTypeSelectAll = (state: boolean) => {
  sideMenuState.value.roadStructures.facilityType.bridges = state;
  sideMenuState.value.roadStructures.facilityType.tunnels = state;
  sideMenuState.value.roadStructures.facilityType.sheds = state;
  sideMenuState.value.roadStructures.facilityType.culverts = state;
  sideMenuState.value.roadStructures.facilityType.pedestrianDecks = state;
  sideMenuState.value.roadStructures.facilityType.overheadSignages = state;
  sideMenuState.value.roadStructures.facilityType.pavements = state;
  sideMenuState.value.roadStructures.facilityType.earthworks = state;
  changeSideMenuStateRoadStructures();
};

/**
 * 点検DB管理者区分全選択・解除
 */
const roadStructuresAdminTypeSelectAll = (state: boolean) => {
  sideMenuState.value.roadStructures.adminType.country.checked = state;
  sideMenuState.value.roadStructures.adminType.prefectures.checked = state;
  sideMenuState.value.roadStructures.adminType.roadPublic.checked = state;
  sideMenuState.value.roadStructures.adminType.orderedCity.checked = state;
  sideMenuState.value.roadStructures.adminType.municipalities.checked = state;
  sideMenuState.value.roadStructures.adminType.expressway.checked = state;
  changeSideMenuStateRoadStructures();
};

/**
 * 点検DB健全性全選択・解除
 */
const roadStructuresSoundnessSelectAll = (state: boolean) => {
  sideMenuState.value.roadStructures.soundness.one.checked = state;
  sideMenuState.value.roadStructures.soundness.two.checked = state;
  sideMenuState.value.roadStructures.soundness.three.checked = state;
  sideMenuState.value.roadStructures.soundness.four.checked = state;
  sideMenuState.value.roadStructures.soundness.notInspected.checked = state;
  changeSideMenuStateRoadStructures();
};

/**
 * 点検DB措置状況全選択・解除
 */
const roadStructuresMeasuresSelectAll = (state: boolean) => {
  sideMenuState.value.roadStructures.measures.unnecessary.checked = state;
  sideMenuState.value.roadStructures.measures.notStarted.checked = state;
  sideMenuState.value.roadStructures.measures.started.checked = state;
  sideMenuState.value.roadStructures.measures.completed.checked = state;
  sideMenuState.value.roadStructures.measures.notInspected.checked = state;
  changeSideMenuStateRoadStructures();
};

/**
 * DRM-DBノード/リンク全選択・解除
 */
const drmNodeLinkSelectAll = (state: boolean) => {
  sideMenuState.value.drm.node = state;
  changeSideMenuStateDrm("node");
  sideMenuState.value.drm.link = state;
  changeSideMenuStateDrm("link");
};

/**
 * 交通事故統計情報年度全選択・解除
 */
const accidentHotspotYearSelectAll = (state: boolean) => {
  Object.values(sideMenuState.value.accidentHotspot.year).forEach(
    (ele: any) => {
      ele.checked = state;
    }
  );
  changeSideMenuStateAccidentHotspot();
};

/**
 * 交通事故統計情報事故内容全選択・解除
 */
const accidentHotspotAccidentDetailsSelectAll = (state: boolean) => {
  sideMenuState.value.accidentHotspot.accidentDetails.death.checked = state;
  sideMenuState.value.accidentHotspot.accidentDetails.injury.checked = state;
  changeSideMenuStateAccidentHotspot();
};

/**
 * 交通事故統計情報事故類型全選択・解除
 */
const accidentHotspotAccidentTypeSelectAll = (state: boolean) => {
  sideMenuState.value.accidentHotspot.accidentType.peopleVehicles.checked =
    state;
  sideMenuState.value.accidentHotspot.accidentType.vehicleMutual.checked =
    state;
  sideMenuState.value.accidentHotspot.accidentType.vehicleAlone.checked = state;
  sideMenuState.value.accidentHotspot.accidentType.train.checked = state;
  changeSideMenuStateAccidentHotspot();
};

/**
 * 交通事故統計情報当事者種別（当事者A）全選択・解除
 */
const accidentHotspotPartyTypeASelectAll = (state: boolean) => {
  sideMenuState.value.accidentHotspot.partyTypeA.pedestrian.checked = state;
  sideMenuState.value.accidentHotspot.partyTypeA.bicycle.checked = state;
  sideMenuState.value.accidentHotspot.partyTypeA.motorcycle.checked = state;
  sideMenuState.value.accidentHotspot.partyTypeA.car.checked = state;
  sideMenuState.value.accidentHotspot.partyTypeA.others.checked = state;
  changeSideMenuStateAccidentHotspot();
};

/**
 * 交通事故統計情報当事者種別（当事者B）全選択・解除
 */
const accidentHotspotPartyTypeBSelectAll = (state: boolean) => {
  sideMenuState.value.accidentHotspot.partyTypeB.pedestrian.checked = state;
  sideMenuState.value.accidentHotspot.partyTypeB.bicycle.checked = state;
  sideMenuState.value.accidentHotspot.partyTypeB.motorcycle.checked = state;
  sideMenuState.value.accidentHotspot.partyTypeB.car.checked = state;
  sideMenuState.value.accidentHotspot.partyTypeB.others.checked = state;
  changeSideMenuStateAccidentHotspot();
};

/**
 * 交通事故統計情報年代別（当事者A）全選択・解除
 */
const accidentHotspotAgeASelectAll = (state: boolean) => {
  sideMenuState.value.accidentHotspot.ageA.from0To24.checked = state;
  sideMenuState.value.accidentHotspot.ageA.from25To64.checked = state;
  sideMenuState.value.accidentHotspot.ageA.over65.checked = state;
  sideMenuState.value.accidentHotspot.ageA.unknown.checked = state;
  changeSideMenuStateAccidentHotspot();
};

/**
 * 交通事故統計情報年代別（当事者B）全選択・解除
 */
const accidentHotspotAgeBSelectAll = (state: boolean) => {
  sideMenuState.value.accidentHotspot.ageB.from0To24.checked = state;
  sideMenuState.value.accidentHotspot.ageB.from25To64.checked = state;
  sideMenuState.value.accidentHotspot.ageB.over65.checked = state;
  sideMenuState.value.accidentHotspot.ageB.unknown.checked = state;
  changeSideMenuStateAccidentHotspot();
};

/**
 * ロードキル発生状況動物種全選択・解除
 */
const roadkillOccurrencesAnimalSelectAll = (target: any, state: boolean) => {
  const selectAllChild = (subTarget: any) => {
    for (const key in subTarget) {
      if (typeof subTarget[key] === "object" && subTarget[key] !== null) {
        selectAllChild(subTarget[key]);
      }
      if (key === "checked") {
        subTarget[key] = state;
      }
    }
  };

  selectAllChild(target);
  changeSideMenuStateRoadkill();
};

/**
 * ロードキル発生状況発生年全選択・解除
 */
const roadkillOccurrencesYearSelectAll = (state: boolean) => {
  Object.values(sideMenuState.value.roadkill!.occurrences.year).forEach(
    (ele: any) => {
      ele.checked = state;
    }
  );
  changeSideMenuStateRoadkill();
};

/**
 * ロードキル対策実施状況対策分類全選択・解除
 */
const roadkillCountermeasureClassificationSelectAll = (state: boolean) => {
  sideMenuState.value.roadkill!.countermeasure.classification.warningSign.checked =
    state;
  sideMenuState.value.roadkill!.countermeasure.classification.roadMarking.checked =
    state;
  sideMenuState.value.roadkill!.countermeasure.classification.underpass.checked =
    state;
  sideMenuState.value.roadkill!.countermeasure.classification.signboard.checked =
    state;
  sideMenuState.value.roadkill!.countermeasure.classification.fence.checked =
    state;
  sideMenuState.value.roadkill!.countermeasure.classification.informationBoard.checked =
    state;
  sideMenuState.value.roadkill!.countermeasure.classification.portableSign.checked =
    state;
  sideMenuState.value.roadkill!.countermeasure.classification.others.checked =
    state;
  changeSideMenuStateRoadkill();
};

/**
 * 道路の指定・特定状況重要物流道路データ種別全選択・解除
 */
const specificSituationImportantLogisticsSelectAll = (state: boolean) => {
  sideMenuState.value.specificSituation!.importantLogistics.dataType.logistics =
    state;
  sideMenuState.value.specificSituation!.importantLogistics.dataType.alternative =
    state;
  changeSideMenuStateSpecificSituation("importantLogistics");
};

/**
 * 道路の指定・特定状況特殊車両データ種別全選択・解除
 */
const specificSituationSpecialVehicleSelectAll = (state: boolean) => {
  sideMenuState.value.specificSituation!.specialVehicle.dataType.weightHeightDesignated =
    state;
  sideMenuState.value.specificSituation!.specialVehicle.dataType.exampt = state;
  sideMenuState.value.specificSituation!.specialVehicle.dataType.vehicleGuidance =
    state;
  sideMenuState.value.specificSituation!.specialVehicle.dataType.examptXPoint =
    state;
  changeSideMenuStateSpecificSituation("specialVehicle");
};

/**
 * 約款同意
 */
const confirmTermsCondition = () => {
  termsConfirmed.value = true;
  floatToggle(floatState.termsCondition.key);
};

/**
 * 約款同意時初期処理
 */
const initialize = async () => {
  commonView.value._isDispLoading = true;
  document.addEventListener("contextmenu", (e) => {
    e.preventDefault();
  });
  const randStr = Math.random().toString(36).substring(2).slice(-7);
  const openSimpleSearch = () => {
    floatToggle(floatState.simpleSearch.key, true);
  };
  await fetch(process.env.VUE_APP_MAINTENANCE_MESSAGE_URL + "?token=" + randStr)
    .then((res) => {
      if (res?.status === 404) {
        return null;
      }
      return res?.json();
    })
    .then((res) => {
      if (res?.isDisp) {
        messageTitle.value = res.title;
        commonView.value._messageLogic.onOpenMessage(
          new Message(
            res.level || "INFO",
            "maintenance",
            res.message.toString()
          ),
          false,
          openSimpleSearch,
          openSimpleSearch
        );
      }
    })
    .catch((e) => {
      commonView.value._messageLogic.onOpenMessage(
        MessageDefine.E0002.getMessage([e])
      );
    });
  _geoMap.value.initMap(
    37.387617,
    140.3833,
    5,
    commonView.value as unknown as ICommonView,
    () => {
      refreshFooter();
    },
    refreshFooter
  );
  changeMap(LayerName.PaleMapTile);
  createSideMenu();
  changeSideMenuStateTravos();
  changeSideMenuStateGeneralTraffic();
  changeSideMenuStateEtc();
  changeSideMenuStateOd();
  changeSideMenuStateDrm();
  changeSideMenuStateRoadStructures();
  changeSideMenuStateAccidentHotspot();
  changeSideMenuStateSpecificSituation();
  changeSideMenuStateRoadkill();
  refreshFooter();
  startSelectedFeature();

  await fetch(process.env.VUE_APP_MANUAL_DATA_URL)
    .then((res) => {
      if (res?.status === 404) {
        return null;
      }
      return res?.json();
    })
    .then((res) => {
      helpFiles.value = res.file?.map((ele: any) => {
        return {
          name: ele.manualName,
          file: {
            name: ele.fileName + ".pdf",
            href: process.env.VUE_APP_HELP_FOLDER + ele.fileName + ".pdf",
            target: "_blank",
          },
          size: ele.size,
        };
      });
    })
    .catch((e) => {
      commonView.value._messageLogic.onOpenMessage(
        MessageDefine.E0002.getMessage([e])
      );
    });

  // データ日時範囲取得
  class layerParam {
    jsonUrl: string;
    layerName: string;
    realTimeEndbuffer?: number;
    constructor(
      jsonUrl: string,
      layerName: string,
      realTimeEndbuffer?: number
    ) {
      this.jsonUrl = jsonUrl;
      this.layerName = layerName;
      this.realTimeEndbuffer = realTimeEndbuffer;
    }
  }
  const layerParamArray: layerParam[] = [
    new layerParam(
      process.env.VUE_APP_DATE_RANGE_BASE_URL +
        process.env.VUE_APP_DATE_RANGE_TRAVOS_MEASURE_1H_URL,
      "交通量データ1時間値(常時観測データ計測値)常設トラカン(様式Q-8-2)",
      UPDATE_BUFFER_1HOUR
    ),
    new layerParam(
      process.env.VUE_APP_DATE_RANGE_BASE_URL +
        process.env.VUE_APP_DATE_RANGE_TRAVOS_MEASURE_1H_IMG_URL,
      "交通量データ1時間値(常時観測データ計測値)CCTVトラカン(様式QA-8-2)",
      UPDATE_BUFFER_1HOUR
    ),
    new layerParam(
      process.env.VUE_APP_DATE_RANGE_BASE_URL +
        process.env.VUE_APP_DATE_RANGE_ETC_DRM_LNK_15M_URL,
      "ETC2.0確定値DRMリンク日別15分単位"
    ),
    new layerParam(
      process.env.VUE_APP_DATE_RANGE_BASE_URL +
        process.env.VUE_APP_DATE_RANGE_ETC_DRM_LNK_1H_URL,
      "ETC2.0確定値DRMリンク日別時間帯別"
    ),
    new layerParam(
      process.env.VUE_APP_DATE_RANGE_BASE_URL +
        process.env.VUE_APP_DATE_RANGE_ETC_DRM_LNK_1MONTH_URL,
      "ETC2.0確定値DRMリンク月別時間帯別"
    ),
    new layerParam(
      process.env.VUE_APP_DATE_RANGE_BASE_URL +
        process.env.VUE_APP_DATE_RANGE_ETC_TRAFFIC_15M_URL,
      "ETC2.0確定値交通調査基本区間日別15分単位"
    ),
    new layerParam(
      process.env.VUE_APP_DATE_RANGE_BASE_URL +
        process.env.VUE_APP_DATE_RANGE_ETC_TRAFFIC_1H_URL,
      "ETC2.0確定値交通調査基本区間日別時間帯別"
    ),
    new layerParam(
      process.env.VUE_APP_DATE_RANGE_BASE_URL +
        process.env.VUE_APP_DATE_RANGE_ETC_TRAFFIC_1MONTH_URL,
      "ETC2.0確定値交通調査基本区間月別時間帯別"
    ),
  ];

  await Promise.all(
    layerParamArray.map(async (ele) => {
      return await fetch(ele.jsonUrl + "?token=" + randStr)
        .then((res) => {
          if (res?.status === 404) {
            return null;
          }
          return res?.json();
        })
        .then((res) => {
          const dateRangeData: dateRange = { mindate: null, maxdate: null };
          if (res.mindate) {
            dateRangeData.mindate = new Date(res.mindate);
          }
          if (ele.realTimeEndbuffer) {
            dateRangeData.maxdate = new Date();
            dateRangeData.maxdate.setMinutes(
              dateRangeData.maxdate.getMinutes() - ele.realTimeEndbuffer
            );
            dateRangeData.maxdate.setMinutes(0);
          } else {
            dateRangeData.maxdate = new Date(res.maxdate);
          }
          switch (res.jobname) {
            case "public-travos-q-8-2":
              dateRangesData.value.travosHistoryMeasured1HourQ82 =
                dateRangeData;
              break;
            case "public-travos-qa-8-2":
              dateRangesData.value.travosHistoryMeasured1HourQa82 =
                dateRangeData;
              break;
            case "etc-drm-15m":
              dateRangesData.value.etcDrmLinkDay15Minutes = dateRangeData;
              break;
            case "etc-drm-1h":
              dateRangesData.value.etcDrmLinkDay1Hour = dateRangeData;
              break;
            case "etc-drm-M":
              dateRangesData.value.etcDrmLinkMonth1Hour = dateRangeData;
              break;
            case "etc-traffic-15m":
              dateRangesData.value.etcBasicSectionDay15Minutes = dateRangeData;
              break;
            case "etc-traffic-1h":
              dateRangesData.value.etcBasicSectionDay1Hour = dateRangeData;
              break;
            case "etc-traffic-M":
              dateRangesData.value.etcBasicSectionMonth1Hour = dateRangeData;
              break;
          }
          return;
        })
        .catch((e) => {
          commonView.value._messageLogic.onOpenMessage(
            MessageDefine.E0002.getMessage([e])
          );
        });
    })
  );

  commonView.value._isDispLoading = false;
  if (commonView.value._messageObject.length === 0) {
    floatToggle(floatState.simpleSearch.key, true);
  }
};

/**
 * 初期処理
 */
onMounted(() => {
  if (
    !document.cookie?.split(";").some((ele) => {
      const content = ele?.split("=");
      return (
        content[0].trim() === "TermsCondeition" &&
        content[1].trim() === "Confirmed"
      );
    })
  ) {
    floatState.termsCondition.opened.value = true;
  } else {
    termsConfirmed.value = true;
  }

  setTimeout(() => {
    const sideMenu = document.getElementById("sideMenu");
    const toolTips = document.querySelectorAll(".side-menu-tooltip");

    const setTranslateTooltip = () => {
      const scrollX = window.scrollX;
      const scrollY = sideMenu.scrollTop + window.scrollY;
      toolTips.forEach((ele: any) => {
        ele.style.transform =
          "translate(-" + scrollX + "px,-" + scrollY + "px)";
      });
    };

    sideMenu.addEventListener("scroll", () => {
      setTranslateTooltip();
    });

    window.addEventListener("scroll", () => {
      setTranslateTooltip();
    });

    setTranslateTooltip();
  }, 10);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(WholeContent), { id: "wholeContent" }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_unref(HeaderContent), { id: "headerContent" }, null, 512), [
        [_vShow, isDispMenu.value]
      ]),
      _createVNode(_unref(MainContent), {
        isFullScreen: !isDispMenu.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DataViewerContent), { isDispMenu: isDispMenu.value }, {
            side: _withCtx(() => [
              _createVNode(_unref(SideMenu), {
                id: "sideMenu",
                class: "main-sidemenu"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(SideMenuItem), { narrow: "" }, {
                    text: _withCtx(() => [
                      _createVNode(_unref(CheckboxItem), {
                        label: "交通量データ",
                        subLabel: "(常時観測交通量)",
                        checked: sideMenuState.value.travos.value,
                        onUpdate: _cache[0] || (_cache[0] = 
                    (value) => {
                      sideMenuState.value.travos.value = value;
                      changeSideMenuStateTravos();
                    }
                  )
                      }, null, 8, ["checked"]),
                      _createVNode(_unref(Tooltip), {
                        direction: "text",
                        class: "side-menu-tooltip"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(QuestionIcon),
                            class: "top-level-icon-has-sub"
                          }, null, 8, _hoisted_1)
                        ]),
                        content: _withCtx(() => [
                          _createTextVNode(" 表示可能ズームレベル"),
                          _hoisted_2,
                          _createTextVNode("交通量データ：10~18 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(RadioItem), {
                            label: "過去データ",
                            name: "radioTravos",
                            checked: 
                      sideMenuState.value.travos.type === _unref(RADIO_TRAVOS_LIST).history
                    ,
                            disabled: !sideMenuState.value.travos.value,
                            onUpdate: _cache[1] || (_cache[1] = 
                      () => {
                        sideMenuState.value.travos.type = _unref(RADIO_TRAVOS_LIST).history;
                        changeSideMenuStateTravos();
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(HeadingBox), { title: "データ種別" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(RadioItem), {
                                            label: "1時間値\n                          (常時観測データ計測値)",
                                            name: "radioTravosHistory",
                                            checked: 
                            sideMenuState.value.travos.history.timeType ===
                            _unref(RADIO_TRAVOS_HISTORY_LIST).measured1Hour
                          ,
                                            disabled: 
                            !sideMenuState.value.travos.value ||
                            sideMenuState.value.travos.type !==
                              _unref(RADIO_TRAVOS_LIST).history
                          ,
                                            onUpdate: _cache[4] || (_cache[4] = 
                            () => {
                              sideMenuState.value.travos.history.timeType =
                                _unref(RADIO_TRAVOS_HISTORY_LIST).measured1Hour;
                              changeSideMenuStateTravos();
                            }
                          )
                                          }, {
                                            sub: _withCtx(() => [
                                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(FormUnitRow), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(FormUnitCell), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CheckboxItem), {
                                                            label: "常設トラカン\n                                    (様式Q-8-2)",
                                                            checked: 
                                      sideMenuState.value.travos.history.measured1Hour
                                        .q82
                                    ,
                                                            disabled: 
                                      !sideMenuState.value.travos.value ||
                                      sideMenuState.value.travos.type !==
                                        _unref(RADIO_TRAVOS_LIST).history ||
                                      sideMenuState.value.travos.history.timeType !==
                                        _unref(RADIO_TRAVOS_HISTORY_LIST).measured1Hour
                                    ,
                                                            onUpdate: _cache[2] || (_cache[2] = 
                                      (value) => {
                                        sideMenuState.value.travos.history.measured1Hour.q82 =
                                          value;
                                        changeSideMenuStateTravos();
                                      }
                                    )
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                                label: _withCtx(() => [
                                                                  _createElementVNode("a", {
                                                                    href: 
                                            LEGEND_FILE_PATH.TRAVOS_HISTORY_Q_8_2
                                          ,
                                                                    target: "_blank"
                                                                  }, [
                                                                    _createElementVNode("img", {
                                                                      src: _unref(DownloadIcon),
                                                                      class: "text-size-icon"
                                                                    }, null, 8, _hoisted_4)
                                                                  ], 8, _hoisted_3)
                                                                ]),
                                                                content: _withCtx(() => [
                                                                  _createTextVNode(" 凡例 ")
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["checked", "disabled"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_unref(FormUnitCell), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CheckboxItem), {
                                                            label: "CCTVトラカン\n                                    (様式QA-8-2)",
                                                            checked: 
                                      sideMenuState.value.travos.history.measured1Hour
                                        .qa82
                                    ,
                                                            disabled: 
                                      !sideMenuState.value.travos.value ||
                                      sideMenuState.value.travos.type !==
                                        _unref(RADIO_TRAVOS_LIST).history ||
                                      sideMenuState.value.travos.history.timeType !==
                                        _unref(RADIO_TRAVOS_HISTORY_LIST).measured1Hour
                                    ,
                                                            onUpdate: _cache[3] || (_cache[3] = 
                                      (value) => {
                                        sideMenuState.value.travos.history.measured1Hour.qa82 =
                                          value;
                                        changeSideMenuStateTravos();
                                      }
                                    )
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                                label: _withCtx(() => [
                                                                  _createElementVNode("a", {
                                                                    href: 
                                            LEGEND_FILE_PATH.TRAVOS_HISTORY_QA_8_2
                                          ,
                                                                    target: "_blank"
                                                                  }, [
                                                                    _createElementVNode("img", {
                                                                      src: _unref(DownloadIcon),
                                                                      class: "text-size-icon"
                                                                    }, null, 8, _hoisted_6)
                                                                  ], 8, _hoisted_5)
                                                                ]),
                                                                content: _withCtx(() => [
                                                                  _createTextVNode(" 凡例 ")
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["checked", "disabled"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), {
                            title: "道路種別",
                            allSelectButton: "",
                            disabled: 
                    !sideMenuState.value.travos.value ||
                    sideMenuState.value.travos.type !== _unref(RADIO_TRAVOS_LIST).history
                  ,
                            onSelectAll: _cache[7] || (_cache[7] = ($event: any) => (travosHistoryRoadTypeSelectAll(true))),
                            onResetAll: _cache[8] || (_cache[8] = ($event: any) => (travosHistoryRoadTypeSelectAll(false)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "一般国道",
                                            checked: sideMenuState.value.travos.history.generalHighway,
                                            disabled: 
                            !sideMenuState.value.travos.value ||
                            sideMenuState.value.travos.type !==
                              _unref(RADIO_TRAVOS_LIST).history
                          ,
                                            onUpdate: _cache[5] || (_cache[5] = 
                            (value) => {
                              sideMenuState.value.travos.history.generalHighway =
                                value;
                              changeSideMenuStateTravos();
                            }
                          )
                                          }, null, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "高速道路（国管理）",
                                            checked: sideMenuState.value.travos.history.expressway,
                                            disabled: 
                            !sideMenuState.value.travos.value ||
                            sideMenuState.value.travos.type !==
                              _unref(RADIO_TRAVOS_LIST).history
                          ,
                                            onUpdate: _cache[6] || (_cache[6] = 
                            (value) => {
                              sideMenuState.value.travos.history.expressway = value;
                              changeSideMenuStateTravos();
                            }
                          )
                                          }, null, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(RadioItem), {
                            label: "最新データ",
                            name: "radioTravos",
                            checked: 
                      sideMenuState.value.travos.type === _unref(RADIO_TRAVOS_LIST).realTime
                    ,
                            disabled: !sideMenuState.value.travos.value,
                            onUpdate: _cache[9] || (_cache[9] = 
                      () => {
                        sideMenuState.value.travos.type = _unref(RADIO_TRAVOS_LIST).realTime;
                        changeSideMenuStateTravos();
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(HeadingBox), { title: "データ種別" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(RadioItem), {
                                            label: "5分値",
                                            name: "radioTravosRealTime",
                                            checked: 
                            sideMenuState.value.travos.realTime.timeType ===
                            _unref(RADIO_TRAVOS_REALTIME_LIST).value5Minutes
                          ,
                                            disabled: 
                            !sideMenuState.value.travos.value ||
                            sideMenuState.value.travos.type !==
                              _unref(RADIO_TRAVOS_LIST).realTime
                          ,
                                            onUpdate: _cache[12] || (_cache[12] = 
                            () => {
                              sideMenuState.value.travos.realTime.timeType =
                                _unref(RADIO_TRAVOS_REALTIME_LIST).value5Minutes;
                              changeSideMenuStateTravos();
                            }
                          )
                                          }, {
                                            sub: _withCtx(() => [
                                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(FormUnitRow), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(FormUnitCell), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CheckboxItem), {
                                                            label: "常設トラカン(様式Q-8-1)",
                                                            checked: 
                                      sideMenuState.value.travos.realTime
                                        .value5Minutes.q81
                                    ,
                                                            disabled: 
                                      !sideMenuState.value.travos.value ||
                                      sideMenuState.value.travos.type !==
                                        _unref(RADIO_TRAVOS_LIST).realTime ||
                                      sideMenuState.value.travos.realTime.timeType !==
                                        _unref(RADIO_TRAVOS_REALTIME_LIST).value5Minutes
                                    ,
                                                            onUpdate: _cache[10] || (_cache[10] = 
                                      (value) => {
                                        sideMenuState.value.travos.realTime.value5Minutes.q81 =
                                          value;
                                        changeSideMenuStateTravos();
                                      }
                                    )
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                                label: _withCtx(() => [
                                                                  _createElementVNode("a", {
                                                                    href: 
                                            LEGEND_FILE_PATH.TRAVOS_REALTIME_Q_8_1
                                          ,
                                                                    target: "_blank"
                                                                  }, [
                                                                    _createElementVNode("img", {
                                                                      src: _unref(DownloadIcon),
                                                                      class: "text-size-icon"
                                                                    }, null, 8, _hoisted_8)
                                                                  ], 8, _hoisted_7)
                                                                ]),
                                                                content: _withCtx(() => [
                                                                  _createTextVNode(" 凡例 ")
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["checked", "disabled"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_unref(FormUnitCell), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CheckboxItem), {
                                                            label: "CCTVトラカン(様式QA-8-1)",
                                                            checked: 
                                      sideMenuState.value.travos.realTime
                                        .value5Minutes.qa81
                                    ,
                                                            disabled: 
                                      !sideMenuState.value.travos.value ||
                                      sideMenuState.value.travos.type !==
                                        _unref(RADIO_TRAVOS_LIST).realTime ||
                                      sideMenuState.value.travos.realTime.timeType !==
                                        _unref(RADIO_TRAVOS_REALTIME_LIST).value5Minutes
                                    ,
                                                            onUpdate: _cache[11] || (_cache[11] = 
                                      (value) => {
                                        sideMenuState.value.travos.realTime.value5Minutes.qa81 =
                                          value;
                                        changeSideMenuStateTravos();
                                      }
                                    )
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                                label: _withCtx(() => [
                                                                  _createElementVNode("a", {
                                                                    href: 
                                            LEGEND_FILE_PATH.TRAVOS_REALTIME_QA_8_1
                                          ,
                                                                    target: "_blank"
                                                                  }, [
                                                                    _createElementVNode("img", {
                                                                      src: _unref(DownloadIcon),
                                                                      class: "text-size-icon"
                                                                    }, null, 8, _hoisted_10)
                                                                  ], 8, _hoisted_9)
                                                                ]),
                                                                content: _withCtx(() => [
                                                                  _createTextVNode(" 凡例 ")
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["checked", "disabled"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(RadioItem), {
                                            label: "1時間値",
                                            name: "radioTravosRealTime",
                                            checked: 
                            sideMenuState.value.travos.realTime.timeType ===
                            _unref(RADIO_TRAVOS_REALTIME_LIST).value1Hour
                          ,
                                            disabled: 
                            !sideMenuState.value.travos.value ||
                            sideMenuState.value.travos.type !==
                              _unref(RADIO_TRAVOS_LIST).realTime
                          ,
                                            onUpdate: _cache[15] || (_cache[15] = 
                            () => {
                              sideMenuState.value.travos.realTime.timeType =
                                _unref(RADIO_TRAVOS_REALTIME_LIST).value1Hour;
                              changeSideMenuStateTravos();
                            }
                          )
                                          }, {
                                            sub: _withCtx(() => [
                                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(FormUnitRow), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(FormUnitCell), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CheckboxItem), {
                                                            label: "常設トラカン(様式Q-8-2)",
                                                            checked: 
                                      sideMenuState.value.travos.realTime.value1Hour
                                        .q82
                                    ,
                                                            disabled: 
                                      !sideMenuState.value.travos.value ||
                                      sideMenuState.value.travos.type !==
                                        _unref(RADIO_TRAVOS_LIST).realTime ||
                                      sideMenuState.value.travos.realTime.timeType !==
                                        _unref(RADIO_TRAVOS_REALTIME_LIST).value1Hour
                                    ,
                                                            onUpdate: _cache[13] || (_cache[13] = 
                                      (value) => {
                                        sideMenuState.value.travos.realTime.value1Hour.q82 =
                                          value;
                                        changeSideMenuStateTravos();
                                      }
                                    )
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                                label: _withCtx(() => [
                                                                  _createElementVNode("a", {
                                                                    href: 
                                            LEGEND_FILE_PATH.TRAVOS_REALTIME_Q_8_2
                                          ,
                                                                    target: "_blank"
                                                                  }, [
                                                                    _createElementVNode("img", {
                                                                      src: _unref(DownloadIcon),
                                                                      class: "text-size-icon"
                                                                    }, null, 8, _hoisted_12)
                                                                  ], 8, _hoisted_11)
                                                                ]),
                                                                content: _withCtx(() => [
                                                                  _createTextVNode(" 凡例 ")
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["checked", "disabled"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_unref(FormUnitCell), null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CheckboxItem), {
                                                            label: "CCTVトラカン(様式QA-8-2)",
                                                            checked: 
                                      sideMenuState.value.travos.realTime.value1Hour
                                        .qa82
                                    ,
                                                            disabled: 
                                      !sideMenuState.value.travos.value ||
                                      sideMenuState.value.travos.type !==
                                        _unref(RADIO_TRAVOS_LIST).realTime ||
                                      sideMenuState.value.travos.realTime.timeType !==
                                        _unref(RADIO_TRAVOS_REALTIME_LIST).value1Hour
                                    ,
                                                            onUpdate: _cache[14] || (_cache[14] = 
                                      (value) => {
                                        sideMenuState.value.travos.realTime.value1Hour.qa82 =
                                          value;
                                        changeSideMenuStateTravos();
                                      }
                                    )
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                                label: _withCtx(() => [
                                                                  _createElementVNode("a", {
                                                                    href: 
                                            LEGEND_FILE_PATH.TRAVOS_REALTIME_QA_8_2
                                          ,
                                                                    target: "_blank"
                                                                  }, [
                                                                    _createElementVNode("img", {
                                                                      src: _unref(DownloadIcon),
                                                                      class: "text-size-icon"
                                                                    }, null, 8, _hoisted_14)
                                                                  ], 8, _hoisted_13)
                                                                ]),
                                                                content: _withCtx(() => [
                                                                  _createTextVNode(" 凡例 ")
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["checked", "disabled"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), {
                            title: "道路種別",
                            allSelectButton: "",
                            disabled: 
                    !sideMenuState.value.travos.value ||
                    sideMenuState.value.travos.type !== _unref(RADIO_TRAVOS_LIST).realTime
                  ,
                            onSelectAll: _cache[18] || (_cache[18] = ($event: any) => (travosRealTimeRoadTypeSelectAll(true))),
                            onResetAll: _cache[19] || (_cache[19] = ($event: any) => (travosRealTimeRoadTypeSelectAll(false)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "一般国道",
                                            checked: 
                            sideMenuState.value.travos.realTime.generalHighway
                          ,
                                            disabled: 
                            !sideMenuState.value.travos.value ||
                            sideMenuState.value.travos.type !==
                              _unref(RADIO_TRAVOS_LIST).realTime
                          ,
                                            onUpdate: _cache[16] || (_cache[16] = 
                            (value) => {
                              sideMenuState.value.travos.realTime.generalHighway =
                                value;
                              changeSideMenuStateTravos();
                            }
                          )
                                          }, null, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "高速道路（国管理）",
                                            checked: sideMenuState.value.travos.realTime.expressway,
                                            disabled: 
                            !sideMenuState.value.travos.value ||
                            sideMenuState.value.travos.type !==
                              _unref(RADIO_TRAVOS_LIST).realTime
                          ,
                                            onUpdate: _cache[17] || (_cache[17] = 
                            (value) => {
                              sideMenuState.value.travos.realTime.expressway = value;
                              changeSideMenuStateTravos();
                            }
                          )
                                          }, null, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SideMenuItem), null, {
                    text: _withCtx(() => [
                      _createVNode(_unref(CheckboxItem), {
                        label: "ETC2.0",
                        checked: sideMenuState.value.etc.value,
                        onUpdate: _cache[20] || (_cache[20] = 
                    (value) => {
                      sideMenuState.value.etc.value = value;
                      changeSideMenuStateEtc();
                    }
                  )
                      }, null, 8, ["checked"]),
                      _createVNode(_unref(Tooltip), {
                        direction: "text",
                        class: "side-menu-tooltip"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(QuestionIcon),
                            class: "top-level-icon"
                          }, null, 8, _hoisted_15)
                        ]),
                        content: _withCtx(() => [
                          _createTextVNode(" 表示可能ズームレベル"),
                          _hoisted_16,
                          _createTextVNode("ETC2.0：12~18 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(HeadingBox), { title: "データ種別" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "DRMリンク",
                                        name: "radioEtcDataType",
                                        checked: 
                          sideMenuState.value.etc.dataType ===
                          _unref(RADIO_ETC_DATA_TYPE_LIST).drmLink
                        ,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[21] || (_cache[21] = 
                          () => {
                            sideMenuState.value.etc.dataType =
                              _unref(RADIO_ETC_DATA_TYPE_LIST).drmLink;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: LEGEND_FILE_PATH.ETC_DRM_LINK,
                                                target: "_blank"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: _unref(DownloadIcon),
                                                  class: "text-size-icon"
                                                }, null, 8, _hoisted_18)
                                              ], 8, _hoisted_17)
                                            ]),
                                            content: _withCtx(() => [
                                              _createTextVNode(" 凡例 ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "交通調査基本区間",
                                        name: "radioEtcDataType",
                                        checked: 
                          sideMenuState.value.etc.dataType ===
                          _unref(RADIO_ETC_DATA_TYPE_LIST).basicSection
                        ,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[22] || (_cache[22] = 
                          () => {
                            sideMenuState.value.etc.dataType =
                              _unref(RADIO_ETC_DATA_TYPE_LIST).basicSection;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: LEGEND_FILE_PATH.ETC_BASIC_SECTION,
                                                target: "_blank"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: _unref(DownloadIcon),
                                                  class: "text-size-icon"
                                                }, null, 8, _hoisted_20)
                                              ], 8, _hoisted_19)
                                            ]),
                                            content: _withCtx(() => [
                                              _createTextVNode(" 凡例 ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(HeadingBox), { title: "時間種別" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "日別15分単位",
                                        name: "radioEtcTimeType",
                                        checked: 
                          sideMenuState.value.etc.timeType ===
                          _unref(RADIO_ETC_TIME_TYPE_LIST).day15Minutes
                        ,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[23] || (_cache[23] = 
                          () => {
                            sideMenuState.value.etc.timeType =
                              _unref(RADIO_ETC_TIME_TYPE_LIST).day15Minutes;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "日別時間帯別",
                                        name: "radioEtcTimeType",
                                        checked: 
                          sideMenuState.value.etc.timeType ===
                          _unref(RADIO_ETC_TIME_TYPE_LIST).day1Hour
                        ,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[24] || (_cache[24] = 
                          () => {
                            sideMenuState.value.etc.timeType =
                              _unref(RADIO_ETC_TIME_TYPE_LIST).day1Hour;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "月別時間帯別",
                                        name: "radioEtcTimeType",
                                        checked: 
                          sideMenuState.value.etc.timeType ===
                          _unref(RADIO_ETC_TIME_TYPE_LIST).month1Hour
                        ,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[25] || (_cache[25] = 
                          () => {
                            sideMenuState.value.etc.timeType =
                              _unref(RADIO_ETC_TIME_TYPE_LIST).month1Hour;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(HeadingBox), { title: "休平日区分" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "平日",
                                        name: "radioEtcDayType",
                                        checked: 
                          sideMenuState.value.etc.dayType ===
                          _unref(RADIO_ETC_DAY_TYPE_LIST).weekday
                        ,
                                        disabled: 
                          !sideMenuState.value.etc.value ||
                          sideMenuState.value.etc.timeType !==
                            _unref(RADIO_ETC_TIME_TYPE_LIST).month1Hour
                        ,
                                        onUpdate: _cache[26] || (_cache[26] = 
                          () => {
                            sideMenuState.value.etc.dayType =
                              _unref(RADIO_ETC_DAY_TYPE_LIST).weekday;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "休日",
                                        name: "radioEtcDayType",
                                        checked: 
                          sideMenuState.value.etc.dayType ===
                          _unref(RADIO_ETC_DAY_TYPE_LIST).holiday
                        ,
                                        disabled: 
                          !sideMenuState.value.etc.value ||
                          sideMenuState.value.etc.timeType !==
                            _unref(RADIO_ETC_TIME_TYPE_LIST).month1Hour
                        ,
                                        onUpdate: _cache[27] || (_cache[27] = 
                          () => {
                            sideMenuState.value.etc.dayType =
                              _unref(RADIO_ETC_DAY_TYPE_LIST).holiday;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "全日",
                                        name: "radioEtcDayType",
                                        checked: 
                          sideMenuState.value.etc.dayType ===
                          _unref(RADIO_ETC_DAY_TYPE_LIST).allday
                        ,
                                        disabled: 
                          !sideMenuState.value.etc.value ||
                          sideMenuState.value.etc.timeType !==
                            _unref(RADIO_ETC_TIME_TYPE_LIST).month1Hour
                        ,
                                        onUpdate: _cache[28] || (_cache[28] = 
                          () => {
                            sideMenuState.value.etc.dayType =
                              _unref(RADIO_ETC_DAY_TYPE_LIST).allday;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(HeadingBox), {
                        title: "道路種別",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.etc.value,
                        onSelectAll: _cache[36] || (_cache[36] = ($event: any) => (etcRoadTypeSelectAll(true))),
                        onResetAll: _cache[37] || (_cache[37] = ($event: any) => (etcRoadTypeSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "高速自動車国道",
                                        checked: sideMenuState.value.etc.expressNationalHighway,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[29] || (_cache[29] = 
                          (value) => {
                            sideMenuState.value.etc.expressNationalHighway = value;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "都市高速道路",
                                        checked: sideMenuState.value.etc.urbanHighway,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[30] || (_cache[30] = 
                          (value) => {
                            sideMenuState.value.etc.urbanHighway = value;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "一般国道",
                                        checked: sideMenuState.value.etc.generalHighway,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[31] || (_cache[31] = 
                          (value) => {
                            sideMenuState.value.etc.generalHighway = value;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "主要地方道（都道府県道）",
                                        checked: sideMenuState.value.etc.mainLocalRoadPrefectures,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[32] || (_cache[32] = 
                          (value) => {
                            sideMenuState.value.etc.mainLocalRoadPrefectures = value;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "主要地方道（指定市道）",
                                        checked: sideMenuState.value.etc.mainLocalRoadDesinatedCity,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[33] || (_cache[33] = 
                          (value) => {
                            sideMenuState.value.etc.mainLocalRoadDesinatedCity =
                              value;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "一般都道府県道",
                                        checked: sideMenuState.value.etc.generalPrefectures,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[34] || (_cache[34] = 
                          (value) => {
                            sideMenuState.value.etc.generalPrefectures = value;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "指定市の一般市道",
                                        checked: sideMenuState.value.etc.generalDesinatedCity,
                                        disabled: !sideMenuState.value.etc.value,
                                        onUpdate: _cache[35] || (_cache[35] = 
                          (value) => {
                            sideMenuState.value.etc.generalDesinatedCity = value;
                            changeSideMenuStateEtc();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SideMenuItem), null, {
                    text: _withCtx(() => [
                      _createVNode(_unref(CheckboxItem), {
                        label: "OD",
                        checked: sideMenuState.value.od.value,
                        onUpdate: _cache[38] || (_cache[38] = 
                    (value) => {
                      sideMenuState.value.od.value = value;
                      changeSideMenuStateOd();
                    }
                  )
                      }, null, 8, ["checked"]),
                      _createVNode(_unref(Tooltip), {
                        direction: "text",
                        class: "side-menu-tooltip"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(QuestionIcon),
                            class: "top-level-icon"
                          }, null, 8, _hoisted_21)
                        ]),
                        content: _withCtx(() => [
                          _createTextVNode(" 表示可能ズームレベル"),
                          _hoisted_22,
                          _createTextVNode("OD：6~18 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(CheckboxItem), {
                            label: "OD交通量",
                            checked: sideMenuState.value.od.od.value,
                            disabled: !sideMenuState.value.od.value,
                            onUpdate: _cache[39] || (_cache[39] = 
                      (value) => {
                        sideMenuState.value.od.od.value = value;
                        if (!value) {
                          closeOdAttribute();
                        }
                        changeSideMenuStateOd('od');
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(HeadingBox), { title: "データ種別" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RADIO_OD_DATA_TYPE_LIST), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(RadioItem), {
                                              label: ele.text,
                                              name: "radioOdDataType",
                                              checked: sideMenuState.value.od.od.dataType === ele.value,
                                              disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.od.value
                          ,
                                              onUpdate: 
                            () => {
                              sideMenuState.value.od.od.dataType = ele.value;
                              changeSideMenuStateOd('od');
                              closeOdAttribute();
                            }
                          
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                  label: _withCtx(() => [
                                                    _createElementVNode("a", {
                                                      href: 
                                  LEGEND_FILE_PATH_LIST.od.od.find(
                                    (item) => item.value === ele.value
                                  )?.path
                                ,
                                                      target: "_blank"
                                                    }, [
                                                      _createElementVNode("img", {
                                                        src: _unref(DownloadIcon),
                                                        class: "text-size-icon"
                                                      }, null, 8, _hoisted_24)
                                                    ], 8, _hoisted_23)
                                                  ]),
                                                  content: _withCtx(() => [
                                                    _createTextVNode(" 凡例 ")
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), { title: "車種" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RADIO_OD_CAR_TYPE_LIST), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(RadioItem), {
                                              label: ele.text,
                                              name: "radioOdCarType",
                                              checked: sideMenuState.value.od.od.carType === ele.value,
                                              disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.od.value
                          ,
                                              onUpdate: 
                            () => {
                              sideMenuState.value.od.od.carType = ele.value;
                              changeSideMenuStateOd('od');
                              closeOdAttribute();
                            }
                          
                                            }, null, 8, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), { title: "年度" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RADIO_OD_YEAR_LIST), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(RadioItem), {
                                              label: ele.text,
                                              name: "radioOdYear",
                                              checked: sideMenuState.value.od.od.year === ele.value,
                                              disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.od.value
                          ,
                                              onUpdate: 
                            () => {
                              sideMenuState.value.od.od.year = ele.value;
                              changeSideMenuStateOd('od');
                            }
                          
                                            }, null, 8, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), { title: "制限" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), {
                                column: ['auto', 'auto'],
                                "gap-column": "10px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("上限値")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(InputField), {
                                            type: "number",
                                            max: 999999999,
                                            min: 0,
                                            value: sideMenuState.value.od.od.tmpLimitMax,
                                            disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.od.value ||
                            !isDisplayOdData.value
                          ,
                                            onUpdate: _cache[40] || (_cache[40] = 
                            (value) => {
                              sideMenuState.value.od.od.tmpLimitMax = value;
                            }
                          )
                                          }, null, 8, ["value", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(FormUnit), {
                                column: ['auto', 'auto'],
                                "gap-column": "10px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("下限値")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(InputField), {
                                            type: "number",
                                            max: 999999999,
                                            min: 0,
                                            value: sideMenuState.value.od.od.tmpLimitMin,
                                            disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.od.value ||
                            !isDisplayOdData.value
                          ,
                                            onUpdate: _cache[41] || (_cache[41] = 
                            (value) => {
                              sideMenuState.value.od.od.tmpLimitMin = value;
                            }
                          )
                                          }, null, 8, ["value", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(ButtonContainer), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ButtonItem), {
                                    disabled: 
                        !sideMenuState.value.od.value ||
                        !sideMenuState.value.od.od.value ||
                        !isDisplayOdData.value
                      ,
                                    onClick: confirmOdLimit
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("実行")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(CheckboxItem), {
                            label: "発生・集中交通量",
                            checked: sideMenuState.value.od.generation.value,
                            disabled: !sideMenuState.value.od.value,
                            onUpdate: _cache[42] || (_cache[42] = 
                      (value) => {
                        sideMenuState.value.od.generation.value = value;
                        changeSideMenuStateOd('generation');
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(HeadingBox), { title: "データ種別" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RADIO_OD_DATA_TYPE_LIST), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(RadioItem), {
                                              label: ele.text,
                                              name: "radioOdGenerationDataType",
                                              checked: 
                            sideMenuState.value.od.generation.dataType === ele.value
                          ,
                                              disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.generation.value
                          ,
                                              onUpdate: 
                            () => {
                              sideMenuState.value.od.generation.dataType = ele.value;
                              changeSideMenuStateOd('generation');
                            }
                          
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                  label: _withCtx(() => [
                                                    _createElementVNode("a", {
                                                      href: 
                                  LEGEND_FILE_PATH_LIST.od.generation.find(
                                    (item) => item.value === ele.value
                                  )?.path
                                ,
                                                      target: "_blank"
                                                    }, [
                                                      _createElementVNode("img", {
                                                        src: _unref(DownloadIcon),
                                                        class: "text-size-icon"
                                                      }, null, 8, _hoisted_26)
                                                    ], 8, _hoisted_25)
                                                  ]),
                                                  content: _withCtx(() => [
                                                    _createTextVNode(" 凡例 ")
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), { title: "車種" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RADIO_OD_CAR_TYPE_LIST), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(RadioItem), {
                                              label: ele.text,
                                              name: "radioOdGenerationCarType",
                                              checked: 
                            sideMenuState.value.od.generation.carType === ele.value
                          ,
                                              disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.generation.value
                          ,
                                              onUpdate: 
                            () => {
                              sideMenuState.value.od.generation.carType = ele.value;
                              changeSideMenuStateOd('generation');
                            }
                          
                                            }, null, 8, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), { title: "年度" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(RadioItem), {
                                            label: "令和3年度調査",
                                            name: "radioOdGenerationYear",
                                            checked: 
                            sideMenuState.value.od.generation.year ===
                            _unref(OD_YEAR_LIST).reiwa3
                          ,
                                            disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.generation.value
                          ,
                                            onUpdate: _cache[43] || (_cache[43] = 
                            () => {
                              sideMenuState.value.od.generation.year =
                                _unref(OD_YEAR_LIST).reiwa3;
                              changeSideMenuStateOd('generation');
                            }
                          )
                                          }, null, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), { title: "移動目的" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RADIO_OD_GENERATION_PURPOSE_LIST), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(RadioItem), {
                                              label: ele.text,
                                              name: "radioOdGenerationPurpose",
                                              checked: 
                            sideMenuState.value.od.generation.purpose === ele.value
                          ,
                                              disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.generation.value ||
                            sideMenuState.value.od.generation.dataType !==
                              _unref(OD_DATA_TYPE_LIST).prefectures ||
                            sideMenuState.value.od.generation.carType !==
                              _unref(OD_CAR_TYPE_LIST).total
                          ,
                                              onUpdate: 
                            () => {
                              sideMenuState.value.od.generation.purpose = ele.value;
                              changeSideMenuStateOd('generation');
                            }
                          
                                            }, null, 8, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), { title: "表示対象" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RADIO_OD_TARGET_LIST), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(RadioItem), {
                                              label: ele.text,
                                              name: "radioOdGenerationTarget",
                                              checked: 
                            sideMenuState.value.od.generation.target === ele.value
                          ,
                                              disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.generation.value
                          ,
                                              onUpdate: 
                            () => {
                              sideMenuState.value.od.generation.target = ele.value;
                              changeSideMenuStateOd('generation');
                            }
                          
                                            }, null, 8, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(CheckboxItem), {
                            label: "ゾーン位置表示",
                            checked: sideMenuState.value.od.zone.value,
                            disabled: !sideMenuState.value.od.value,
                            onUpdate: _cache[44] || (_cache[44] = 
                      (value) => {
                        sideMenuState.value.od.zone.value = value;
                        changeSideMenuStateOd('zone');
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(HeadingBox), { title: "データ種別" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RADIO_OD_DATA_TYPE_LIST), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(RadioItem), {
                                              label: ele.text,
                                              name: "radioOdZoneDataType",
                                              checked: 
                            sideMenuState.value.od.zone.dataType === ele.value
                          ,
                                              disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.zone.value
                          ,
                                              onUpdate: 
                            () => {
                              sideMenuState.value.od.zone.dataType = ele.value;
                              changeSideMenuStateOd('zone');
                            }
                          
                                            }, null, 8, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(HeadingBox), { title: "年度" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(RadioItem), {
                                            label: "令和3年度調査",
                                            name: "radioOdZoneYear",
                                            checked: 
                            sideMenuState.value.od.zone.year === _unref(OD_YEAR_LIST).reiwa3
                          ,
                                            disabled: 
                            !sideMenuState.value.od.value ||
                            !sideMenuState.value.od.zone.value
                          ,
                                            onUpdate: _cache[45] || (_cache[45] = 
                            () => {
                              sideMenuState.value.od.zone.year = _unref(OD_YEAR_LIST).reiwa3;
                              changeSideMenuStateOd('zone');
                            }
                          )
                                          }, null, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SideMenuItem), null, {
                    text: _withCtx(() => [
                      _createVNode(_unref(CheckboxItem), {
                        checked: sideMenuState.value.roadStructures.value,
                        onUpdate: _cache[46] || (_cache[46] = 
                    (value) => {
                      sideMenuState.value.roadStructures.value = value;
                      changeSideMenuStateRoadStructures();
                    }
                  ),
                        label: "点検DB"
                      }, null, 8, ["checked"]),
                      _createVNode(_unref(Tooltip), {
                        direction: "text",
                        class: "side-menu-tooltip"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(QuestionIcon),
                            class: "top-level-icon"
                          }, null, 8, _hoisted_27)
                        ]),
                        content: _withCtx(() => [
                          _createTextVNode(" 表示可能ズームレベル"),
                          _hoisted_28,
                          _createTextVNode("点検DB：12~18 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(HeadingBox), {
                        title: "施設区分",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.roadStructures.value,
                        onSelectAll: _cache[55] || (_cache[55] = ($event: any) => (roadStructuresFacilityTypeSelectAll(true))),
                        onResetAll: _cache[56] || (_cache[56] = ($event: any) => (roadStructuresFacilityTypeSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "道路橋",
                                        checked: 
                          sideMenuState.value.roadStructures.facilityType.bridges
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[47] || (_cache[47] = 
                          (value) => {
                            sideMenuState.value.roadStructures.facilityType.bridges =
                              value;
                            changeSideMenuStateRoadStructures(
                              _unref(LayerName).RoadStructuresBridges
                            );
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_29)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(BridgesLayerIcon) }, null, 8, _hoisted_30)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "トンネル",
                                        checked: 
                          sideMenuState.value.roadStructures.facilityType.tunnels
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[48] || (_cache[48] = 
                          (value) => {
                            sideMenuState.value.roadStructures.facilityType.tunnels =
                              value;
                            changeSideMenuStateRoadStructures(
                              _unref(LayerName).RoadStructuresTunnels
                            );
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_31)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(TunnelsLayerIcon) }, null, 8, _hoisted_32)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "シェッド",
                                        checked: 
                          sideMenuState.value.roadStructures.facilityType.sheds
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[49] || (_cache[49] = 
                          (value) => {
                            sideMenuState.value.roadStructures.facilityType.sheds =
                              value;
                            changeSideMenuStateRoadStructures(
                              _unref(LayerName).RoadStructuresSheds
                            );
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_33)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(ShedsLayerIcon) }, null, 8, _hoisted_34)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "大型カルバート",
                                        checked: 
                          sideMenuState.value.roadStructures.facilityType.culverts
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[50] || (_cache[50] = 
                          (value) => {
                            sideMenuState.value.roadStructures.facilityType.culverts =
                              value;
                            changeSideMenuStateRoadStructures(
                              _unref(LayerName).RoadStructuresCulverts
                            );
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_35)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(CulvertsLayerIcon) }, null, 8, _hoisted_36)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "横断歩道橋",
                                        checked: 
                          sideMenuState.value.roadStructures.facilityType
                            .pedestrianDecks
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[51] || (_cache[51] = 
                          (value) => {
                            sideMenuState.value.roadStructures.facilityType.pedestrianDecks =
                              value;
                            changeSideMenuStateRoadStructures(
                              _unref(LayerName).RoadStructuresPedestrianDecks
                            );
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_37)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(PedestrianDecksLayerIcon) }, null, 8, _hoisted_38)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "門型標識等",
                                        checked: 
                          sideMenuState.value.roadStructures.facilityType
                            .overheadSignages
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[52] || (_cache[52] = 
                          (value) => {
                            sideMenuState.value.roadStructures.facilityType.overheadSignages =
                              value;
                            changeSideMenuStateRoadStructures(
                              _unref(LayerName).RoadStructuresOverheadSignages
                            );
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_39)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(OverheadSignagesLayerIcon) }, null, 8, _hoisted_40)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "舗装",
                                        checked: 
                          sideMenuState.value.roadStructures.facilityType.pavements
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[53] || (_cache[53] = 
                          (value) => {
                            sideMenuState.value.roadStructures.facilityType.pavements =
                              value;
                            changeSideMenuStateRoadStructures(
                              _unref(LayerName).RoadStructuresPavements
                            );
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_41)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(PavementsLayerIcon) }, null, 8, _hoisted_42)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "特定道路土工構造物",
                                        checked: 
                          sideMenuState.value.roadStructures.facilityType.earthworks
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[54] || (_cache[54] = 
                          (value) => {
                            sideMenuState.value.roadStructures.facilityType.earthworks =
                              value;
                            changeSideMenuStateRoadStructures(
                              _unref(LayerName).RoadStructuresEarthworks
                            );
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_43)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(EarthworksLayerIcon) }, null, 8, _hoisted_44)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "管理者区分",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.roadStructures.value,
                        onSelectAll: _cache[63] || (_cache[63] = ($event: any) => (roadStructuresAdminTypeSelectAll(true))),
                        onResetAll: _cache[64] || (_cache[64] = ($event: any) => (roadStructuresAdminTypeSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "国",
                                        checked: 
                          sideMenuState.value.roadStructures.adminType.country.checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[57] || (_cache[57] = 
                          (value) => {
                            sideMenuState.value.roadStructures.adminType.country.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "都道府県",
                                        checked: 
                          sideMenuState.value.roadStructures.adminType.prefectures
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[58] || (_cache[58] = 
                          (value) => {
                            sideMenuState.value.roadStructures.adminType.prefectures.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "道路公社",
                                        checked: 
                          sideMenuState.value.roadStructures.adminType.roadPublic
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[59] || (_cache[59] = 
                          (value) => {
                            sideMenuState.value.roadStructures.adminType.roadPublic.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "政令市",
                                        checked: 
                          sideMenuState.value.roadStructures.adminType.orderedCity
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[60] || (_cache[60] = 
                          (value) => {
                            sideMenuState.value.roadStructures.adminType.orderedCity.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "市区町村",
                                        checked: 
                          sideMenuState.value.roadStructures.adminType.municipalities
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[61] || (_cache[61] = 
                          (value) => {
                            sideMenuState.value.roadStructures.adminType.municipalities.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "高速道路会社",
                                        checked: 
                          sideMenuState.value.roadStructures.adminType.expressway
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[62] || (_cache[62] = 
                          (value) => {
                            sideMenuState.value.roadStructures.adminType.expressway.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "健全性",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.roadStructures.value,
                        onSelectAll: _cache[70] || (_cache[70] = ($event: any) => (roadStructuresSoundnessSelectAll(true))),
                        onResetAll: _cache[71] || (_cache[71] = ($event: any) => (roadStructuresSoundnessSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "Ⅰ",
                                        checked: 
                          sideMenuState.value.roadStructures.soundness.one.checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[65] || (_cache[65] = 
                          (value) => {
                            sideMenuState.value.roadStructures.soundness.one.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "Ⅱ",
                                        checked: 
                          sideMenuState.value.roadStructures.soundness.two.checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[66] || (_cache[66] = 
                          (value) => {
                            sideMenuState.value.roadStructures.soundness.two.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "Ⅲ",
                                        checked: 
                          sideMenuState.value.roadStructures.soundness.three.checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[67] || (_cache[67] = 
                          (value) => {
                            sideMenuState.value.roadStructures.soundness.three.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "Ⅳ",
                                        checked: 
                          sideMenuState.value.roadStructures.soundness.four.checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[68] || (_cache[68] = 
                          (value) => {
                            sideMenuState.value.roadStructures.soundness.four.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "未点検",
                                        checked: 
                          sideMenuState.value.roadStructures.soundness.notInspected
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[69] || (_cache[69] = 
                          (value) => {
                            sideMenuState.value.roadStructures.soundness.notInspected.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "措置状況",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.roadStructures.value,
                        onSelectAll: _cache[77] || (_cache[77] = ($event: any) => (roadStructuresMeasuresSelectAll(true))),
                        onResetAll: _cache[78] || (_cache[78] = ($event: any) => (roadStructuresMeasuresSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "措置不要",
                                        checked: 
                          sideMenuState.value.roadStructures.measures.unnecessary
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[72] || (_cache[72] = 
                          (value) => {
                            sideMenuState.value.roadStructures.measures.unnecessary.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "措置未着手",
                                        checked: 
                          sideMenuState.value.roadStructures.measures.notStarted
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[73] || (_cache[73] = 
                          (value) => {
                            sideMenuState.value.roadStructures.measures.notStarted.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "措置着手済",
                                        checked: 
                          sideMenuState.value.roadStructures.measures.started.checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[74] || (_cache[74] = 
                          (value) => {
                            sideMenuState.value.roadStructures.measures.started.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "措置完了済",
                                        checked: 
                          sideMenuState.value.roadStructures.measures.completed
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[75] || (_cache[75] = 
                          (value) => {
                            sideMenuState.value.roadStructures.measures.completed.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "未点検",
                                        checked: 
                          sideMenuState.value.roadStructures.measures.notInspected
                            .checked
                        ,
                                        disabled: !sideMenuState.value.roadStructures.value,
                                        onUpdate: _cache[76] || (_cache[76] = 
                          (value) => {
                            sideMenuState.value.roadStructures.measures.notInspected.checked =
                              value;
                            changeSideMenuStateRoadStructures();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SideMenuItem), null, {
                    text: _withCtx(() => [
                      _createVNode(_unref(CheckboxItem), {
                        checked: sideMenuState.value.accidentHotspot.value,
                        onUpdate: _cache[79] || (_cache[79] = 
                    (value) => {
                      sideMenuState.value.accidentHotspot.value = value;
                      changeSideMenuStateAccidentHotspot();
                    }
                  ),
                        label: "交通事故統計情報"
                      }, null, 8, ["checked"]),
                      _createVNode(_unref(Tooltip), {
                        direction: "text",
                        class: "side-menu-tooltip"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(QuestionIcon),
                            class: "top-level-icon"
                          }, null, 8, _hoisted_45)
                        ]),
                        content: _withCtx(() => [
                          _createTextVNode(" 表示可能ズームレベル"),
                          _hoisted_46,
                          _createTextVNode("交通事故統計情報：15~18 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(HeadingBox), {
                        title: "年度",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.accidentHotspot.value,
                        onSelectAll: _cache[80] || (_cache[80] = ($event: any) => (accidentHotspotYearSelectAll(true))),
                        onResetAll: _cache[81] || (_cache[81] = ($event: any) => (accidentHotspotYearSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((sideMenuState.value.accidentHotspot.year as unknown as any[]), (ele) => {
                                    return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                      key: ele.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(CheckboxItem), {
                                          label: ele.label,
                                          checked: ele.checked,
                                          disabled: !sideMenuState.value.accidentHotspot.value,
                                          onUpdate: 
                          (value) => {
                            sideMenuState.value.accidentHotspot.year[
                              ele.value
                            ].checked = value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        
                                        }, null, 8, ["label", "checked", "disabled", "onUpdate"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  _createTextVNode(" 各年度のデータには、過去に発生した事故データが含まれる場合がります。 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "事故内容",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.accidentHotspot.value,
                        onSelectAll: _cache[84] || (_cache[84] = ($event: any) => (accidentHotspotAccidentDetailsSelectAll(true))),
                        onResetAll: _cache[85] || (_cache[85] = ($event: any) => (accidentHotspotAccidentDetailsSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "死亡",
                                        checked: 
                          sideMenuState.value.accidentHotspot.accidentDetails.death
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[82] || (_cache[82] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.accidentDetails.death.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_47)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(accidentHotspotDeathIcon) }, null, 8, _hoisted_48)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "負傷",
                                        checked: 
                          sideMenuState.value.accidentHotspot.accidentDetails.injury
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[83] || (_cache[83] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.accidentDetails.injury.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(QuestionIcon),
                                                class: "text-size-icon"
                                              }, null, 8, _hoisted_49)
                                            ]),
                                            content: _withCtx(() => [
                                              _createElementVNode("img", { src: _unref(accidentHotspotInjuryIcon) }, null, 8, _hoisted_50)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "事故類型",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.accidentHotspot.value,
                        onSelectAll: _cache[90] || (_cache[90] = ($event: any) => (accidentHotspotAccidentTypeSelectAll(true))),
                        onResetAll: _cache[91] || (_cache[91] = ($event: any) => (accidentHotspotAccidentTypeSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "人対車両",
                                        checked: 
                          sideMenuState.value.accidentHotspot.accidentType
                            .peopleVehicles.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[86] || (_cache[86] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.accidentType.peopleVehicles.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "車両相互",
                                        checked: 
                          sideMenuState.value.accidentHotspot.accidentType
                            .vehicleMutual.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[87] || (_cache[87] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.accidentType.vehicleMutual.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "車両単独",
                                        checked: 
                          sideMenuState.value.accidentHotspot.accidentType
                            .vehicleAlone.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[88] || (_cache[88] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.accidentType.vehicleAlone.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "列車",
                                        checked: 
                          sideMenuState.value.accidentHotspot.accidentType.train
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[89] || (_cache[89] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.accidentType.train.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "当事者種別\n                （当事者A）",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.accidentHotspot.value,
                        onSelectAll: _cache[97] || (_cache[97] = ($event: any) => (accidentHotspotPartyTypeASelectAll(true))),
                        onResetAll: _cache[98] || (_cache[98] = ($event: any) => (accidentHotspotPartyTypeASelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "歩行者",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeA.pedestrian
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[92] || (_cache[92] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeA.pedestrian.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "自転車",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeA.bicycle
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[93] || (_cache[93] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeA.bicycle.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "二輪車",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeA.motorcycle
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[94] || (_cache[94] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeA.motorcycle.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "自動車",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeA.car.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[95] || (_cache[95] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeA.car.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "その他",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeA.others
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[96] || (_cache[96] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeA.others.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "当事者種別\n                （当事者B）",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.accidentHotspot.value,
                        onSelectAll: _cache[104] || (_cache[104] = ($event: any) => (accidentHotspotPartyTypeBSelectAll(true))),
                        onResetAll: _cache[105] || (_cache[105] = ($event: any) => (accidentHotspotPartyTypeBSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "歩行者",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeB.pedestrian
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[99] || (_cache[99] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeB.pedestrian.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "自転車",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeB.bicycle
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[100] || (_cache[100] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeB.bicycle.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "二輪車",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeB.motorcycle
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[101] || (_cache[101] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeB.motorcycle.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "自動車",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeB.car.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[102] || (_cache[102] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeB.car.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "その他",
                                        checked: 
                          sideMenuState.value.accidentHotspot.partyTypeB.others
                            .checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[103] || (_cache[103] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.partyTypeB.others.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "年代別\n                （当事者A）",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.accidentHotspot.value,
                        onSelectAll: _cache[110] || (_cache[110] = ($event: any) => (accidentHotspotAgeASelectAll(true))),
                        onResetAll: _cache[111] || (_cache[111] = ($event: any) => (accidentHotspotAgeASelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "0～24歳",
                                        checked: 
                          sideMenuState.value.accidentHotspot.ageA.from0To24.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[106] || (_cache[106] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.ageA.from0To24.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "25～64歳",
                                        checked: 
                          sideMenuState.value.accidentHotspot.ageA.from25To64.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[107] || (_cache[107] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.ageA.from25To64.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "65歳～",
                                        checked: 
                          sideMenuState.value.accidentHotspot.ageA.over65.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[108] || (_cache[108] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.ageA.over65.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "不明",
                                        checked: 
                          sideMenuState.value.accidentHotspot.ageA.unknown.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[109] || (_cache[109] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.ageA.unknown.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_unref(HeadingBox), {
                        title: "年代別\n                （当事者B）",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.accidentHotspot.value,
                        onSelectAll: _cache[116] || (_cache[116] = ($event: any) => (accidentHotspotAgeBSelectAll(true))),
                        onResetAll: _cache[117] || (_cache[117] = ($event: any) => (accidentHotspotAgeBSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "0～24歳",
                                        checked: 
                          sideMenuState.value.accidentHotspot.ageB.from0To24.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[112] || (_cache[112] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.ageB.from0To24.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "25～64歳",
                                        checked: 
                          sideMenuState.value.accidentHotspot.ageB.from25To64.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[113] || (_cache[113] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.ageB.from25To64.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "65歳～",
                                        checked: 
                          sideMenuState.value.accidentHotspot.ageB.over65.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[114] || (_cache[114] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.ageB.over65.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "不明",
                                        checked: 
                          sideMenuState.value.accidentHotspot.ageB.unknown.checked
                        ,
                                        disabled: !sideMenuState.value.accidentHotspot.value,
                                        onUpdate: _cache[115] || (_cache[115] = 
                          (value) => {
                            sideMenuState.value.accidentHotspot.ageB.unknown.checked =
                              value;
                            changeSideMenuStateAccidentHotspot();
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SideMenuItem), null, {
                    text: _withCtx(() => [
                      _createVNode(_unref(CheckboxItem), {
                        label: "ロードキル",
                        checked: sideMenuState.value.roadkill.value,
                        onUpdate: _cache[118] || (_cache[118] = 
                    (value) => {
                      sideMenuState.value.roadkill.value = value;
                      changeSideMenuStateRoadkill();
                    }
                  )
                      }, null, 8, ["checked"]),
                      _createVNode(_unref(Tooltip), {
                        direction: "text",
                        class: "side-menu-tooltip"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(QuestionIcon),
                            class: "top-level-icon"
                          }, null, 8, _hoisted_51)
                        ]),
                        content: _withCtx(() => [
                          _createTextVNode(" 表示可能ズームレベル"),
                          _hoisted_52,
                          _createTextVNode("発生状況、対策実施状況：13~18"),
                          _hoisted_53,
                          _createTextVNode("ヒートマップ：10~18 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(CheckboxItem), {
                            label: "ロードキル発生状況",
                            checked: sideMenuState.value.roadkill.occurrences.value,
                            disabled: !sideMenuState.value.roadkill.value,
                            onUpdate: _cache[119] || (_cache[119] = 
                      (value) => {
                        sideMenuState.value.roadkill.occurrences.value = value;
                        changeSideMenuStateRoadkill('occurrences');
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(HeadingBox), {
                            title: "動物種",
                            allSelectButton: "",
                            noPadding: "",
                            disabled: 
                    !sideMenuState.value.roadkill.value ||
                    !sideMenuState.value.roadkill.occurrences.value
                  ,
                            onSelectAll: _cache[144] || (_cache[144] = ($event: any) => (
                    roadkillOccurrencesAnimalSelectAll(
                      sideMenuState.value.roadkill.occurrences.animal,
                      true
                    )
                  )),
                            onResetAll: _cache[145] || (_cache[145] = ($event: any) => (
                    roadkillOccurrencesAnimalSelectAll(
                      sideMenuState.value.roadkill.occurrences.animal,
                      false
                    )
                  ))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(SideMenuInnerItem), { alone: "" }, {
                                text: _withCtx(() => [
                                  _createVNode(_unref(CheckboxItem), {
                                    label: "タヌキ",
                                    checked: 
                          sideMenuState.value.roadkill.occurrences.animal.racoonDog
                            .checked
                        ,
                                    disabled: 
                          !sideMenuState.value.roadkill.value ||
                          !sideMenuState.value.roadkill.occurrences.value
                        ,
                                    onUpdate: _cache[120] || (_cache[120] = 
                          (value) => {
                            sideMenuState.value.roadkill.occurrences.animal.racoonDog.checked =
                              value;
                            changeSideMenuStateRoadkill('occurrences');
                          }
                        )
                                  }, null, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(SideMenuInnerItem), { alone: "" }, {
                                text: _withCtx(() => [
                                  _createVNode(_unref(CheckboxItem), {
                                    label: "犬・猫",
                                    checked: 
                          sideMenuState.value.roadkill.occurrences.animal.dogAndCat
                            .checked
                        ,
                                    disabled: 
                          !sideMenuState.value.roadkill.value ||
                          !sideMenuState.value.roadkill.occurrences.value
                        ,
                                    onUpdate: _cache[121] || (_cache[121] = 
                          (value) => {
                            sideMenuState.value.roadkill.occurrences.animal.dogAndCat.checked =
                              value;
                            changeSideMenuStateRoadkill('occurrences');
                          }
                        )
                                  }, null, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(SideMenuInnerItem), {
                                allSelectButton: "",
                                disabled: 
                      !sideMenuState.value.roadkill.value ||
                      !sideMenuState.value.roadkill.occurrences.value
                    ,
                                onSelectAll: _cache[130] || (_cache[130] = ($event: any) => (
                      roadkillOccurrencesAnimalSelectAll(
                        sideMenuState.value.roadkill.occurrences.animal.bird,
                        true
                      )
                    )),
                                onResetAll: _cache[131] || (_cache[131] = ($event: any) => (
                      roadkillOccurrencesAnimalSelectAll(
                        sideMenuState.value.roadkill.occurrences.animal.bird,
                        false
                      )
                    ))
                              }, {
                                text: _withCtx(() => [
                                  _createVNode(_unref(CheckboxItem), {
                                    label: "鳥類",
                                    checked: 
                          sideMenuState.value.roadkill.occurrences.animal.bird.checked
                        ,
                                    disabled: 
                          !sideMenuState.value.roadkill.value ||
                          !sideMenuState.value.roadkill.occurrences.value
                        ,
                                    onUpdate: _cache[122] || (_cache[122] = 
                          (value) => {
                            sideMenuState.value.roadkill.occurrences.animal.bird.checked =
                              value;
                            changeSideMenuStateRoadkill('occurrences');
                          }
                        )
                                  }, null, 8, ["checked", "disabled"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_unref(HeadingBox), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(FormUnitRow), null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "希少種以外",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.bird
                                  .notRare.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.bird
                                  .checked
                              ,
                                                    onUpdate: _cache[123] || (_cache[123] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.bird.notRare.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "ウズラ（希少種）",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.bird
                                  .quail.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.bird
                                  .checked
                              ,
                                                    onUpdate: _cache[124] || (_cache[124] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.bird.quail.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "オオワシ（希少種）",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.bird
                                  .stellersSeaEagle.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.bird
                                  .checked
                              ,
                                                    onUpdate: _cache[125] || (_cache[125] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.bird.stellersSeaEagle.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "オジロワシ（希少種）",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.bird
                                  .whiteTailedEagle.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.bird
                                  .checked
                              ,
                                                    onUpdate: _cache[126] || (_cache[126] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.bird.whiteTailedEagle.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "タンチョウ（希少種）",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.bird
                                  .redCrownedCrane.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.bird
                                  .checked
                              ,
                                                    onUpdate: _cache[127] || (_cache[127] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.bird.redCrownedCrane.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "ハヤブサ（希少種）",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.bird
                                  .peregrineFalcon.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.bird
                                  .checked
                              ,
                                                    onUpdate: _cache[128] || (_cache[128] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.bird.peregrineFalcon.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "ヤンバルクイナ（希少種）",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.bird
                                  .okinawaRail.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.bird
                                  .checked
                              ,
                                                    onUpdate: _cache[129] || (_cache[129] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.bird.okinawaRail.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_unref(SideMenuInnerItem), {
                                allSelectButton: "",
                                disabled: 
                      !sideMenuState.value.roadkill.value ||
                      !sideMenuState.value.roadkill.occurrences.value
                    ,
                                onSelectAll: _cache[135] || (_cache[135] = ($event: any) => (
                      roadkillOccurrencesAnimalSelectAll(
                        sideMenuState.value.roadkill.occurrences.animal.deer,
                        true
                      )
                    )),
                                onResetAll: _cache[136] || (_cache[136] = ($event: any) => (
                      roadkillOccurrencesAnimalSelectAll(
                        sideMenuState.value.roadkill.occurrences.animal.deer,
                        false
                      )
                    ))
                              }, {
                                text: _withCtx(() => [
                                  _createVNode(_unref(CheckboxItem), {
                                    label: "シカ",
                                    checked: 
                          sideMenuState.value.roadkill.occurrences.animal.deer.checked
                        ,
                                    disabled: 
                          !sideMenuState.value.roadkill.value ||
                          !sideMenuState.value.roadkill.occurrences.value
                        ,
                                    onUpdate: _cache[132] || (_cache[132] = 
                          (value) => {
                            sideMenuState.value.roadkill.occurrences.animal.deer.checked =
                              value;
                            changeSideMenuStateRoadkill('occurrences');
                          }
                        )
                                  }, null, 8, ["checked", "disabled"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_unref(HeadingBox), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(FormUnitRow), null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "希少種以外",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.deer
                                  .notRare.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.deer
                                  .checked
                              ,
                                                    onUpdate: _cache[133] || (_cache[133] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.deer.notRare.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "ニホンカモシカ（希少種）",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.deer
                                  .japaneseSerow.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal.deer
                                  .checked
                              ,
                                                    onUpdate: _cache[134] || (_cache[134] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.deer.japaneseSerow.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_unref(SideMenuInnerItem), { alone: "" }, {
                                text: _withCtx(() => [
                                  _createVNode(_unref(CheckboxItem), {
                                    label: "キツネ",
                                    checked: 
                          sideMenuState.value.roadkill.occurrences.animal.fox.checked
                        ,
                                    disabled: 
                          !sideMenuState.value.roadkill.value ||
                          !sideMenuState.value.roadkill.occurrences.value
                        ,
                                    onUpdate: _cache[137] || (_cache[137] = 
                          (value) => {
                            sideMenuState.value.roadkill.occurrences.animal.fox.checked =
                              value;
                            changeSideMenuStateRoadkill('occurrences');
                          }
                        )
                                  }, null, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(SideMenuInnerItem), { alone: "" }, {
                                text: _withCtx(() => [
                                  _createVNode(_unref(CheckboxItem), {
                                    label: "イノシシ",
                                    checked: 
                          sideMenuState.value.roadkill.occurrences.animal.wildBoar
                            .checked
                        ,
                                    disabled: 
                          !sideMenuState.value.roadkill.value ||
                          !sideMenuState.value.roadkill.occurrences.value
                        ,
                                    onUpdate: _cache[138] || (_cache[138] = 
                          (value) => {
                            sideMenuState.value.roadkill.occurrences.animal.wildBoar.checked =
                              value;
                            changeSideMenuStateRoadkill('occurrences');
                          }
                        )
                                  }, null, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(SideMenuInnerItem), {
                                allSelectButton: "",
                                disabled: 
                      !sideMenuState.value.roadkill.value ||
                      !sideMenuState.value.roadkill.occurrences.value
                    ,
                                onSelectAll: _cache[142] || (_cache[142] = ($event: any) => (
                      roadkillOccurrencesAnimalSelectAll(
                        sideMenuState.value.roadkill.occurrences.animal.others,
                        true
                      )
                    )),
                                onResetAll: _cache[143] || (_cache[143] = ($event: any) => (
                      roadkillOccurrencesAnimalSelectAll(
                        sideMenuState.value.roadkill.occurrences.animal.others,
                        false
                      )
                    ))
                              }, {
                                text: _withCtx(() => [
                                  _createVNode(_unref(CheckboxItem), {
                                    label: "その他",
                                    checked: 
                          sideMenuState.value.roadkill.occurrences.animal.others
                            .checked
                        ,
                                    disabled: 
                          !sideMenuState.value.roadkill.value ||
                          !sideMenuState.value.roadkill.occurrences.value
                        ,
                                    onUpdate: _cache[139] || (_cache[139] = 
                          (value) => {
                            sideMenuState.value.roadkill.occurrences.animal.others.checked =
                              value;
                            changeSideMenuStateRoadkill('occurrences');
                          }
                        )
                                  }, null, 8, ["checked", "disabled"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_unref(HeadingBox), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(FormUnitRow), null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "希少種以外",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.others
                                  .notRare.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal
                                  .others.checked
                              ,
                                                    onUpdate: _cache[140] || (_cache[140] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.others.notRare.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(FormUnitCell), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CheckboxItem), {
                                                    label: "ケナガネズミ（希少種）",
                                                    checked: 
                                sideMenuState.value.roadkill.occurrences.animal.others
                                  .ryukyuRat.checked
                              ,
                                                    disabled: 
                                !sideMenuState.value.roadkill.value ||
                                !sideMenuState.value.roadkill.occurrences.value ||
                                !sideMenuState.value.roadkill.occurrences.animal
                                  .others.checked
                              ,
                                                    onUpdate: _cache[141] || (_cache[141] = 
                                (value) => {
                                  sideMenuState.value.roadkill.occurrences.animal.others.ryukyuRat.checked =
                                    value;
                                  changeSideMenuStateRoadkill('occurrences');
                                }
                              )
                                                  }, null, 8, ["checked", "disabled"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_unref(HeadingBox), {
                            title: "発生年",
                            allSelectButton: "",
                            disabled: 
                    !sideMenuState.value.roadkill?.value ||
                    !sideMenuState.value.roadkill?.occurrences.value
                  ,
                            onSelectAll: _cache[146] || (_cache[146] = ($event: any) => (roadkillOccurrencesYearSelectAll(true))),
                            onResetAll: _cache[147] || (_cache[147] = ($event: any) => (roadkillOccurrencesYearSelectAll(false)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((sideMenuState.value.roadkill.occurrences.year as unknown as any[]), (ele) => {
                                        return (_openBlock(), _createBlock(_unref(FormUnitCell), {
                                          key: ele.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(CheckboxItem), {
                                              label: ele.label,
                                              checked: ele.checked,
                                              disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.occurrences.value
                          ,
                                              onUpdate: 
                            (value) => {
                              sideMenuState.value.roadkill.occurrences.year[
                                ele.value
                              ].checked = value;
                              changeSideMenuStateRoadkill('occurrences');
                            }
                          
                                            }, null, 8, ["label", "checked", "disabled", "onUpdate"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_unref(HeadingBox), {
                            title: "ヒートマップ",
                            disabled: 
                    !sideMenuState.value.roadkill.value ||
                    !sideMenuState.value.roadkill.occurrences.value
                  
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "ヒートマップ",
                                            checked: sideMenuState.value.roadkill.occurrences.heatmap,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.occurrences.value
                          ,
                                            onUpdate: _cache[148] || (_cache[148] = 
                            (value) => {
                              sideMenuState.value.roadkill.occurrences.heatmap =
                                value;
                              changeSideMenuStateRoadkill('occurrences');
                            }
                          )
                                          }, null, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(CheckboxItem), {
                            label: "対策実施状況",
                            checked: sideMenuState.value.roadkill.countermeasure.value,
                            disabled: !sideMenuState.value.roadkill.value,
                            onUpdate: _cache[149] || (_cache[149] = 
                      (value) => {
                        sideMenuState.value.roadkill.countermeasure.value = value;
                        changeSideMenuStateRoadkill('countermeasure');
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(HeadingBox), {
                            title: "対策分類",
                            allSelectButton: "",
                            disabled: 
                    !sideMenuState.value.roadkill.value ||
                    !sideMenuState.value.roadkill.countermeasure.value
                  ,
                            onSelectAll: _cache[158] || (_cache[158] = ($event: any) => (
                    roadkillCountermeasureClassificationSelectAll(true)
                  )),
                            onResetAll: _cache[159] || (_cache[159] = ($event: any) => (
                    roadkillCountermeasureClassificationSelectAll(false)
                  ))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "警戒標識",
                                            checked: 
                            sideMenuState.value.roadkill.countermeasure.classification
                              .warningSign.checked
                          ,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.countermeasure.value
                          ,
                                            onUpdate: _cache[150] || (_cache[150] = 
                            (value) => {
                              sideMenuState.value.roadkill.countermeasure.classification.warningSign.checked =
                                value;
                              changeSideMenuStateRoadkill('countermeasure');
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_54)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(loadkillWarningSignLayerIcon) }, null, 8, _hoisted_55)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "路面表示",
                                            checked: 
                            sideMenuState.value.roadkill.countermeasure.classification
                              .roadMarking.checked
                          ,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.countermeasure.value
                          ,
                                            onUpdate: _cache[151] || (_cache[151] = 
                            (value) => {
                              sideMenuState.value.roadkill.countermeasure.classification.roadMarking.checked =
                                value;
                              changeSideMenuStateRoadkill('countermeasure');
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_56)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(loadkillRoadMarkingLayerIcon) }, null, 8, _hoisted_57)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "道路横断施設",
                                            checked: 
                            sideMenuState.value.roadkill.countermeasure.classification
                              .underpass.checked
                          ,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.countermeasure.value
                          ,
                                            onUpdate: _cache[152] || (_cache[152] = 
                            (value) => {
                              sideMenuState.value.roadkill.countermeasure.classification.underpass.checked =
                                value;
                              changeSideMenuStateRoadkill('countermeasure');
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_58)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(loadkillUnderpassLayerIcon) }, null, 8, _hoisted_59)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "注意看板",
                                            checked: 
                            sideMenuState.value.roadkill.countermeasure.classification
                              .signboard.checked
                          ,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.countermeasure.value
                          ,
                                            onUpdate: _cache[153] || (_cache[153] = 
                            (value) => {
                              sideMenuState.value.roadkill.countermeasure.classification.signboard.checked =
                                value;
                              changeSideMenuStateRoadkill('countermeasure');
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_60)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(loadkillSignboardLayerIcon) }, null, 8, _hoisted_61)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "柵・フェンス",
                                            checked: 
                            sideMenuState.value.roadkill.countermeasure.classification
                              .fence.checked
                          ,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.countermeasure.value
                          ,
                                            onUpdate: _cache[154] || (_cache[154] = 
                            (value) => {
                              sideMenuState.value.roadkill.countermeasure.classification.fence.checked =
                                value;
                              changeSideMenuStateRoadkill('countermeasure');
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_62)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(loadkillFenceLayerIcon) }, null, 8, _hoisted_63)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "道路情報板",
                                            checked: 
                            sideMenuState.value.roadkill.countermeasure.classification
                              .informationBoard.checked
                          ,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.countermeasure.value
                          ,
                                            onUpdate: _cache[155] || (_cache[155] = 
                            (value) => {
                              sideMenuState.value.roadkill.countermeasure.classification.informationBoard.checked =
                                value;
                              changeSideMenuStateRoadkill('countermeasure');
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_64)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(loadkillInformationBoardLayerIcon) }, null, 8, _hoisted_65)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "移動式注意喚起看板",
                                            checked: 
                            sideMenuState.value.roadkill.countermeasure.classification
                              .portableSign.checked
                          ,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.countermeasure.value
                          ,
                                            onUpdate: _cache[156] || (_cache[156] = 
                            (value) => {
                              sideMenuState.value.roadkill.countermeasure.classification.portableSign.checked =
                                value;
                              changeSideMenuStateRoadkill('countermeasure');
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_66)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(loadkillPortableSignLayerIcon) }, null, 8, _hoisted_67)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "その他",
                                            checked: 
                            sideMenuState.value.roadkill.countermeasure.classification
                              .others.checked
                          ,
                                            disabled: 
                            !sideMenuState.value.roadkill.value ||
                            !sideMenuState.value.roadkill.countermeasure.value
                          ,
                                            onUpdate: _cache[157] || (_cache[157] = 
                            (value) => {
                              sideMenuState.value.roadkill.countermeasure.classification.others.checked =
                                value;
                              changeSideMenuStateRoadkill('countermeasure');
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_68)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(loadkillOtherLayerIcon) }, null, 8, _hoisted_69)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SideMenuItem), { narrow: "" }, {
                    text: _withCtx(() => [
                      _createVNode(_unref(CheckboxItem), {
                        label: "道路の指定・特定状況",
                        subLabel: "(主要渋滞箇所、重要物流道路、特殊車両データ)",
                        checked: sideMenuState.value.specificSituation.value,
                        onUpdate: _cache[160] || (_cache[160] = 
                    (value) => {
                      sideMenuState.value.specificSituation.value = value;
                      changeSideMenuStateSpecificSituation();
                    }
                  )
                      }, null, 8, ["checked"]),
                      _createVNode(_unref(Tooltip), {
                        direction: "text",
                        class: "side-menu-tooltip"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(QuestionIcon),
                            class: "top-level-icon-has-sub"
                          }, null, 8, _hoisted_70)
                        ]),
                        content: _withCtx(() => [
                          _createTextVNode(" 表示可能ズームレベル"),
                          _hoisted_71,
                          _createTextVNode("道路の指定・特定状況：10~18 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(SideMenuSubItem), { alone: true }, {
                        text: _withCtx(() => [
                          _createVNode(_unref(CheckboxItem), {
                            label: "主要渋滞箇所",
                            checked: 
                      sideMenuState.value.specificSituation.trafficCongestion.value
                    ,
                            disabled: !sideMenuState.value.specificSituation.value,
                            onUpdate: _cache[161] || (_cache[161] = 
                      (value) => {
                        sideMenuState.value.specificSituation.trafficCongestion.value =
                          value;
                        changeSideMenuStateSpecificSituation(
                          'trafficCongestion'
                        );
                      }
                    )
                          }, null, 8, ["checked", "disabled"]),
                          _createVNode(_unref(Tooltip), {
                            direction: "text",
                            class: "side-menu-tooltip"
                          }, {
                            label: _withCtx(() => [
                              _createElementVNode("img", {
                                src: _unref(QuestionIcon),
                                class: "text-size-icon-sub"
                              }, null, 8, _hoisted_72)
                            ]),
                            content: _withCtx(() => [
                              _createElementVNode("img", { src: _unref(majorTrafficCongestionLayerIcon) }, null, 8, _hoisted_73)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(CheckboxItem), {
                            label: "重要物流道路",
                            checked: 
                      sideMenuState.value.specificSituation.importantLogistics.value
                    ,
                            disabled: !sideMenuState.value.specificSituation.value,
                            onUpdate: _cache[162] || (_cache[162] = 
                      (value) => {
                        sideMenuState.value.specificSituation.importantLogistics.value =
                          value;
                        changeSideMenuStateSpecificSituation(
                          'importantLogistics'
                        );
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(ToggleButton), {
                            label: "太線表示",
                            checked: 
                    sideMenuState.value.specificSituation.importantLogistics.bold
                  ,
                            disabled: 
                    !sideMenuState.value.specificSituation.value ||
                    !sideMenuState.value.specificSituation.importantLogistics.value
                  ,
                            onToggleSwitch: _cache[163] || (_cache[163] = 
                    (value) => {
                      sideMenuState.value.specificSituation.importantLogistics.bold =
                        value;
                      changeSideMenuStateSpecificSituation(
                        'importantLogistics'
                      );
                    }
                  )
                          }, null, 8, ["checked", "disabled"]),
                          _createVNode(_unref(HeadingBox), {
                            title: "データ種別",
                            allSelectButton: "",
                            disabled: 
                    !sideMenuState.value.specificSituation.value ||
                    !sideMenuState.value.specificSituation.importantLogistics.value
                  ,
                            onSelectAll: _cache[166] || (_cache[166] = ($event: any) => (
                    specificSituationImportantLogisticsSelectAll(true)
                  )),
                            onResetAll: _cache[167] || (_cache[167] = ($event: any) => (
                    specificSituationImportantLogisticsSelectAll(false)
                  ))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "全国重要物流道路",
                                            checked: 
                            sideMenuState.value.specificSituation.importantLogistics
                              .dataType.logistics
                          ,
                                            disabled: 
                            !sideMenuState.value.specificSituation.value ||
                            !sideMenuState.value.specificSituation.importantLogistics
                              .value
                          ,
                                            onUpdate: _cache[164] || (_cache[164] = 
                            (value) => {
                              sideMenuState.value.specificSituation.importantLogistics.dataType.logistics =
                                value;
                              changeSideMenuStateSpecificSituation(
                                'importantLogistics'
                              );
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_74)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(RoadtypeLogisticsLayerIcon) }, null, 8, _hoisted_75)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "全国代替補完路",
                                            checked: 
                            sideMenuState.value.specificSituation.importantLogistics
                              .dataType.alternative
                          ,
                                            disabled: 
                            !sideMenuState.value.specificSituation.value ||
                            !sideMenuState.value.specificSituation.importantLogistics
                              .value
                          ,
                                            onUpdate: _cache[165] || (_cache[165] = 
                            (value) => {
                              sideMenuState.value.specificSituation.importantLogistics.dataType.alternative =
                                value;
                              changeSideMenuStateSpecificSituation(
                                'importantLogistics'
                              );
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_76)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(RoadtypeAlternativeLayerIcon) }, null, 8, _hoisted_77)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(SideMenuSubItem), null, {
                        text: _withCtx(() => [
                          _createVNode(_unref(CheckboxItem), {
                            label: "特殊車両データ",
                            checked: 
                      sideMenuState.value.specificSituation.specialVehicle.value
                    ,
                            disabled: !sideMenuState.value.specificSituation.value,
                            onUpdate: _cache[168] || (_cache[168] = 
                      (value) => {
                        sideMenuState.value.specificSituation.specialVehicle.value =
                          value;
                        changeSideMenuStateSpecificSituation('specialVehicle');
                      }
                    )
                          }, null, 8, ["checked", "disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(ToggleButton), {
                            label: "太線表示",
                            checked: sideMenuState.value.specificSituation.specialVehicle.bold,
                            disabled: 
                    !sideMenuState.value.specificSituation.value ||
                    !sideMenuState.value.specificSituation.specialVehicle.value
                  ,
                            onToggleSwitch: _cache[169] || (_cache[169] = 
                    (value) => {
                      sideMenuState.value.specificSituation.specialVehicle.bold =
                        value;
                      changeSideMenuStateSpecificSituation('specialVehicle');
                    }
                  )
                          }, null, 8, ["checked", "disabled"]),
                          _createVNode(_unref(HeadingBox), {
                            title: "データ種別",
                            allSelectButton: "",
                            disabled: 
                    !sideMenuState.value.specificSituation.value ||
                    !sideMenuState.value.specificSituation.specialVehicle.value
                  ,
                            onSelectAll: _cache[174] || (_cache[174] = ($event: any) => (specificSituationSpecialVehicleSelectAll(true))),
                            onResetAll: _cache[175] || (_cache[175] = ($event: any) => (specificSituationSpecialVehicleSelectAll(false)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitRow), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "重さ・高さ指定道路",
                                            checked: 
                            sideMenuState.value.specificSituation.specialVehicle
                              .dataType.weightHeightDesignated
                          ,
                                            disabled: 
                            !sideMenuState.value.specificSituation.value ||
                            !sideMenuState.value.specificSituation.specialVehicle
                              .value
                          ,
                                            onUpdate: _cache[170] || (_cache[170] = 
                            (value) => {
                              sideMenuState.value.specificSituation.specialVehicle.dataType.weightHeightDesignated =
                                value;
                              changeSideMenuStateSpecificSituation(
                                'specialVehicle'
                              );
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), {
                                                direction: "text",
                                                ballonLeft: "-1.8px"
                                              }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_78)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createTextVNode(" 画面右上の「凡例表示」"),
                                                  _hoisted_79,
                                                  _createTextVNode("よりご確認ください ")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "大型車誘導区間",
                                            checked: 
                            sideMenuState.value.specificSituation.specialVehicle
                              .dataType.vehicleGuidance
                          ,
                                            disabled: 
                            !sideMenuState.value.specificSituation.value ||
                            !sideMenuState.value.specificSituation.specialVehicle
                              .value
                          ,
                                            onUpdate: _cache[171] || (_cache[171] = 
                            (value) => {
                              sideMenuState.value.specificSituation.specialVehicle.dataType.vehicleGuidance =
                                value;
                              changeSideMenuStateSpecificSituation(
                                'specialVehicle'
                              );
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_80)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(specificSituationGuidanceIcon) }, null, 8, _hoisted_81)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "特車通行許可不要区間",
                                            checked: 
                            sideMenuState.value.specificSituation.specialVehicle
                              .dataType.exampt
                          ,
                                            disabled: 
                            !sideMenuState.value.specificSituation.value ||
                            !sideMenuState.value.specificSituation.specialVehicle
                              .value
                          ,
                                            onUpdate: _cache[172] || (_cache[172] = 
                            (value) => {
                              sideMenuState.value.specificSituation.specialVehicle.dataType.exampt =
                                value;
                              changeSideMenuStateSpecificSituation(
                                'specialVehicle'
                              );
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_82)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", { src: _unref(specificSituationExamptIcon) }, null, 8, _hoisted_83)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(FormUnitCell), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(CheckboxItem), {
                                            label: "特車通行許可不要区間\n                          （交差点）",
                                            checked: 
                            sideMenuState.value.specificSituation.specialVehicle
                              .dataType.examptXPoint
                          ,
                                            disabled: 
                            !sideMenuState.value.specificSituation.value ||
                            !sideMenuState.value.specificSituation.specialVehicle
                              .value
                          ,
                                            onUpdate: _cache[173] || (_cache[173] = 
                            (value) => {
                              sideMenuState.value.specificSituation.specialVehicle.dataType.examptXPoint =
                                value;
                              changeSideMenuStateSpecificSituation(
                                'specialVehicle'
                              );
                            }
                          )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Tooltip), { direction: "right" }, {
                                                label: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(QuestionIcon),
                                                    class: "text-size-icon"
                                                  }, null, 8, _hoisted_84)
                                                ]),
                                                content: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: _unref(specificSituationXpointIcon),
                                                    class: "specific-situation-xpoint-icon"
                                                  }, null, 8, _hoisted_85)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["checked", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SideMenuItem), null, {
                    text: _withCtx(() => [
                      _createVNode(_unref(CheckboxItem), {
                        label: "DRM-DB",
                        checked: sideMenuState.value.drm.value,
                        onUpdate: _cache[176] || (_cache[176] = 
                    (value) => {
                      sideMenuState.value.drm.value = value;
                      changeSideMenuStateDrm();
                    }
                  )
                      }, null, 8, ["checked"]),
                      _createVNode(_unref(Tooltip), {
                        direction: "text",
                        class: "side-menu-tooltip"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(QuestionIcon),
                            class: "top-level-icon"
                          }, null, 8, _hoisted_86)
                        ]),
                        content: _withCtx(() => [
                          _createTextVNode(" 表示可能ズームレベル"),
                          _hoisted_87,
                          _createTextVNode("ノード：17~18"),
                          _hoisted_88,
                          _createTextVNode(" リンク：9~18 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(HeadingBox), { title: "道路区分" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "基本道路",
                                        name: "radioDrmRoadType",
                                        checked: 
                          sideMenuState.value.drm.roadType ===
                          _unref(RADIO_DRM_ROAD_TYPE_LIST).basicRoad
                        ,
                                        disabled: !sideMenuState.value.drm.value,
                                        onUpdate: _cache[177] || (_cache[177] = 
                          () => {
                            sideMenuState.value.drm.roadType =
                              _unref(RADIO_DRM_ROAD_TYPE_LIST).basicRoad;
                            changeSideMenuStateDrm();
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: LEGEND_FILE_PATH.DRM_BASIC_ROAD,
                                                target: "_blank"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: _unref(DownloadIcon),
                                                  class: "text-size-icon"
                                                }, null, 8, _hoisted_90)
                                              ], 8, _hoisted_89)
                                            ]),
                                            content: _withCtx(() => [
                                              _createTextVNode(" 凡例 ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(RadioItem), {
                                        label: "全道路",
                                        name: "radioDrmRoadType",
                                        checked: 
                          sideMenuState.value.drm.roadType ===
                          _unref(RADIO_DRM_ROAD_TYPE_LIST).allRoad
                        ,
                                        disabled: !sideMenuState.value.drm.value,
                                        onUpdate: _cache[178] || (_cache[178] = 
                          () => {
                            sideMenuState.value.drm.roadType =
                              _unref(RADIO_DRM_ROAD_TYPE_LIST).allRoad;
                            changeSideMenuStateDrm();
                          }
                        )
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(Tooltip), { direction: "right" }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("a", {
                                                href: LEGEND_FILE_PATH.DRM_ALL_ROAD,
                                                target: "_blank"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: _unref(DownloadIcon),
                                                  class: "text-size-icon"
                                                }, null, 8, _hoisted_92)
                                              ], 8, _hoisted_91)
                                            ]),
                                            content: _withCtx(() => [
                                              _createTextVNode(" 凡例 ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(HeadingBox), {
                        title: "ノード/リンク",
                        allSelectButton: "",
                        disabled: !sideMenuState.value.drm.value,
                        onSelectAll: _cache[181] || (_cache[181] = ($event: any) => (drmNodeLinkSelectAll(true))),
                        onResetAll: _cache[182] || (_cache[182] = ($event: any) => (drmNodeLinkSelectAll(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnit), { modifires: "check-items-column" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormUnitRow), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "ノード",
                                        checked: sideMenuState.value.drm.node,
                                        disabled: !sideMenuState.value.drm.value,
                                        onUpdate: _cache[179] || (_cache[179] = 
                          (value) => {
                            sideMenuState.value.drm.node = value;
                            changeSideMenuStateDrm('node');
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(FormUnitCell), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(CheckboxItem), {
                                        label: "リンク",
                                        checked: sideMenuState.value.drm.link,
                                        disabled: !sideMenuState.value.drm.value,
                                        onUpdate: _cache[180] || (_cache[180] = 
                          (value) => {
                            sideMenuState.value.drm.link = value;
                            changeSideMenuStateDrm('link');
                          }
                        )
                                      }, null, 8, ["checked", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            main: _withCtx(() => [
              _withDirectives(_createVNode(_unref(ToolHeader), { id: "toolHeader" }, {
                menu: _withCtx(() => [
                  _createVNode(_unref(ToolHeaderButtonItem), {
                    onClick: _cache[183] || (_cache[183] = ($event: any) => (toggleDispMenu(false)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全画面表示")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ToolHeaderButtonItem), {
                    onClick: _cache[184] || (_cache[184] = ($event: any) => (floatToggle(floatState.calcArea.key, true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("計測")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ToolHeaderButtonItem), {
                    onClick: _cache[185] || (_cache[185] = ($event: any) => (floatToggle(floatState.capture.key, true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("画面"),
                      _hoisted_93,
                      _createTextVNode("キャプチャ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ToolHeaderButtonItem), {
                    onClick: _cache[186] || (_cache[186] = ($event: any) => (floatToggle(floatState.dataDownloadMenu.key, true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("データ"),
                      _hoisted_94,
                      _createTextVNode("ダウンロード")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ToolHeaderButtonItem), { onClick: importVectorFile }, {
                    default: _withCtx(() => [
                      _createTextVNode("ベクタ"),
                      _hoisted_95,
                      _createTextVNode("読み込み")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("input", {
                    id: "selectImportVetorFileBody",
                    type: "file",
                    accept: ".geojson",
                    onChange: selectImportVectorFile
                  }, null, 32),
                  _createVNode(_unref(ToolHeaderButtonItem), { onClick: clearVectorFile }, {
                    default: _withCtx(() => [
                      _createTextVNode("ベクタ"),
                      _hoisted_96,
                      _createTextVNode("クリア")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ToolHeaderButtonItem), { onClick: exportOptionFile }, {
                    default: _withCtx(() => [
                      _createTextVNode("設定"),
                      _hoisted_97,
                      _createTextVNode("出力")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ToolHeaderButtonItem), { onClick: importOptionFile }, {
                    default: _withCtx(() => [
                      _createTextVNode("設定"),
                      _hoisted_98,
                      _createTextVNode("読み込み")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ToolHeaderButtonItem), {
                    onClick: _cache[187] || (_cache[187] = ($event: any) => (floatToggle(floatState.simpleSearch.key, true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("簡易検索"),
                      _hoisted_99,
                      _createTextVNode("モード")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("input", {
                    id: "selectImportOptionFileBody",
                    type: "file",
                    accept: ".json",
                    onChange: selectImportOptionFile
                  }, null, 32)
                ]),
                search: _withCtx(() => [
                  _createVNode(_unref(ToolHeaderSearch), {
                    placeholder: "住所検索",
                    onClick: searchAddress,
                    onUpdate: _cache[188] || (_cache[188] = 
                  (value) => {
                    inputAddress.value = value;
                  }
                )
                  })
                ]),
                help: _withCtx(() => [
                  _createVNode(_unref(ToolHeaderButtonItem), { onClick: floatToggleLegendList }, {
                    default: _withCtx(() => [
                      _createTextVNode("凡例表示"),
                      _hoisted_100
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ToolHeaderButtonItem), {
                    onClick: _cache[189] || (_cache[189] = ($event: any) => (floatToggle(floatState.help.key, true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("マニュアル")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, isDispMenu.value]
              ]),
              _createElementVNode("div", _hoisted_101, [
                _hoisted_102,
                _createElementVNode("div", _hoisted_103, [
                  _withDirectives(_createElementVNode("button", {
                    class: "map-selector-button-closed",
                    onClick: _cache[190] || (_cache[190] = ($event: any) => (changeDispMapSelector(true)))
                  }, [
                    _createElementVNode("img", {
                      src: selectorImageSource.value,
                      class: "map-selector-button-image-closed"
                    }, null, 8, _hoisted_104)
                  ], 512), [
                    [_vShow, !isDispMapSelector.value]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_105, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["map-selector-button", {
                    'map-selector-button-selected':
                      visibleMapLayer.value === _unref(LayerName).StdMapTile,
                  }]),
                      onClick: _cache[191] || (_cache[191] = ($event: any) => (changeMap(_unref(LayerName).StdMapTile)))
                    }, [
                      _createElementVNode("img", {
                        src: _unref(stdMapIcon),
                        class: "map-selector-button-image"
                      }, null, 8, _hoisted_106)
                    ], 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["map-selector-button", {
                    'map-selector-button-selected':
                      visibleMapLayer.value === _unref(LayerName).PaleMapTile,
                  }]),
                      onClick: _cache[192] || (_cache[192] = ($event: any) => (changeMap(_unref(LayerName).PaleMapTile)))
                    }, [
                      _createElementVNode("img", {
                        src: _unref(paleMapIcon),
                        class: "map-selector-button-image"
                      }, null, 8, _hoisted_107)
                    ], 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["map-selector-button", {
                    'map-selector-button-selected':
                      visibleMapLayer.value === _unref(LayerName).BlankMapTile,
                  }]),
                      onClick: _cache[193] || (_cache[193] = ($event: any) => (changeMap(_unref(LayerName).BlankMapTile)))
                    }, [
                      _createElementVNode("img", {
                        src: _unref(blankMapIcon),
                        class: "map-selector-button-image"
                      }, null, 8, _hoisted_108)
                    ], 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["map-selector-button", {
                    'map-selector-button-selected':
                      visibleMapLayer.value === _unref(LayerName).SeamlessphotoMapTile,
                  }]),
                      onClick: _cache[194] || (_cache[194] = ($event: any) => (changeMap(_unref(LayerName).SeamlessphotoMapTile)))
                    }, [
                      _createElementVNode("img", {
                        src: _unref(seamlessPhotoMapIcon),
                        class: "map-selector-button-image"
                      }, null, 8, _hoisted_109)
                    ], 2)
                  ], 512), [
                    [_vShow, isDispMapSelector.value]
                  ])
                ])
              ]),
              _createVNode(_unref(ToolFooter), { id: "toolFooter" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormUnit), {
                    column: ['30px', '100px', '100px', '25px'],
                    "gap-column": "2px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FormUnitRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnitCell), null, {
                            default: _withCtx(() => [
                              _createTextVNode("座標")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormUnitCell), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(InputField), {
                                pattern: new RegExp(/^\d{0,2}?(\.\d{0,6})?$/),
                                maxlength: 9,
                                max: 90,
                                min: 0,
                                value: footerInfo.value.latitude,
                                onUpdate: _cache[195] || (_cache[195] = (value) => (footerInfo.value.latitude = value))
                              }, null, 8, ["pattern", "value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormUnitCell), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(InputField), {
                                pattern: new RegExp(/^\d{0,3}?(\.\d{0,6})?$/),
                                maxlength: 10,
                                max: 180,
                                min: 0,
                                value: footerInfo.value.longitude,
                                onUpdate: _cache[196] || (_cache[196] = (value) => (footerInfo.value.longitude = value))
                              }, null, 8, ["pattern", "value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormUnitCell), { align: "right" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ButtonSubmit), {
                                onClick: _cache[197] || (_cache[197] = ($event: any) => (
                      moveMapFooter(
                        Number(footerInfo.value.latitude),
                        Number(footerInfo.value.longitude)
                      )
                    ))
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnit), {
                    column: ['80px', '70px'],
                    "gap-column": "2px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FormUnitRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormUnitCell), null, {
                            default: _withCtx(() => [
                              _createTextVNode("ズームレベル")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormUnitCell), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(SelectItem), {
                                value: footerInfo.value.zoomLevel.toString(),
                                onUpdate: updateZoom
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(14, (ele) => {
                                    return _createElementVNode("option", {
                                      key: ele + 4,
                                      value: ele + 4
                                    }, _toDisplayString(ele + 4), 9, _hoisted_110)
                                  }), 64))
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["isDispMenu"])
        ]),
        _: 1
      }, 8, ["isFullScreen"]),
      (commonView.value._isDispLoading)
        ? (_openBlock(), _createBlock(_unref(OverlayContent), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(LoadingContent))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(ToolHeaderButtonDropdown), {
        isOpen: floatState.dataDownloadMenu.opened.value,
        dropdownItems: dataDownloadItems,
        onClose: _cache[198] || (_cache[198] = ($event: any) => (floatToggle(floatState.dataDownloadMenu.key, false)))
      }, null, 8, ["isOpen"]),
      _withDirectives(_createVNode(_unref(TimeController), {
        isOpen: 
        (sideMenuState.value.travos.value &&
          sideMenuState.value.travos.type === _unref(RADIO_TRAVOS_LIST).history) ||
        sideMenuState.value.etc.value
      ,
        "data-html2canvas-ignore": "",
        mapTime: mapTime.value,
        attributeTime: attributeTime.value,
        travosHistoryChecked: 
        sideMenuState.value.travos.value &&
        sideMenuState.value.travos.type == _unref(RADIO_TRAVOS_LIST).history
      ,
        travosHistoryTimeType: sideMenuState.value.travos.history.timeType,
        travosHistoryMeasured1HourQ82: 
        sideMenuState.value.travos.history.measured1Hour.q82
      ,
        travosHistoryMeasured1HourQa82: 
        sideMenuState.value.travos.history.measured1Hour.qa82
      ,
        etcChecked: sideMenuState.value.etc.value,
        etcDataType: sideMenuState.value.etc.dataType,
        etcTimeType: sideMenuState.value.etc.timeType,
        dateRangesData: dateRangesData.value,
        onUpdateMapTime: updateMapTime,
        onUpdateAttributeTime: updateAttributeTime,
        onExecuteUpdateTime: _cache[199] || (_cache[199] = ($event: any) => (executeUpdateTime(true))),
        onResetMapTime: _cache[200] || (_cache[200] = ($event: any) => (executeUpdateTime(false)))
      }, null, 8, ["isOpen", "mapTime", "attributeTime", "travosHistoryChecked", "travosHistoryTimeType", "travosHistoryMeasured1HourQ82", "travosHistoryMeasured1HourQa82", "etcChecked", "etcDataType", "etcTimeType", "dateRangesData"]), [
        [_vShow, 
        (sideMenuState.value.travos.value &&
          sideMenuState.value.travos.type === _unref(RADIO_TRAVOS_LIST).history) ||
        sideMenuState.value.etc.value
      ]
      ]),
      _withDirectives(_createVNode(_unref(RealTimePlayer), {
        isOpen: 
        sideMenuState.value.travos.value &&
        sideMenuState.value.travos.type === _unref(RADIO_TRAVOS_LIST).realTime
      ,
        text: { play: 'ON', stop: 'OFF' },
        isPlaying: isUpdateRealTimeData.value,
        "data-html2canvas-ignore": "",
        onPlayClick: startUpdateRealTimeData,
        onStopClick: endUpdateRealTimeData
      }, null, 8, ["isOpen", "isPlaying"]), [
        [_vShow, 
        sideMenuState.value.travos.value &&
        sideMenuState.value.travos.type === _unref(RADIO_TRAVOS_LIST).realTime &&
        termsConfirmed.value
      ]
      ]),
      _withDirectives(_createVNode(_unref(DispMenuButton), {
        title: "",
        "data-html2canvas-ignore": "",
        onDispMenu: _cache[201] || (_cache[201] = ($event: any) => (toggleDispMenu(true)))
      }, null, 512), [
        [_vShow, !isDispMenu.value]
      ]),
      _withDirectives(_createVNode(_unref(PopupWindow), {
        "data-html2canvas-ignore": "",
        title: "計測",
        width: "300px",
        windowId: "calcArea",
        isOpen: floatState.calcArea.opened.value,
        draggable: true,
        style: { top: '122px', left: '290px' },
        onCloseClick: _cache[202] || (_cache[202] = ($event: any) => (floatToggle(floatState.calcArea.key, false)))
      }, {
        "main-content": _withCtx(() => [
          _createVNode(CalcArea, {
            geoMap: _geoMap.value,
            commonView: commonView.value,
            isOpen: floatState.calcArea.opened.value,
            onEndCalcArea: startSelectedFeature
          }, null, 8, ["geoMap", "commonView", "isOpen"])
        ]),
        _: 1
      }, 8, ["isOpen"]), [
        [_vShow, floatState.calcArea.opened.value]
      ]),
      _withDirectives(_createVNode(_unref(PopupWindow), {
        "data-html2canvas-ignore": "",
        title: "画面キャプチャ",
        width: "300px",
        windowId: "captureDisplay",
        isOpen: floatState.capture.opened.value,
        draggable: true,
        style: { top: '122px', left: '290px' },
        onCloseClick: _cache[203] || (_cache[203] = ($event: any) => (floatToggle(floatState.capture.key, false)))
      }, {
        "main-content": _withCtx(() => [
          _createVNode(CaptureDisplay, {
            isOpen: floatState.capture.opened.value,
            onShowFrame: showCaptureFrame,
            onHideFrame: hideCaptureFrame
          }, null, 8, ["isOpen"])
        ]),
        _: 1
      }, 8, ["isOpen"]), [
        [_vShow, floatState.capture.opened.value]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributeList.value, (ele) => {
        return _withDirectives((_openBlock(), _createBlock(_unref(PopupWindow), {
          key: ele.fid,
          isOpen: true,
          width: ele.attributeConvert.getViewFormatData().width + 'px',
          title: ele.attributeConvert.getViewFormatData().title,
          windowId: 'normalAttribute' + ele.fid,
          style: { top: '122px', left: '290px' },
          draggable: true,
          avoidOverlap: true,
          onCloseClick: ($event: any) => (deleteAttribute(ele.fid, _unref(AttributeType).Normal))
        }, {
          "main-content": _withCtx(() => [
            _createVNode(NormalAttribute, {
              attributeConvert: ele.attributeConvert,
              buttonDisplay: !ele.fid.startsWith('GeoJSON-'),
              onExportCsv: exportCsv,
              onExportJson: exportJson,
              onMoveMapToGeometry: moveMapToGeometry
            }, null, 8, ["attributeConvert", "buttonDisplay"])
          ]),
          _: 2
        }, 1032, ["width", "title", "windowId", "onCloseClick"])), [
          [_vShow, ele.isOpen]
        ])
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(realtimeAttributeList.value, (ele) => {
        return _withDirectives((_openBlock(), _createBlock(_unref(PopupWindow), {
          key: ele.fid,
          isOpen: true,
          title: ele.searchDateAttributeConvert?.getViewFormatData()?.title,
          width: 
        ele.searchDateAttributeConvert?.getViewFormatData()?.width?.toString() +
        'px'
      ,
          style: { top: '122px', left: '290px' },
          windowId: 'realTimeAttribute' + ele.fid,
          draggable: true,
          avoidOverlap: true,
          onCloseClick: ($event: any) => (deleteAttribute(ele.fid, _unref(AttributeType).RealTime))
        }, {
          "main-content": _withCtx(() => [
            _createVNode(RealtimeAttribute, {
              searchDateAttributeConvert: ele.searchDateAttributeConvert,
              mapTimeCode: mapTimeCode.value,
              ref_for: true,
              ref: ele.refs,
              fid: ele.fid,
              onExportCsv: exportCsv,
              onExportJson: exportJson,
              onClickRealtimeHistory: openRealtimeHistoryFromAttribute,
              onMoveMapToGeometry: moveMapToGeometry
            }, null, 8, ["searchDateAttributeConvert", "mapTimeCode", "fid"])
          ]),
          _: 2
        }, 1032, ["title", "width", "windowId", "onCloseClick"])), [
          [_vShow, ele.isOpen]
        ])
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyAttributeList.value, (ele) => {
        return _withDirectives((_openBlock(), _createBlock(_unref(PopupWindow), {
          key: ele.fid,
          isOpen: true,
          title: ele.searchDateAttributeConvert.getViewFormatData().title,
          width: ele.searchDateAttributeConvert.getViewFormatData().width + 'px',
          style: { top: '122px', left: '290px' },
          windowId: 'historyAttribute' + ele.fid,
          draggable: true,
          avoidOverlap: true,
          onCloseClick: ($event: any) => (deleteAttribute(ele.fid, _unref(AttributeType).History))
        }, {
          "main-content": _withCtx(() => [
            _createVNode(HistoryAttribute, {
              searchDateAttributeConvert: ele.searchDateAttributeConvert,
              compareHistoryAttributeConvert: ele.compareHistoryAttributeConvert,
              mapTimeCode: mapTimeCode.value,
              attributeTimeCode: attributeTimeCode.value,
              ref_for: true,
              ref: ele.refs,
              onExportCsv: exportCsv,
              onExportJson: exportJson,
              onMoveMapToGeometry: moveMapToGeometry
            }, null, 8, ["searchDateAttributeConvert", "compareHistoryAttributeConvert", "mapTimeCode", "attributeTimeCode"])
          ]),
          _: 2
        }, 1032, ["title", "width", "windowId", "onCloseClick"])), [
          [_vShow, ele.isOpen]
        ])
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageAttributeList.value, (ele) => {
        return _withDirectives((_openBlock(), _createBlock(_unref(PopupWindow), {
          key: ele.fid,
          isOpen: true,
          title: ele.attributeConvert.getViewFormatData().title,
          width: ele.attributeConvert.getViewFormatData().width + 'px',
          titleMaxLength: ele.attributeConvert.getViewFormatData().titleMaxLength,
          style: { top: '122px', left: '290px' },
          windowId: 'imageAttribute' + ele.fid,
          draggable: true,
          onCloseClick: ($event: any) => (deleteAttribute(ele.fid, _unref(AttributeType).Image))
        }, {
          "main-content": _withCtx(() => [
            _createVNode(ImageAttribute, {
              attributeConvert: ele.attributeConvert,
              onExportCsv: exportCsv,
              onExportJson: exportJson,
              onMoveMapToGeometry: moveMapToGeometry
            }, null, 8, ["attributeConvert"])
          ]),
          _: 2
        }, 1032, ["title", "width", "titleMaxLength", "windowId", "onCloseClick"])), [
          [_vShow, ele.isOpen]
        ])
      }), 128)),
      (
        realTimeTrafficData.value?.realTimeTrafficConvert &&
        floatState.realTimeTraffic.opened.value
      )
        ? (_openBlock(), _createBlock(_unref(PopupWindow), {
            key: 1,
            width: '1020px',
            style: { top: '122px', left: '290px' },
            draggable: "",
            isOpen: 
        realTimeTrafficData.value?.realTimeTrafficConvert &&
        floatState.realTimeTraffic.opened.value
      ,
            title: realTimeTrafficData.value?.title,
            noPadding: true,
            windowId: "realTimeTraffic",
            onCloseClick: deleteRealTimeTrafficData,
            attributeConvert: realTimeTrafficData.value?.realTimeTrafficConvert
          }, {
            "main-content": _withCtx(() => [
              (
            realTimeTrafficData.value?.realTimeTrafficConvert &&
            floatState.realTimeTraffic.opened.value
          )
                ? (_openBlock(), _createBlock(RealTimeTraffic, {
                    key: 0,
                    realTimeTrafficConvert: realTimeTrafficData.value.realTimeTrafficConvert,
                    timeCode: realTimeTimeCodeTraffic.value,
                    onChangeTitle: changeRealTimeTrafficTitle
                  }, null, 8, ["realTimeTrafficConvert", "timeCode"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["isOpen", "title", "attributeConvert"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_unref(PopupWindow), {
        "data-html2canvas-ignore": "",
        title: "マニュアル",
        x: 0,
        y: 10,
        width: "692px",
        draggable: "",
        isOpen: floatState.help.opened.value,
        style: { top: '122px', left: '290px' },
        windowId: "help",
        onCloseClick: _cache[204] || (_cache[204] = ($event: any) => (floatToggle(floatState.help.key, false)))
      }, {
        "main-content": _withCtx(() => [
          _createVNode(_unref(HelpTable), {
            isOpen: floatState.help.opened.value,
            files: helpFiles.value
          }, null, 8, ["isOpen", "files"])
        ]),
        _: 1
      }, 8, ["isOpen"]), [
        [_vShow, floatState.help.opened.value]
      ]),
      _withDirectives(_createVNode(_unref(PopupWindow), {
        "data-html2canvas-ignore": "",
        title: "住所",
        x: 0,
        y: 10,
        width: "456px",
        draggable: "",
        noPadding: true,
        isOpen: floatState.address.opened.value,
        style: { top: '122px', left: '290px' },
        windowId: "addressTable",
        onCloseClick: _cache[206] || (_cache[206] = ($event: any) => (floatToggle(floatState.address.key, false)))
      }, {
        "main-content": _withCtx(() => [
          _createVNode(_unref(AddressTable), {
            isOpen: floatState.address.opened.value,
            addressList: addressList.value,
            onMoveMap: _cache[205] || (_cache[205] = (address)=>{
                  moveMap(address.latitude,address.longitude);
                })
          }, null, 8, ["isOpen", "addressList"])
        ]),
        _: 1
      }, 8, ["isOpen"]), [
        [_vShow, floatState.address.opened.value]
      ]),
      _withDirectives(_createVNode(_unref(PopupWindow), {
        "data-html2canvas-ignore": "",
        draggable: "",
        style: { top: '122px', left: '290px' },
        width: '250px',
        isOpen: floatState.exportArea.opened.value,
        title: "市区町村属性出力",
        windowId: "exportArea",
        onCloseClick: _cache[207] || (_cache[207] = ($event: any) => (floatToggle(floatState.exportArea.key, false)))
      }, {
        "main-content": _withCtx(() => [
          _createVNode(ExportArea, {
            isOpen: floatState.exportArea.opened.value,
            geoMap: _geoMap.value,
            commonView: commonView.value,
            zoomLevel: footerInfo.value.zoomLevel,
            sideMenuState: sideMenuState.value,
            onEndExportArea: startSelectedFeature
          }, null, 8, ["isOpen", "geoMap", "commonView", "zoomLevel", "sideMenuState"])
        ]),
        _: 1
      }, 8, ["isOpen"]), [
        [_vShow, floatState.exportArea.opened.value]
      ]),
      _withDirectives(_createVNode(_unref(PopupWindow), {
        "data-html2canvas-ignore": "",
        draggable: "",
        style: { top: '122px', left: '290px' },
        width: '250px',
        isOpen: floatState.exportBulk.opened.value,
        title: "一括出力",
        windowId: "exportArea",
        onCloseClick: _cache[208] || (_cache[208] = ($event: any) => (floatToggle(floatState.exportBulk.key, false)))
      }, {
        "main-content": _withCtx(() => [
          _createVNode(ExportBulk, {
            isOpen: floatState.exportBulk.opened.value,
            geoMap: _geoMap.value,
            commonView: commonView.value,
            onExportBulk: exportBulk
          }, null, 8, ["isOpen", "geoMap", "commonView"])
        ]),
        _: 1
      }, 8, ["isOpen"]), [
        [_vShow, floatState.exportBulk.opened.value]
      ]),
      (legendListDefaultLeft.value)
        ? _withDirectives((_openBlock(), _createBlock(_unref(PopupWindow), {
            key: 2,
            title: "凡例",
            width: "335px",
            windowId: "legendList",
            isOpen: floatState.legendList.opened.value,
            draggable: true,
            style: _normalizeStyle({ top: '112px', left: legendListDefaultLeft.value + 'px' }),
            onCloseClick: _cache[209] || (_cache[209] = ($event: any) => (floatToggle(floatState.legendList.key, false)))
          }, {
            "main-content": _withCtx(() => [
              _createVNode(LegendList)
            ]),
            _: 1
          }, 8, ["isOpen", "style"])), [
            [_vShow, floatState.legendList.opened.value]
          ])
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commonView.value._messageObject, (ele, index) => {
        return (_openBlock(), _createBlock(MessageDialog, {
          key: ele,
          commonView: ele,
          isDispOverlay: true,
          title: messageTitle.value,
          onClose: ($event: any) => (closeMessage(index))
        }, null, 8, ["commonView", "title", "onClose"]))
      }), 128)),
      _createVNode(SimpleSearch, {
        isOpen: floatState.simpleSearch.opened.value,
        isFirstTime: simpleSearchFirstFlg.value,
        onSubmitSimpleSearch: setOption,
        onClose: closeSimpleSearch
      }, null, 8, ["isOpen", "isFirstTime"]),
      (floatState.termsCondition.opened.value)
        ? (_openBlock(), _createBlock(TermsCondition, {
            key: 3,
            onClose: confirmTermsCondition
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})